<template>
  <div class="home_container">
    <div
      class="box_shadow"
      @touchmove.prevent
      @mousewheel.prevent
      v-if="showShadow"
      @click.prevent="hideMenu"
    >
      <div class="toolTips" :class="{ activeTool: ishowTab }">
        <span class="triangle"></span>
        <div class="tool_info">
          <div class="item" @click.stop="getTask('1')">
            <img src="../../assets/image/ic_sm@3x.png" />
            <p>扫一扫</p>
          </div>
          <div
            class="item"
            @click="getTask('2')"
            v-if="
              integritylimitState.integrityProviLeader ||
              integritylimitState.integrityCityLeader ||
              integritylimitState.integrityCountyLeader ||
              integritylimitState.integrityCityGeneral ||
              integritylimitState.integrityCountyGeneral
            "
          >
            <img src="../../assets/image/ic_qykf@3x.png" />
            <p>企业扣分</p>
          </div>
          <div
            class="item"
            @click="getTask('3')"
            v-if="limitState.guideLeader || limitState.guideHandler"
          >
            <img src="../../assets/image/ic_dypf@3x.png" />
            <p>导游评分</p>
          </div>
          <div
              class="item"
              @click="getTask('4')"
              v-if="limitState.travelAgencyLeader || limitState.travelAgencyHandler"
          >
            <img src="../../assets/image/ic-shop-point@3x.png" />
            <p>位置标记</p>
          </div>
        </div>
      </div>
    </div>
    <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
      <div class="container" id="bukal" style="overflow: auto">
        <div class="scan" @click="scanBtn">
          <img class="scan_img" src="../../assets/image/ic_xlcd@3x.png" />
        </div>
        <div class="head" :style="{ height: headHeight }">
          <img class="tower" src="@/assets/index/tower.png" />
          <div class="head-user">
            <div class="head-user-name">{{ headName }}{{ headTime }}</div>
            <div class="head-user-desc" v-if="organize !== ''">{{ organize }}</div>
          </div>
        </div>
        <card class="con-box">
          <!-- <card class="con-box" v-if="getAuth"> -->
          <!-- 投诉所属 -->
          <div
            class="items-box"
            @click="
              !(
                complainlimitState.complaintLeader ||
                complainlimitState.complaintHandlder
              )
                ? showTip()
                : openWindow(
                    '投诉',
                    complainlimitState.complaintLeader
                      ? '/complaint/leader'
                      : '/complaint/worker'
                  )
            "
          >
            <div class="notice-contain">
              <img
                class="items-img"
                src="@/assets/index/ic_toushu.png"
                alt
                v-if="
                  complainlimitState.complaintLeader ||
                  complainlimitState.complaintHandlder
                "
              />
              <img class="items-img" src="@/assets/index/ic_tousu_no_power.png" alt v-else />
            </div>
            <p
              class="items-text"
              :class="
                !(
                  complainlimitState.complaintLeader ||
                  complainlimitState.complaintHandlder
                )
                  ? 'no-power'
                  : ''
              "
            >投诉</p>
          </div>
          <!-- 退货 -->
           <div
            class="items-box"
            @click="
              !(refundlimitState.refundHandler || refundlimitState.refundLeader) || isCompanyHandler
                ? showTip()
                : openWindow('退货','/refund/newRefund')
            "
          >
            <div class="notice-contain">
              <img
                class="items-img"
                src="@/assets/index/ic_tuihuo.png"
                alt
                v-if="
                  (refundlimitState.refundHandler ||
                  refundlimitState.refundLeader) && !isCompanyHandler
                "
              />
              <img class="items-img" src="@/assets/index/ic_tuihuo_no_power.png" alt v-else />
            </div>
            <p
              class="items-text"
              :class="
                !(
                  refundlimitState.refundHandler ||
                  refundlimitState.refundLeader
                ) || isCompanyHandler
                  ? 'no-power'
                  : ''
              "
            >退货</p>
          </div>


          <div
            class="items-box"
            @click="showTip"
            v-if="
              !(
                integritylimitState.integrityProviLeader ||
                integritylimitState.integrityCityLeader ||
                integritylimitState.integrityCountyLeader ||
                integritylimitState.integrityCityGeneral ||
                integritylimitState.integrityCountyGeneral
              )
            "
          >
            <div class="notice-contain">
              <img class="items-img" src="@/assets/index/ic_chengxin_no_power.png" alt />
            </div>
            <p class="items-text no-power">诚信</p>
          </div>
          <div class="items-box" @click="openWindow('诚信', '/integrity/index')" v-else>
            <div class="notice-contain">
              <img class="items-img" src="@/assets/index/ic_chengxin.png" alt />
            </div>
            <p class="items-text">诚信</p>
          </div>
          <div
            class="items-box"
            @click="
              !(limitState.travelAgencyHandler || limitState.travelAgencyLeader)
                ? showTip()
                : openWindow('旅行社', '/travelAgency/home')
            "
          >
            <!-- <div class="items-box" @click="!(limitState.travelAgencyHandler || limitState.travelAgencyLeader)?showTip():$router.push('/travelAgency/home')"> -->
            <div class="notice-contain">
              <img
                class="items-img"
                src="@/assets/index/ic_lvxingshe.png"
                alt
                v-if="
                  limitState.travelAgencyHandler ||
                  limitState.travelAgencyLeader
                "
              />
              <img class="items-img" src="@/assets/index/ic_lxshe_no_power.png" alt v-else />
            </div>
            <p
              class="items-text"
              :class="
                !(
                  limitState.travelAgencyHandler ||
                  limitState.travelAgencyLeader
                )
                  ? 'no-power'
                  : ''
              "
            >旅行社</p>
          </div>
          <div
            class="items-box"
            @click="
              !(limitState.guideLeader || limitState.guideHandler)
                ? showTip()
                : openWindow('导游', '/guide/index')
            "
          >
            <div class="notice-contain">
              <img
                class="items-img"
                src="@/assets/index/ic_daoyou.png"
                alt
                v-if="limitState.guideLeader || limitState.guideHandler"
              />
              <img class="items-img" src="@/assets/index/ic_daoyou_no_power.png" alt v-else />
            </div>
            <p
              class="items-text"
              :class="
                !(limitState.guideLeader || limitState.guideHandler)
                  ? 'no-power'
                  : ''
              "
            >导游</p>
          </div>
          <div
            class="items-box"
            @click="
              !(
                judgelimitState.assessProviLeader ||
                judgelimitState.assessStateCityLeader
              )
                ? showTip()
                : checkAppraise()
            "
          >
            <div class="notice-contain">
              <img
                class="items-img"
                src="../../assets/index/ic_kaohe.png"
                alt
                v-if="
                  judgelimitState.assessProviLeader ||
                  judgelimitState.assessStateCityLeader
                "
              />
              <img class="items-img" src="../../assets/index/ic_kaohe_no_power.png" alt v-else />
            </div>
            <p
              class="items-text"
              :class="
                !(
                  judgelimitState.assessProviLeader ||
                  judgelimitState.assessStateCityLeader
                )
                  ? 'no-power'
                  : ''
              "
            >考核平台</p>
          </div>
          <!-- /** 分时预约 --- 权限 */ -->
          <div class="items-box" @click="!appointment ? showTip() : toTime()">
            <div class="notice-contain">
              <img class="items-img" src="../../assets/index/ic_time.png" alt v-if="appointment" />
              <img class="items-img" src="../../assets/index/ic_time_no_power_2.png" alt v-else />
            </div>
            <p class="items-text" :class="!appointment ? 'no-power' : ''">
              景区预约
            </p>
          </div>

          <div
            class="items-box"
            @click="!attract ? showTip() : openWindow('招商引资', '/investment/index')"
          >
            <div class="notice-contain">
              <img class="items-img" src="../../assets/investment/ic_time.png" alt v-if="attract" />
              <img
                class="items-img"
                src="../../assets/investment/ic_time_no_power_2.png"
                alt
                v-else
              />
            </div>
            <p class="items-text" :class="!attract ? 'no-power' : ''">招商引资</p>
          </div>

          <div class="items-box" @click="!teamSupervision ? showTip() : showTeamSupervision()">
            <div class="notice-contain">
              <img class="items-img" src="../../assets/teamSupervision/icon.png" alt v-if="teamSupervision" />
              <img class="items-img" src="../../assets/teamSupervision/icon_no_power.png" alt v-else />
            </div>
            <p class="items-text" :class="!(teamSupervision) ? 'no-power' : ''">团队监管</p>
          </div>

        </card>
        <div class="tab_nav" v-if="dataTab.length > 0">
          <!-- <div class="tab_nav" v-if="getAuth&&dataTab.length>0"> -->
          <div class="check" @click="checkList" :class="{ active: clickIndex == 1 }">
            我的待办
            <i
              v-if="
                parseInt(noticeNumTravel) +
                  parseInt(noticeNumComplain) +
                  parseInt(noticeNumIntegrity) +
                  parseInt(noticeNumRefund) +
                  parseInt(noticeNumGuide1) +
                  parseInt(noticeNumAttract) + 
                  parseInt(noticeNumTouristPrivacy) >
                  0 &&
                parseInt(noticeNumTravel) +
                  parseInt(noticeNumComplain) +
                  parseInt(noticeNumIntegrity) +
                  parseInt(noticeNumRefund) +
                  parseInt(noticeNumGuide1) +
                  parseInt(noticeNumAttract) +
                  parseInt(noticeNumTouristPrivacy) <=
                  99
              "
              class="i_circle"
            >
              {{
              parseInt(noticeNumTravel) +
              parseInt(noticeNumComplain) +
              parseInt(noticeNumIntegrity) +
              parseInt(noticeNumRefund) +
              parseInt(noticeNumGuide1) +
              parseInt(noticeNumAttract) +
              parseInt(noticeNumTouristPrivacy)
              }}
            </i>
            <i
              v-if="
                parseInt(noticeNumTravel) +
                  parseInt(noticeNumComplain) +
                  parseInt(noticeNumIntegrity) +
                  parseInt(noticeNumRefund) +
                  parseInt(noticeNumGuide1) +
                  parseInt(noticeNumAttract) +
                  parseInt(noticeNumTouristPrivacy) >
                99
              "
              class="i_cril"
            >99+</i>
          </div>
          <div class="check boad" @click="watchList" :class="{ active: clickIndex == 2 }">统计数据</div>
        </div>
        <!-- 待办 -->
        <!-- v-show="clickIndex==1&&dataTab.length>0" -->
        <div class="data-card pg-pd12 waitCheck" v-show="clickIndex == 1 && dataTab.length > 0">
          <!-- <div class="state_nav" v-if="getAuth"> -->
          <div class="state_nav">
            <tabNav :tabList="dataTab" ref="tab" :name="'dataTab'" @onSwitch="myPending"></tabNav>
          </div>
          <div class="content_list">
            <!-- 投诉的tab卡片 -->
            <!-- 投诉所属 -->
            <IndexComplainToDo 
              v-if="currentListState === 'complaint'"
              :waitList="waitList"
            ></IndexComplainToDo>
            <!-- 退货的卡片 -->
            <div
              class="tab_item"
              v-for="(item, index) in waitList"
              :key="index + waitList.length"
              v-if="currentListState == 'refund'"
            >
              <div class="item_list">
                <div class="item_title line_bottom">
                  <div class="left">
                    <p class="tip1">{{ item.statusText }}</p>
                  </div>
                  <div class="right" @click="goRefundDetail(item)">
                    <p class="tip4">立即处理</p>
                  </div>
                </div>
                <div class="item_bottom">
                  <div class="bottom_list">
                    <p class="tip5">商品金额 :</p>
                    <p class="tip6">¥{{ item.shoppingAmount }}</p>
                  </div>
                  <div class="bottom_list other">
                    <p class="tip5">商品名称：</p>
                    <p class="tip6">{{ item.product }}</p>
                  </div>
                  <div class="bottom_list other">
                    <p class="tip5">商家名称：</p>
                    <p class="tip6">{{ item.shoppingStore }}</p>
                  </div>
                  <div class="bottom_list other">
                    <p class="tip5">购买时间：</p>
                    <p class="tip6">{{ item.shoppingTime | filtTime1() }}</p>
                  </div>
                </div>
              </div>
            </div>
            <!-- 诚信的卡片 -->
            <div
              class="tab_item"
              v-for="(item, index) in waitList"
              :key="index"
              v-if="currentListState == 'inner'"
            >
              <div class="item_list">
                <div class="item_title line_bottom" v-if="(item.taskType == 21 || item.taskType == 22) && areaFlag">
                  <div class="left left_box">
                    <p class="tip1">{{ item.title }}</p>
                  </div>
                  <div class="right_box">
                    <div
                      class="left_time"
                      v-if="item.taskType == 32 || item.taskType == 33"
                    >{{ item.diffDay }}</div>
                    <div class="right" @click="goInnerDetail(item)">
                      <p class="tip4">立即处理</p>
                    </div>
                  </div>
                </div>
                <div class="item_title line_bottom" v-if="item.taskType != 21 && item.taskType != 22">
                  <div class="left left_box">
                    <p class="tip1">{{ item.title }}</p>
                    <p
                      class="left_tip"
                      v-if="
                        item.taskType == 30 ||
                        item.taskType == 31 ||
                        item.taskType == 32 ||
                        item.taskType == 33
                      "
                      :style="
                        item.taskType == 30 ||
                        item.taskType == 31 ||
                        item.taskType == 32
                          ? 'background: #FFA509'
                          : 'background: #FF4D17'
                      "
                    >
                      <span>
                        {{
                        item.taskType == 30 ||
                        item.taskType == 31 ||
                        item.taskType == 32
                        ? "较重"
                        : item.taskType == 33
                        ? "严重"
                        : ""
                        }}
                      </span>
                    </p>
                  </div>
                  <div class="right_box">
                    <div
                      class="left_time"
                      v-if="item.taskType == 32 || item.taskType == 33"
                    >{{ item.diffDay }}</div>
                    <div class="right" @click="goInnerDetail(item)">
                      <p class="tip4">立即处理</p>
                    </div>
                  </div>
                </div>
                <!-- taskType: 1 - 评分待审核， 2 - 评分任务待编辑， 3 - 待线下整改通知， 4 - 待重新评分，
                30 - 退出重点关注待审核， 31 - 退出重点关注审核不通过， 32 - 重点关注企业待评分， 33 - 黑名单预警企业待评分
                21 - 企业停业，22 - 经营范围变更-->
                <div class="item_bottom" v-if="item.taskType == 1">
                  <!-- // 待审核 -->
                  <div class="bottom_list" v-if="item.industryCategory">
                    <p class="tip5 otherWidth">涉及行业类别：</p>
                    <!-- <p class="tip7 otherWidth"><span v-for="(itm,idex) in item.industryCategory" :key="idex">{{itm}}</span></p> -->
                    <p class="tip6" style="color: #36b374">{{ item.industryCategory }}</p>
                  </div>
                  <div class="bottom_list other">
                    <p class="tip5 otherWidth">审核结果：</p>
                    <p class="tip6">{{ item.memo }}</p>
                  </div>
                  <div class="bottom_list other" v-show="item.planTime">
                    <p class="tip5 otherWidth">目标完成时间：</p>
                    <p class="tip6" v-if="item.planTime">{{ item.planTime | filtTime1 }}</p>
                  </div>
                  <div class="bottom_list other">
                    <p class="tip5 otherWidth">提交人：</p>
                    <p class="tip6" v-if="item.creatorName">{{ item.creatorName }}</p>
                  </div>
                </div>
                <div class="item_bottom" v-if="item.taskType == 2">
                  <!-- // 评分任务待编辑 -->
                  <div class="bottom_list">
                    <p class="tip5">任务名称：</p>
                    <p class="tip6">{{ item.name }}</p>
                  </div>
                  <div class="bottom_list other">
                    <p class="tip5">审核结果：</p>
                    <p class="tip6">{{ item.memo }}</p>
                  </div>
                </div>
                <div class="item_bottom" v-if="item.taskType == 3">
                  <!-- // 待办详情待线下整改 -->
                  <div class="bottom_list">
                    <p class="tip5">企业名称：</p>
                    <p class="tip6">{{ item.name }}</p>
                  </div>
                  <div class="bottom_list other" v-if="item.planTime">
                    <p class="tip5 otherWidth1">进入重点关注日期：</p>
                    <p class="tip6" v-if="item.planTime">{{ item.planTime | filtTime }}</p>
                  </div>
                  <div class="item_bottom_tag" v-if="item.regionName || item.industryCategory">
                    <div
                      class="item_bottom_tag_city line_border_blue"
                      v-if="item.regionName"
                    >{{ item.regionName }}</div>
                    <div
                      class="item_bottom_tag_guide line_border_green"
                      v-if="item.industryCategory"
                    >
                      {{
                      item.industryCategory.indexOf("[") > -1
                      ? item.industryCategory.slice(
                      1,
                      item.industryCategory.length - 1
                      )
                      : item.industryCategory
                      }}
                    </div>
                  </div>
                </div>
                <div class="item_bottom" v-if="item.taskType == 4">
                  <!-- // 待办详情待重新评分 -->
                  <div class="bottom_list">
                    <p class="tip5">企业名称：</p>
                    <p class="tip6">{{ item.name }}</p>
                  </div>
                  <div class="bottom_list other" v-if="item.regionName">
                    <p class="tip5">所属辖区：</p>
                    <p class="tip6" v-if="item.regionName">{{ item.regionName }}</p>
                  </div>
                  <div class="bottom_list other" v-if="item.planTime">
                    <p class="tip5 otherWidth1">重点关注到期日期：</p>
                    <p class="tip6" v-if="item.planTime">{{ item.planTime | filtTime }}</p>
                  </div>
                  <div class="bottom_list other">
                    <p class="tip5 otherWidth">提交人：</p>
                    <p class="tip6" v-if="item.creatorName">{{ item.creatorName }}</p>
                  </div>
                </div>
                <div class="item_bottom" v-if="(item.taskType == 21 || item.taskType == 22) && areaFlag">
                  <div class="bottom_list">
                    <p class="tip5">企业名称：</p>
                    <p class="tip6">{{ item.name }}</p>
                  </div>
                  <div class="bottom_list other">
                    <p class="tip5 otherWidth1">进入任务时间：</p>
                    <p class="tip6" v-if="item.planTime">{{ item.planTime | filtTime }}</p>
                  </div>
                  <div class="item_bottom_tag" v-if="item.regionName || item.industryCategory">
                    <div
                      class="item_bottom_tag_city line_border_blue"
                      v-if="item.regionName"
                    >{{ item.regionName }}</div>
                    <div
                      class="item_bottom_tag_guide line_border_green"
                      v-if="item.industryCategory"
                    >
                      {{
                      item.industryCategory.indexOf("[") > -1
                      ? item.industryCategory.slice(
                      1,
                      item.industryCategory.length - 1
                      )
                      : item.industryCategory
                      }}
                    </div>
                  </div>
                </div>
                <div
                  class="item_bottom"
                  v-if="
                    item.taskType == 30 ||
                    item.taskType == 31 ||
                    item.taskType == 32 ||
                    item.taskType == 33
                  "
                >
                  <!-- // 退出重点关注待审核 -->
                  <div class="bottom_list">
                    <p class="tip5">企业名称：</p>
                    <p class="tip6">{{ item.name }}</p>
                  </div>
                  <div class="bottom_list other">
                    <p class="tip5 otherWidth1">进入重点关注时间：</p>
                    <p class="tip6" v-if="item.planTime">{{ item.planTime | filtTime }}</p>
                  </div>
                  <div class="item_bottom_tag" v-if="item.regionName || item.industryCategory">
                    <div
                      class="item_bottom_tag_city line_border_blue"
                      v-if="item.regionName"
                    >{{ item.regionName }}</div>
                    <div
                      class="item_bottom_tag_guide line_border_green"
                      v-if="item.industryCategory"
                    >
                      {{
                      item.industryCategory.indexOf("[") > -1
                      ? item.industryCategory.slice(
                      1,
                      item.industryCategory.length - 1
                      )
                      : item.industryCategory
                      }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- 导游的卡片 -->
            <div
              class="tab_item"
              v-for="(item, index) in waitList"
              :key="index"
              v-if="currentListState == 'guide'"
            >
              <!-- 信息审核 -->
              <div class="item_list">
                <div
                  class="item_title line_bottom"
                  v-if="
                    item.type != 4 &&
                    !(guide_trave_Role.OrgInfo.orgRegionId == 34)
                  "
                >
                  <div class="left">
                    <p class="tip1" v-if="item.type == 6">新增导游待审核</p>
                    <p class="tip1" v-if="item.type == 2">黑名单到期待退出</p>
                  </div>
                  <div class="right">
                    <p class="tip3" v-if="item.time && item.type !== 6">{{ item.time }}</p>
                    <p class="tip4" @click="getJumpTo(item)">立即处理</p>
                  </div>
                </div>
                <div
                  class="item_title line_bottom"
                  v-if="
                    item.type == 4 && guide_trave_Role.OrgInfo.orgRegionId == 34
                  "
                >
                  <div class="left">
                    <p class="tip1" v-if="item.type == 4">待处置</p>
                  </div>
                  <div class="right">
                    <p class="tip3" v-if="item.time && item.type !== 6">{{ item.time }}</p>
                    <p class="tip4" @click="getJumpTo(item)">立即处理</p>
                  </div>
                </div>
                <div class="item_bottom" v-if="item.type == 6">
                  <div class="bottom_list">
                    <p class="tip5">导游姓名 :</p>
                    <p class="tip6">{{ item.relevance_name }}</p>
                  </div>
                  <div class="bottom_list other">
                    <p class="tip5">导游证号:</p>
                    <p class="tip6 textWidth">{{ item.relevance_id }}</p>
                  </div>
                  <div class="bottom_list other">
                    <p class="tip5">上报日期:</p>
                    <p class="tip6 textWidth">{{ item.create_time | filtGuideTime }}</p>
                  </div>
                </div>
                <div
                  class="item_bottom"
                  v-if="
                    item.type == 4 && guide_trave_Role.OrgInfo.orgRegionId == 34
                  "
                >
                  <p class="b_title">黑名单全国惩戒到期</p>
                  <div class="bottom_list">
                    <p class="tip5 otherWidth">导游姓名 :</p>
                    <p class="tip6 textWidth">{{ item.relevance_name }}</p>
                  </div>
                  <div class="bottom_list other">
                    <p class="tip5 otherWidth">导游证号：</p>
                    <p class="tip6 textWidth">{{ item.relevance_id }}</p>
                  </div>
                  <div class="bottom_list other">
                    <p class="tip5 otherWidth">违规退出日期：</p>
                    <p class="tip6 textWidth">{{ item.create_time | filtGuideTime }}</p>
                  </div>
                </div>
                <div class="item_bottom" v-if="item.type == 2">
                  <div class="bottom_list">
                    <p class="tip5 otherWidth">导游姓名 :</p>
                    <p class="tip6 textWidth">{{ item.relevance_name }}</p>
                  </div>
                  <div class="bottom_list other">
                    <p class="tip5 otherWidth">导游证号：</p>
                    <p class="tip6 textWidth">{{ item.relevance_id }}</p>
                  </div>
                  <div class="bottom_list other">
                    <p class="tip5 otherWidth">惩戒结束日期：</p>
                    <p class="tip6 textWidth">{{ item.create_time | filtGuideTime }}</p>
                  </div>
                </div>
              </div>
            </div>
            <!-- 旅行社的卡片 -->
            <div
              class="tab_item"
              v-for="(item, index) in waitList"
              :key="index"
              v-if="currentListState == 'trave'"
            >
              <!-- 信息审核 -->
              <div class="item_list" v-if="item.type == 1">
                <div class="item_title line_bottom">
                  <div class="left">
                    <p class="tip1">新增旅行社待审核</p>
                  </div>
                  <div class="right">
                    <p class="tip4" @click="jumpTravle(item)">立即处理</p>
                  </div>
                </div>
                <div class="item_bottom">
                  <div class="bottom_list">
                    <p class="tip5 otherWidth">旅行社名称 :</p>
                    <p class="tip6 otherWidth">{{ item.relevance_name }}</p>
                  </div>
                  <div class="bottom_list other">
                    <p class="tip5 otherWidth">统一社会信用代码:</p>
                    <p class="tip6 textWidth">{{ item.relevance_id }}</p>
                  </div>
                  <div class="bottom_list other">
                    <p class="tip5 otherWidth">上报日期:</p>
                    <p class="tip6 textWidth">{{ item.create_time | filtGuideTime }}</p>
                  </div>
                </div>
              </div>
            </div>
            <div class="no_task" v-if="isTask">
              <img src="../../assets/image/ic_wuxing.png" />
              <p>赞！您已完成所有工作</p>
            </div>

            <!-- 招商的卡片 -->
            <div
              class="tab_item"
              v-for="(item, index) in waitList"
              :key="index + waitList.length"
              v-if="currentListState == 'attract'"
            >
              <div class="item_list">
                <div class="item_title line_bottom">
                  <div class="left">
                    <p class="tip1" v-if="item.attractType == 0">待处理</p>
                    <p class="tip1" v-if="[1,2,3,4,5].indexOf(item.attractType) != -1">待审核</p>
                    <p class="tip1" v-if="item.attractType == 6">待审核</p>
                  </div>
                  <div class="right" @click="goAttractDetail(item)">
                    <p class="tip4">立即处理</p>
                  </div>
                </div>
                <div class="item_bottom" v-if="item.attractType == 0">
                  <div class="bottom_list">
                    <p class="tip5">咨询对象 :</p>
                    <p class="tip6">{{item.advisoryObject}}</p>
                  </div>
                  <div class="bottom_list">
                    <p class="tip5">姓名 :</p>
                    <p class="tip6">{{item.queristName}}</p>
                  </div>
                  <div class="bottom_list">
                    <p class="tip5">留言时间 :</p>
                    <p class="tip6">{{item.advisoryTime}}</p>
                  </div>
                </div>
                <div class="item_bottom" v-if="[1,2,3,4,5].indexOf(item.attractType) != -1">
                  <div class="bottom_list">
                    <p class="tip5">信息类型 :</p>
                    <p class="tip6" v-if="item.attractType == 1">招商项目</p>
                    <p class="tip6" v-if="item.attractType == 2">营商环境</p>
                    <p class="tip6" v-if="item.attractType == 3">联系我们</p>
                    <p class="tip6" v-if="item.attractType == 4">合作企业</p>
                    <p class="tip6" v-if="item.attractType == 5">运营位</p>
                  </div>
                  <div class="bottom_list">
                    <p class="tip5">标题 :</p>
                    <p class="tip6" v-if="[1,2,3,4].indexOf(item.attractType) != -1">{{item.title}}</p>
                    <p class="tip6" v-else>{{item.operatingName}}</p>
                  </div>
                  <div class="bottom_list">
                    <p class="tip5">提交时间 :</p>
                    <p class="tip6">{{item.createTime}}</p>
                  </div>
                </div>
                <div class="item_bottom" v-if="item.attractType == 6">
                  <div class="bottom_list">
                    <p class="tip5">项目名称 :</p>
                    <p class="tip6">{{item.projectName}}</p>
                  </div>
                  <div class="bottom_list">
                    <p class="tip5">提交时间 :</p>
                    <p class="tip6">{{item.createTime}}</p>
                  </div>
                </div>
              </div>
            </div>

            <!-- 团队监管的卡片 -->
            <template v-if="currentListState == 'touristPrivacy'">
              <TouristPrivacyCard  v-for="(item, index) in touristPrivacyList" :data="item" :key="item.id"></TouristPrivacyCard>
            </template>
            <!-- 团队监管的卡片 -->
          </div>
        </div>

        <!-- 统计数据 -->
        <!-- <div v-if="false"> -->
        <div class="data-card pg-pd12" v-if="clickIndex == 2 || dataTab.length == 0">
          <div class="data-card-head data-card-head-first" v-if="dataTab.length == 0">
            <div class="data-card-head-tit-big">统计数据</div>
          </div>
          <!--//////////////////////////////////////////////////////////////////-->
          <!--投诉-->
          <!--//////////////////////////////////////////////////////////////////-->
          <!-- 投诉所属 -->
          <div
            class="data-card-cnt"
            v-if="
              complainlimitState.complaintLeader ||
              complainlimitState.complaintHandlder
            "
          >
            <div class="data-card-head">
              <div class="data-card-head-tit">投诉</div>
              <div
                class="showmore-contain"
                @click="
                  openWindow(
                    '投诉',
                    complainlimitState.complaintLeader
                      ? '/complaint/leader'
                      : '/complaint/worker'
                  )
                "
              >
                <right :title="'查看更多'"></right>
              </div>
            </div>
            <div class="item mt12">
              <div class="item-head">
                <div class="item-head-title">今日投诉数量统计</div>
                <template v-if="globalApp.online">
                  <div
                    class="item-head-full"
                    @click="fullScreen(0, '今日投诉数量统计')"
                    v-if="complainlimitState.complaintLeader"
                  >
                    全屏
                    <img class="item-head-full-img" src="@/assets/index/ic_full screen.png" />
                  </div>
                </template>
              </div>
              <rline></rline>
              <!--领导组-->
              <template v-if="complainlimitState.complaintLeader">
                <div class="box complain-example-box">
                  <div v-for="(item, index) in handling" :key="index" class="left line line_bottom">
                    <div @click="leaderListItemClick(item, item.name)">
                      <scoreCard
                        :type="3"
                        :data="{
                          title: item.name ? item.name + '(件)' : '',
                          num: item.value,
                        }"
                      ></scoreCard>
                    </div>
                  </div>
                  <div class="vline">
                    <div class="borders-1px"></div>
                  </div>
                </div>
              </template>
              <!--处置组-->
              <template
                v-if="
                  complainlimitState.complaintHandlder && IfComplaintHandling
                "
              >
                <div class="box complain-example-box">
                  <div
                    v-for="(item, index) in handleWorkbench"
                    :key="index"
                    class="left line line_bottom"
                    :class="[
                      handleWorkbench.length % 2 == 1
                        ? handleWorkbench.length - 1 > index
                          ? ''
                          : 'line_bottom_none'
                        : handleWorkbench.length - 2 > index
                        ? ''
                        : 'line_bottom_none',
                    ]"
                  >
                    <div @click="WorkbenchItemClick(item, areaOne)">
                      <scoreCard :type="3" :data="{ title: item.name + '(件)', num: item.value }"></scoreCard>
                    </div>
                  </div>
                  <div class="vline">
                    <div class="borders-1px"></div>
                  </div>
                </div>
              </template>

              <!-- 落点分布 开始 -->
              <div class="fallPointDistribution" 
              v-if="
                complainlimitState.complaintLeader && (
                dropDistribution.province || 
                dropDistribution.city || 
                dropDistribution.county || 
                dropDistribution.enterprise
              )"
              >
                <div class="status">落点分布</div>
                <div class="levelDistribution">
                  <div class="districtLevel" @click="goRoute(1)">
                    <div class="leaveName levelOp1">省级</div>
                    <div class="pointsNum">{{ dropDistribution.province }}</div>
                  </div>
                  <div class="levelPointing">
                    <img src="@/assets/index/right2x.png" />
                  </div>
                  <div class="districtLevel" @click="goRoute(2)">
                    <div class="leaveName levelOp2">州市</div>
                    <div class="pointsNum">{{ dropDistribution.city }}</div>
                  </div>
                  <div class="levelPointing">
                    <img src="@/assets/index/right2x.png" />
                  </div>
                  <div class="districtLevel" @click="goRoute(3)">
                    <div class="leaveName levelOp3">区级</div>
                    <div class="pointsNum">{{ dropDistribution.county }}</div>
                  </div>
                  <div class="levelPointing">
                    <img src="@/assets/index/right2x.png" />
                  </div>
                  <div class="districtLevel">
                    <div class="leaveName levelOp4" @click="goRoute(4)">企业</div>
                    <div class="pointsNum">{{ dropDistribution.enterprise }}</div>
                  </div>
                </div>
                <rline></rline>
              </div>
              <!-- 落点分布 结束 -->

              <!-- 紧急程度分布 开始 -->
              <div
                class="power"
                v-show="
                  complainlimitState.complaintLeader &&
                  syntheticalWarning.length
                "
              >
                <div class="spread"></div>
                <div class="warning">
                  <div class="w-title">综合预警</div>
                  <van-swipe class="w-swiper complain-w-swiper" indicator-color="#BBBBBB">
                    <van-swipe-item
                      v-for="(item, index1) in syntheticalWarning"
                      :key="index1"
                      @click="
                        goList('syntheticalWarning', item.typeCode, areaOne)
                      "
                    >
                      <div class="item">
                        <div class="i-title">{{ item.name }}</div>
                        <div class="i-cont">{{ item.warning }}，{{ item.description }}</div>
                        <div class="i-time">{{ item.time }}</div>
                      </div>
                    </van-swipe-item>
                  </van-swipe>
                </div>
                <rline></rline>
                <div class="warning">
                  <div class="w-title">紧急程度分布</div>
                  <div class="w-cont">
                    <div
                      class="c-item"
                      v-for="(item, index) in emergency"
                      :key="index"
                      @click="
                        toLeaderWarningList('emergency', item.type, areaOne, item)
                      "
                    >
                      <div class="i-title">{{ item.name }}</div>
                      <div
                        class="i-num"
                        :class="[
                          { 'd-color': index == 0 },
                          { 't-color': index == 1 },
                          { 'w-color': index == 2 },
                        ]"
                      >{{ item.value }}</div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- 紧急程度分布 结束 -->
            </div>
          </div>

          <!--//////////////////////////////////////////////////////////////////-->
          <!--投诉-->
          <!--//////////////////////////////////////////////////////////////////-->

          <!--//////////////////////////////////////////////////////////////////-->
          <!--退货-->
          <!--//////////////////////////////////////////////////////////////////-->
          <!--TODO: 退货统计数据，暂时隐藏-->
          <!--<div
            class="data-card-cnt"
            v-if="
              refundlimitState.refundLeader || refundlimitState.refundHandler
            "
          >
            <div class="data-card-head">
              <div class="data-card-head-tit">退货</div>
              <div
                class="showmore-contain"
                @click="
                  openWindow(
                    '退货',
                    refundlimitState.refundLeader
                      ? '/refund/leader'
                      : '/refund/worker'
                  )
                "
              >
                <right :title="'查看更多'"></right>
              </div>
            </div>

            <div class="item mt12">
              <div class="item-head">
                <div class="item-head-title">今日退货数量统计</div>
                <template v-if="globalApp.online">
                  <div
                    class="item-head-full"
                    @click="fullScreen(2, '今日退货数量统计')"
                    v-if="refundlimitState.refundLeader"
                  >
                    全屏
                    <img class="item-head-full-img" src="@/assets/index/ic_full screen.png" />
                  </div>
                </template>
              </div>
              <rline></rline>

              <div class="select_type" v-if="refundlimitState.refundLeader">
                <span
                  class="t_txt"
                  v-for="(item, index) in dataList"
                  :key="index"
                  :class="{ t_active: item.select }"
                  @click="selectAll(index, item)"
                >{{ item.key }}</span>
              </div>
              <div>
                <template>
                  <rline class="mt16" v-if="refundlimitState.refundLeader"></rline>
                  <div class="card-wrap">
                    <div
                      class="items"
                      @click="
                        goLeader(
                          '',
                          '/refund/manageList?status=&refundType=&isCenterReceipt='
                        )
                      "
                    >
                      <div class="tit">退货申请(起)</div>
                      <div class="num">{{ homeInfo.allReturnList }}</div>
                      <div class="price" v-if="refundlimitState.refundLeader">
                        {{ homeInfo.totalShoppingAmount | filt
                        }}
                        <i v-if="parseInt(homeInfo.totalShoppingAmount) < 10000">元</i>
                        <i
                          v-if="
                            parseInt(homeInfo.totalShoppingAmount) >= 10000 &&
                            parseInt(homeInfo.totalShoppingAmount) < 100000000
                          "
                        >万元</i>
                        <i
                          v-if="
                            parseInt(homeInfo.totalShoppingAmount) >= 100000000
                          "
                        >亿元</i>
                      </div>
                    </div>
                    <div
                      class="items"
                      @click="
                        goLeader(
                          'refundSuccess',
                          '/refund/manageList?status=-12&refundType=&isCenterReceipt='
                        )
                      "
                    >
                      <div class="tit">退货成功(起)</div>
                      <div class="num">{{ homeInfo.refundSuccess }}</div>
                      <div class="price" v-if="refundlimitState.refundLeader">
                        {{ homeInfo.refundSuccessRefundAmount | filt
                        }}
                        <i
                          v-if="
                            parseInt(homeInfo.refundSuccessRefundAmount) < 10000
                          "
                        >元</i>
                        <i
                          v-if="
                            parseInt(homeInfo.refundSuccessRefundAmount) >=
                              10000 &&
                            parseInt(homeInfo.refundSuccessRefundAmount) <
                              100000000
                          "
                        >万元</i>
                        <i
                          v-if="
                            parseInt(homeInfo.refundSuccessRefundAmount) >=
                            100000000
                          "
                        >亿元</i>
                      </div>
                    </div>
                    <div class="vline">
                      <div class="borders-1px"></div>
                    </div>
                  </div>
                  <rline></rline>
                  <div class="card-wrap">
                    <div
                      class="items"
                      @click="
                        goLeader(
                          'processing',
                          '/refund/manageList?status=-11&refundType=&isCenterReceipt='
                        )
                      "
                    >
                      <div class="tit">处理中(起)</div>
                      <div class="num">{{ homeInfo.waitHandle }}</div>
                      <div class="price" v-if="refundlimitState.refundLeader">
                        {{ homeInfo.waitHandleShoppingAmount | filt
                        }}
                        <i
                          v-if="
                            parseInt(homeInfo.waitHandleShoppingAmount) < 10000
                          "
                        >元</i>
                        <i
                          v-if="
                            parseInt(homeInfo.waitHandleShoppingAmount) >=
                              10000 &&
                            parseInt(homeInfo.waitHandleShoppingAmount) <
                              100000000
                          "
                        >万元</i>
                        <i
                          v-if="
                            parseInt(homeInfo.waitHandleShoppingAmount) >=
                            100000000
                          "
                        >亿元</i>
                      </div>
                    </div>
                    <div
                      class="items"
                      @click="
                        goLeader(
                          'waitAccept',
                          '/refund/manageList?status=-13&refundType=&isCenterReceipt='
                        )
                      "
                    >
                      <div class="tit">待受理(起)</div>
                      <div class="num">{{ homeInfo.waitAccept }}</div>
                      <div class="price" v-if="refundlimitState.refundLeader">
                        {{ homeInfo.waitAcceptShoppingAmount | filt
                        }}
                        <i
                          v-if="
                            parseInt(homeInfo.waitAcceptShoppingAmount) < 10000
                          "
                        >元</i>
                        <i
                          v-if="
                            parseInt(homeInfo.waitAcceptShoppingAmount) >=
                              10000 &&
                            parseInt(homeInfo.waitAcceptShoppingAmount) <
                              100000000
                          "
                        >万元</i>
                        <i
                          v-if="
                            parseInt(homeInfo.waitAcceptShoppingAmount) >=
                            100000000
                          "
                        >亿元</i>
                      </div>
                    </div>
                    <div class="vline">
                      <div class="borders-1px"></div>
                    </div>
                  </div>
                  <rline></rline>
                  <div class="card-wrap">
                    <div
                      class="items"
                      @click="
                        goLeader(
                          'userRevoke',
                          '/refund/manageList?status=150&refundType=&isCenterReceipt='
                        )
                      "
                    >
                      <div class="tit">游客撤销(起)</div>
                      <div class="num">{{ homeInfo.userRevoke }}</div>
                      <div class="price" v-if="refundlimitState.refundLeader">
                        {{ homeInfo.userRevokeShoppingAmount | filt
                        }}
                        <i
                          v-if="
                            parseInt(homeInfo.userRevokeShoppingAmount) < 10000
                          "
                        >元</i>
                        <i
                          v-if="
                            parseInt(homeInfo.userRevokeShoppingAmount) >=
                              10000 &&
                            parseInt(homeInfo.userRevokeShoppingAmount) <
                              100000000
                          "
                        >万元</i>
                        <i
                          v-if="
                            parseInt(homeInfo.userRevokeShoppingAmount) >=
                            100000000
                          "
                        >亿元</i>
                      </div>
                    </div>
                    <div
                      class="items"
                      @click="
                        goLeader(
                          'refuseAccept',
                          '/refund/manageList?status=-14&refundType=&isCenterReceipt='
                        )
                      "
                    >
                      <div class="tit">不予受理(起)</div>
                      <div class="num">{{ homeInfo.refuseAccept }}</div>
                      <div class="price" v-if="refundlimitState.refundLeader">
                        {{ homeInfo.refuseAcceptShoppingAmount | filt
                        }}
                        <i
                          v-if="
                            parseInt(homeInfo.refuseAcceptShoppingAmount) <
                            10000
                          "
                        >元</i>
                        <i
                          v-if="
                            parseInt(homeInfo.refuseAcceptShoppingAmount) >=
                              10000 &&
                            parseInt(homeInfo.refuseAcceptShoppingAmount) <
                              100000000
                          "
                        >万元</i>
                        <i
                          v-if="
                            parseInt(homeInfo.refuseAcceptShoppingAmount) >=
                            100000000
                          "
                        >亿元</i>
                      </div>
                    </div>
                    <div class="vline">
                      <div class="borders-1px"></div>
                    </div>
                  </div>
                  <rline v-if="refundlimitState.refundLeader"></rline>
                </template>

                <div v-if="refundlimitState.refundLeader">
                  <div class="line-charts">近30天退货趋势</div>
                  <div class="line-contain">
                    <lineCharts :data="lineList" :showYear="true" :color="color" :unit="lineUnit" />
                  </div>
                </div>
              </div>
            </div>
          </div>-->
          <!--TODO: 退货统计数据，暂时隐藏-->
          <!--//////////////////////////////////////////////////////////////////-->
          <!--退货-->
          <!--//////////////////////////////////////////////////////////////////-->

          <!--//////////////////////////////////////////////////////////////////-->
          <!--旅行社-->
          <!--//////////////////////////////////////////////////////////////////-->
          <div
            class="data-card-cnt"
            v-if="
              limitState.travelAgencyHandler || limitState.travelAgencyLeader
            "
          >
            <div class="data-card-head">
              <div class="data-card-head-tit">旅行社</div>
              <div class="showmore-contain" @click="openWindow('旅行社', '/travelAgency/home')">
                <right :title="'查看更多'"></right>
              </div>
            </div>
            <div class="w-swiper">
              <!-- 全部旅行社 -->
              <div v-for="(item, index) in travelData" :key="'travel-swipe-' + index">
                <div class="item mt12">
                  <div class="item-head">
                    <div class="item-head-title">
                      {{
                      Number(limitState.city) > 34
                      ? limitState.cityName
                      : "全省"
                      }}{{ item.name }}旅行社{{
                      item.name === "" ? "总量" : "数量"
                      }}
                    </div>
                    <template v-if="globalApp.online">
                      <div
                        class="item-head-full"
                        @click="
                          fullScreen(
                            5,
                            (Number(limitState.city) > 34
                              ? limitState.cityName
                              : '全省') +
                              item.name +
                              '旅行社总量',
                            index
                          )
                        "
                      >
                        全屏
                        <img class="item-head-full-img" src="@/assets/index/ic_full screen.png" />
                      </div>
                    </template>
                  </div>
                  <!--省级 dashboard-->
                  <rline v-if="limitState.travelAgencyLeader"></rline>

                  <div class="guide-card" v-if="limitState.travelAgencyLeader">
                    <div class="ranking">
                      <span class="num">{{ item.data.dashboard.numbers }}</span>
                      <span class="unit">家</span>
                    </div>
                    <div class="desc">
                      <span class="diff">较上月</span>
                      <span class="res no-change" v-if="item.data.dashboard.compare === 'equal'">持平</span>
                      <span
                        class="res up"
                        v-if="
                          item.data.dashboard.compare === 'add' &&
                          item.name === ''
                        "
                      >+{{ item.data.dashboard.price }}↑</span>
                      <span
                        class="res down"
                        v-if="
                          item.data.dashboard.compare === 'add' &&
                          item.name !== ''
                        "
                      >+{{ item.data.dashboard.price }}↑</span>
                      <span
                        class="res down"
                        v-if="
                          item.data.dashboard.compare === 'decrease' &&
                          item.name === ''
                        "
                      >{{ item.data.dashboard.price }}↓</span>
                      <span
                        class="res up"
                        v-if="
                          item.data.dashboard.compare === 'decrease' &&
                          item.name !== ''
                        "
                      >{{ item.data.dashboard.price }}↓</span>
                    </div>
                  </div>

                  <rline v-if="limitState.travelAgencyHandler"></rline>
                  <!--州级 dashboard-->
                  <div
                    class="guide-card-state ht83"
                    v-if="limitState.travelAgencyHandler"
                    style="position: relative"
                  >
                    <div class="guide-card flex1" style="padding-bottom: 20px">
                      <div class="ranking">
                        <span class="num">
                          {{
                          item.data.dashboard.numbers
                          }}
                        </span>
                        <span class="unit">家</span>
                      </div>
                      <div class="desc">
                        <span class="diff">较上月</span>
                        <span
                          class="res no-change"
                          v-if="item.data.dashboard.compare === 'equal'"
                        >持平</span>
                        <span
                          class="res up"
                          v-if="
                            item.data.dashboard.compare === 'add' &&
                            item.name === ''
                          "
                        >+{{ item.data.dashboard.price }}↑</span>
                        <span
                          class="res down"
                          v-if="
                            item.data.dashboard.compare === 'add' &&
                            item.name !== ''
                          "
                        >+{{ item.data.dashboard.price }}↑</span>
                        <span
                          class="res down"
                          v-if="
                            item.data.dashboard.compare === 'decrease' &&
                            item.name === ''
                          "
                        >{{ item.data.dashboard.price }}↓</span>
                        <span
                          class="res up"
                          v-if="
                            item.data.dashboard.compare === 'decrease' &&
                            item.name !== ''
                          "
                        >{{ item.data.dashboard.price }}↓</span>
                      </div>
                    </div>
                    <div class="guide-card flex1" style="padding-bottom: 20px">
                      <div class="ranking">
                        <span class="unit gray">第</span>
                        <span class="num">{{ item.data.rank.numbers }}</span>
                        <span class="unit gray">名</span>
                      </div>
                      <div class="desc">
                        <span class="diff">较上月</span>
                        <span class="res no-change" v-if="item.data.rank.compare === 'equal'">持平</span>
                        <span
                          class="res up"
                          v-if="
                            item.data.rank.compare === 'add' && item.name === ''
                          "
                        >+{{ item.data.rank.price }}↑</span>
                        <span
                          class="res down"
                          v-if="
                            item.data.rank.compare === 'add' && item.name !== ''
                          "
                        >+{{ item.data.rank.price }}↑</span>
                        <span
                          class="res down"
                          v-if="
                            item.data.rank.compare === 'decrease' &&
                            item.name === ''
                          "
                        >{{ item.data.rank.price }}↓</span>
                        <span
                          class="res up"
                          v-if="
                            item.data.rank.compare === 'decrease' &&
                            item.name !== ''
                          "
                        >{{ item.data.rank.price }}↓</span>
                      </div>
                    </div>
                    <div class="vline">
                      <div class="borders-1px"></div>
                    </div>
                  </div>
                  <rline></rline>
                  <!-- 省级 图表 -->
                  <div class="ranking-wrap" v-if="limitState.travelAgencyLeader">
                    <tab
                      :tabList="travelTabList"
                      :name="index + 'travelTabIndex'"
                      :ref="index + 'TravelTabRef'"
                      :indexKey="index"
                      @onSwitch="travelTabSwitch"
                    ></tab>
                  </div>
                  <div class v-if="limitState.travelAgencyLeader">
                    <div class="map-contain">
                      <van-loading color="#36b374" class="v-loading" v-if="!travelMap" />
                      <template v-if="travelMap">
                        <mapCharts
                          :list="item.data.mapList"
                          :level="travellevel"
                          :showCircle="showCircle"
                          :unit="'家'"
                          :showUnit="true"
                          v-if="
                            index === 'all'
                              ? travelAllTabIndex == 0
                              : index === 'black'
                              ? travelBlackTabIndex == 0
                              : travelSuperviseTabIndex == 0
                          "
                        />
                      </template>
                      <guideLineCharts
                        :data="item.data.trendList"
                        :color="color"
                        :interval="1"
                        :showYear="true"
                        :unit="'家'"
                        :title="
                          index === 'all'
                            ? '总数:'
                            : index === 'black'
                            ? '黑名单数:'
                            : '重点关注数:'
                        "
                        :showNum="true"
                        v-if="
                          index === 'all'
                            ? travelAllTabIndex == 1
                            : index === 'black'
                            ? travelBlackTabIndex == 1
                            : travelSuperviseTabIndex == 1
                        "
                      />
                    </div>
                  </div>
                  <!-- 州市 图表 -->
                  <div class="ranking-wrap" v-if="limitState.travelAgencyHandler">
                    <tab
                      :tabList="travelTabList"
                      :name="index + 'travelTabIndex'"
                      :ref="index + 'TravelTabRef'"
                      :indexKey="index"
                      @onSwitch="travelTabSwitch"
                    ></tab>
                  </div>
                  <div class v-if="limitState.travelAgencyHandler">
                    <div class="map-contain">
                      <guideLineCharts
                        :data="item.data.trendList"
                        :color="color"
                        :interval="1"
                        :showYear="true"
                        :unit="'家'"
                        :title="
                          index === 'all'
                            ? '总数:'
                            : index === 'black'
                            ? '黑名单数:'
                            : '重点关注数:'
                        "
                        :showNum="true"
                        v-if="
                          travelMap && index === 'all'
                            ? travelAllTabIndex == 0
                            : index === 'black'
                            ? travelBlackTabIndex == 0
                            : travelSuperviseTabIndex == 0
                        "
                      />
                      <guideRankCharts
                        class="mt13"
                        :rankList="item.data.rankList"
                        :selfId="Number(limitState.city)"
                        :className="'fixed-height'"
                        :firstSize="20"
                        :indexKey="index"
                        @setSelfItem="setTravelSelfItem"
                        v-show="
                          index === 'all'
                            ? travelAllTabIndex == 1
                            : index === 'black'
                            ? travelBlackTabIndex == 1
                            : travelSuperviseTabIndex == 1
                        "
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!--//////////////////////////////////////////////////////////////////-->
          <!--旅行社-->
          <!--//////////////////////////////////////////////////////////////////-->

          <!--//////////////////////////////////////////////////////////////////-->
          <!--start 导游 by huhui-->
          <!--//////////////////////////////////////////////////////////////////-->
          <div class="data-card-cnt" v-if="limitState.guideLeader || limitState.guideHandler">
            <div class="data-card-head">
              <div class="data-card-head-tit">导游</div>
              <div class="showmore-contain" @click="openWindow('导游', '/guide/index')">
                <right :title="'查看更多'"></right>
              </div>
            </div>
            <div class="w-swiper">
              <!-- 全部旅导游 -->
              <div v-for="(item, index) in guideData" :key="'guide-swipe-' + index">
                <div class="item mt12">
                  <div class="item-head">
                    <div class="item-head-title">
                      {{
                      Number(limitState.city) > 34
                      ? limitState.cityName
                      : "全省"
                      }}{{ item.name }}导游{{
                      item.name === "" ? "总量" : "数量"
                      }}
                    </div>
                    <div
                      v-if="globalApp.online"
                      class="item-head-full"
                      @click="
                        fullScreen(
                          4,
                          (Number(limitState.city) > 34
                            ? limitState.cityName
                            : '全省') +
                            item.name +
                            '导游总量',
                          index
                        )
                      "
                    >
                      全屏
                      <img class="item-head-full-img" src="@/assets/index/ic_full screen.png" />
                    </div>
                  </div>
                  <!--省级 dashboard-->
                  <rline v-if="limitState.guideLeader"></rline>

                  <div class="guide-card" v-if="limitState.guideLeader">
                    <div class="ranking">
                      <span class="num">{{ item.data.dashboard.numbers }}</span>
                      <span class="unit">名</span>
                    </div>
                    <div class="desc">
                      <span class="diff">较上月</span>
                      <span class="res no-change" v-if="item.data.dashboard.compare === 'equal'">持平</span>
                      <span
                        class="res up"
                        v-if="
                          item.data.dashboard.compare === 'add' &&
                          item.name === ''
                        "
                      >+{{ item.data.dashboard.price }}↑</span>
                      <span
                        class="res down"
                        v-if="
                          item.data.dashboard.compare === 'add' &&
                          item.name !== ''
                        "
                      >+{{ item.data.dashboard.price }}↑</span>
                      <span
                        class="res down"
                        v-if="
                          item.data.dashboard.compare === 'decrease' &&
                          item.name === ''
                        "
                      >{{ item.data.dashboard.price }}↓</span>
                      <span
                        class="res up"
                        v-if="
                          item.data.dashboard.compare === 'decrease' &&
                          item.name !== ''
                        "
                      >{{ item.data.dashboard.price }}↓</span>
                    </div>
                  </div>

                  <rline v-if="limitState.guideHandler"></rline>
                  <!--州级 dashboard-->
                  <div
                    class="guide-card-state ht83"
                    v-if="limitState.guideHandler"
                    style="position: relative"
                  >
                    <div class="guide-card flex1" style="padding-bottom: 20px">
                      <div class="ranking">
                        <span class="num">
                          {{
                          item.data.dashboard.numbers
                          }}
                        </span>
                        <span class="unit">名</span>
                      </div>
                      <div class="desc">
                        <span class="diff">较上月</span>
                        <span
                          class="res no-change"
                          v-if="item.data.dashboard.compare === 'equal'"
                        >持平</span>
                        <span
                          class="res up"
                          v-if="
                            item.data.dashboard.compare === 'add' &&
                            item.name === ''
                          "
                        >+{{ item.data.dashboard.price }}↑</span>
                        <span
                          class="res down"
                          v-if="
                            item.data.dashboard.compare === 'add' &&
                            item.name !== ''
                          "
                        >+{{ item.data.dashboard.price }}↑</span>
                        <span
                          class="res down"
                          v-if="
                            item.data.dashboard.compare === 'decrease' &&
                            item.name === ''
                          "
                        >{{ item.data.dashboard.price }}↓</span>
                        <span
                          class="res up"
                          v-if="
                            item.data.dashboard.compare === 'decrease' &&
                            item.name !== ''
                          "
                        >{{ item.data.dashboard.price }}↓</span>
                      </div>
                    </div>
                    <div class="guide-card flex1" style="padding-bottom: 20px">
                      <div class="ranking">
                        <span class="unit gray">第</span>
                        <span class="num">{{ item.data.rank.numbers }}</span>
                        <span class="unit gray">名</span>
                      </div>
                      <div class="desc">
                        <span class="diff">较上月</span>
                        <span class="res no-change" v-if="item.data.rank.compare === 'equal'">持平</span>
                        <span
                          class="res up"
                          v-if="
                            item.data.rank.compare === 'add' && item.name === ''
                          "
                        >+{{ item.data.rank.price }}↑</span>
                        <span
                          class="res down"
                          v-if="
                            item.data.rank.compare === 'add' && item.name !== ''
                          "
                        >+{{ item.data.rank.price }}↑</span>
                        <span
                          class="res down"
                          v-if="
                            item.data.rank.compare === 'decrease' &&
                            item.name === ''
                          "
                        >{{ item.data.rank.price }}↓</span>
                        <span
                          class="res up"
                          v-if="
                            item.data.rank.compare === 'decrease' &&
                            item.name !== ''
                          "
                        >{{ item.data.rank.price }}↓</span>
                      </div>
                    </div>
                    <div class="vline">
                      <div class="borders-1px"></div>
                    </div>
                  </div>
                  <rline></rline>
                  <!-- 省级 图表 -->
                  <div class="ranking-wrap" v-if="limitState.guideLeader">
                    <tab
                      :tabList="guideTabList"
                      :name="index + 'GuideTabIndex'"
                      :ref="index + 'GuideTabRef'"
                      :indexKey="index"
                      @onSwitch="guideTabSwitch"
                    ></tab>
                  </div>
                  <div class v-if="limitState.guideLeader">
                    <div class="map-contain">
                      <van-loading color="#36b374" class="v-loading" v-if="!travelMap" />
                      <mapCharts
                        :list="item.data.mapList"
                        :level="guidelevel"
                        :unit="'名'"
                        :showCircle="showCircle"
                        :showUnit="true"
                        v-if="
                          travelMap && index === 'all'
                            ? guideAllTabIndex == 0
                            : index === 'black'
                            ? guideBlackTabIndex == 0
                            : guideSuperviseTabIndex == 0
                        "
                      />
                      <guideLineCharts
                        :data="item.data.trendList"
                        :color="color"
                        :interval="1"
                        :showYear="true"
                        :unit="'名'"
                        :title="
                          index === 'all'
                            ? '总数:'
                            : index === 'black'
                            ? '黑名单数:'
                            : '重点关注数:'
                        "
                        :showNum="true"
                        v-if="
                          index === 'all'
                            ? guideAllTabIndex == 1
                            : index === 'black'
                            ? guideBlackTabIndex == 1
                            : guideSuperviseTabIndex == 1
                        "
                      />
                    </div>
                  </div>
                  <!-- 州市 图表 -->
                  <div class="ranking-wrap" v-if="limitState.guideHandler">
                    <tab
                      :tabList="guideTabList"
                      :name="index + 'GuideTabIndex'"
                      :ref="index + 'GuideTabRef'"
                      :indexKey="index"
                      @onSwitch="guideTabSwitch"
                    ></tab>
                  </div>
                  <div class v-if="limitState.guideHandler">
                    <div class="map-contain">
                      <guideLineCharts
                        :data="item.data.trendList"
                        :color="color"
                        :interval="1"
                        :showYear="true"
                        :unit="'名'"
                        :title="
                          index === 'all'
                            ? '总数:'
                            : index === 'black'
                            ? '黑名单数:'
                            : '重点关注数:'
                        "
                        :showNum="true"
                        v-if="
                          travelMap && index === 'all'
                            ? guideAllTabIndex == 0
                            : index === 'black'
                            ? guideBlackTabIndex == 0
                            : guideSuperviseTabIndex == 0
                        "
                      />
                      <guideRankCharts
                        class="mt13"
                        :rankList="item.data.rankList"
                        :selfId="Number(limitState.city)"
                        :className="'fixed-height'"
                        :firstSize="20"
                        :indexKey="index"
                        @setSelfItem="setGuideSelfItem"
                        v-show="
                          index === 'all'
                            ? guideAllTabIndex == 1
                            : index === 'black'
                            ? guideBlackTabIndex == 1
                            : guideSuperviseTabIndex == 1
                        "
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!--//////////////////////////////////////////////////////////////////-->
          <!-- end 导游 by huhui-->
          <!--//////////////////////////////////////////////////////////////////-->

          <!--//////////////////////////////////////////////////////////////////-->
          <!--诚信-->
          <!--//////////////////////////////////////////////////////////////////-->
          <div
            class="data-card-cnt"
            v-if="
              integritylimitState.integrityProviLeader ||
              integritylimitState.integrityCityLeader ||
              integritylimitState.integrityCountyLeader ||
              integritylimitState.integrityCityGeneral ||
              integritylimitState.integrityCountyGeneral
            "
          >
            <div class="data-card-head">
              <div class="data-card-head-tit">诚信</div>
              <div class="showmore-contain" @click="openWindow('诚信', '/integrity/index')">
                <right :title="'查看更多'"></right>
              </div>
            </div>
            <div
              :class="[
                'item',
                'mt12',
                {
                  pb10:
                    integritylimitState.integrityCityGeneral ||
                    integritylimitState.integrityCountyGeneral,
                },
              ]"
            >
              <div class="item-head">
                <div class="item-head-title">{{ curCity }}诚信评分情况</div>
                <template v-if="globalApp.online">
                  <div
                    class="item-head-full"
                    @click="fullScreen(3, curCity + '诚信评分情况')"
                    v-if="
                      integritylimitState.integrityProviLeader ||
                      integritylimitState.integrityCityLeader ||
                      integritylimitState.integrityCountyLeader
                    "
                  >
                    全屏
                    <img class="item-head-full-img" src="@/assets/index/ic_full screen.png" />
                  </div>
                </template>
              </div>
              <rline></rline>
              <div class="container_shop">
                <div
                  class="shop_title line_bottom"
                  @click="goBusinessList({ name: '总数', code: 'all', ind: 0 })"
                >
                  <div class="title">
                    <p>累计完成评价总数(家)</p>
                    <img src="../../assets/image/inner_icon.png" />
                  </div>
                  <p class="shop_total">{{ formData.total }}</p>
                </div>
                <div class="shop_type line_bottom">
                  <div
                    class="shop_item"
                    @click="goBusinessList({ name: '正常经营数', code: 'normal', ind: 0})
                    "
                  >
                    <div class="shop_left">
                      <p>正常经营数(家)</p>
                      <img src="../../assets/image/inner_icon.png" />
                    </div>
                    <p class="item_total">{{ formData.normal }}</p>
                  </div>
                  <div
                    class="shop_item"
                    @click="
                      goBusinessList({ name: '停业数', code: 'stop', ind: 0 })
                    "
                  >
                    <div class="shop_left">
                      <p>停业数(家)</p>
                      <img src="../../assets/image/inner_icon.png" />
                    </div>
                    <p class="item_total">{{ formData.stop }}</p>
                  </div>
                  <div
                    class="shop_item"
                    @click="
                      goBusinessList({
                        name: '经营范围变更数',
                        code: 'change',
                        ind: 0
                      })
                    "
                  >
                    <div class="shop_left">
                      <p>经营范围变更数(家)</p>
                      <img src="../../assets/image/inner_icon.png" />
                    </div>
                    <p class="item_total">{{ formData.businessChanged }}</p>
                  </div>
                  <!-- <div class="shop_item" @click="goBusinessList({ name: '在评数', code: 'Again', ind: 0})">
                        <div class="shop_left">
                              <p>在评数(家)</p>
                              <img src="../../assets/image/inner_icon.png"/>
                        </div>
                        <p class="item_total">{{formData.again}}</p>
                  </div>-->
                </div>
                <div
                  class="item_list line_bottom"
                  @click="goBusinessList({ name: '', code: 'online', ind: 1 })"
                >
                  <div class="c_total">
                    <p class="tip3">评分达标企业</p>
                    <div class="p_total">
                      <span>{{ formData.online }}</span>
                      <span>家</span>
                    </div>
                  </div>
                  <p class="tip1">较上季度</p>
                  <div class="complin">
                    <p class="tip2" v-if="formData.pExponent === 0">持平</p>
                    <p class="tip2" v-if="formData.pExponent > 0">+{{ formData.pExponent }}</p>
                    <p class="tip2" v-if="formData.pExponent < 0">{{ formData.pExponent }}</p>
                    <img
                      class="iconSize"
                      src="../../assets/image/ic_cp@3x (1).png"
                      alt
                      v-if="formData.pExponent === 0"
                    />
                    <img
                      class="iconSize"
                      src="../../assets/image/ic_ss_b@3x.png"
                      alt
                      v-else-if="formData.pExponent > 0"
                    />
                    <img
                      class="iconSize"
                      src="../../assets/image/ic_xj_b@3x.png"
                      alt
                      v-else-if="formData.pExponent < 0"
                    />
                  </div>
                  <img src="../../assets/image/inner_icon.png" class="arrow_right" />
                </div>
                <div
                  class="item_list line_bottom"
                  @click="
                    goBusinessList({ name: '', code: 'supervision', ind: 2 })
                  "
                >
                  <div class="c_total">
                    <p class="tip3">重点关注名单</p>
                    <div class="p_total">
                      <span>{{ formData.supervision }}</span>
                      <span>家</span>
                    </div>
                  </div>
                  <p class="tip1">较上季度</p>
                  <div class="complin">
                    <p class="tip2" style="color: #2283e6" v-if="formData.zExponent === 0">持平</p>
                    <p
                      class="tip2"
                      style="color: #999999"
                      v-if="formData.zExponent > 0"
                    >+{{ formData.zExponent }}</p>
                    <p
                      class="tip2"
                      style="color: #999999"
                      v-if="formData.zExponent < 0"
                    >{{ formData.zExponent }}</p>
                    <img
                      class="iconSize"
                      src="../../assets/image/ic_cp@3x (1).png"
                      alt
                      v-if="formData.zExponent === 0"
                    />
                    <img
                      class="iconSize"
                      src="../../assets/image/ic_ss_b@3x.png"
                      alt
                      v-else-if="formData.zExponent > 0"
                    />
                    <img
                      class="iconSize"
                      src="../../assets/image/ic_xj_b@3x.png"
                      alt
                      v-else-if="formData.zExponent < 0"
                    />
                  </div>
                  <img src="../../assets/image/inner_icon.png" class="arrow_right" />
                </div>
                <div
                  class="item_list line_bottom"
                  @click="
                    goBusinessList({ name: '', code: 'blacklist', ind: 3 })
                  "
                >
                  <div class="c_total">
                    <p class="tip3">黑名单</p>
                    <div class="p_total">
                      <span>{{ formData.blacklist }}</span>
                      <span>家</span>
                    </div>
                  </div>
                  <p class="tip1">较上季度</p>
                  <div class="complin">
                    <p class="tip2" style="color: #2283e6" v-if="formData.hExponent === 0">持平</p>
                    <p
                      class="tip2"
                      style="color: #999999"
                      v-if="formData.hExponent > 0"
                    >+{{ formData.hExponent }}</p>
                    <p
                      class="tip2"
                      style="color: #999999"
                      v-if="formData.hExponent < 0"
                    >{{ formData.hExponent }}</p>
                    <img
                      class="iconSize"
                      src="../../assets/image/ic_cp@3x (1).png"
                      alt
                      v-if="formData.hExponent === 0"
                    />
                    <img
                      class="iconSize"
                      src="../../assets/image/ic_ss_b@3x.png"
                      alt
                      v-else-if="formData.hExponent > 0"
                    />
                    <img
                      class="iconSize"
                      src="../../assets/image/ic_xj_b@3x.png"
                      alt
                      v-else-if="formData.hExponent < 0"
                    />
                  </div>
                  <img src="../../assets/image/inner_icon.png" class="arrow_right" />
                </div>
              </div>
              <div
                class="spread"
                v-if="
                  integritylimitState.integrityProviLeader ||
                  integritylimitState.integrityCityLeader ||
                  integritylimitState.integrityCountyLeader
                "
              >
                <div class="s-title">已评价诚信指数得分分布</div>
                <div class="line-contain">
                  <pieChartsInfeed
                    :pieData="pieInfeedList"
                    :subtext="'达标企业总数(家)'"
                  />
                </div>
              </div>
            </div>
          </div>
          <!--//////////////////////////////////////////////////////////////////-->

          <!--//////////////////////////////////////////////////////////////////-->
          <!--考核平台-->
          <!--//////////////////////////////////////////////////////////////////-->
          <div
            class="data-card-cnt"
            v-if="
              judgelimitState.assessProviLeader ||
              judgelimitState.assessStateCityLeader
            "
          >
            <div class="data-card-head">
              <div class="data-card-head-tit">考核平台</div>
              <!-- <div class="showmore-contain" @click="openWindow('考核平台','/appraise/index')"> -->
              <div
                class="showmore-contain"
                @click="
                  !(
                    judgelimitState.assessProviLeader ||
                    judgelimitState.assessStateCityLeader
                  )
                    ? showTip()
                    : checkAppraise()
                "
              >
                <right :title="'查看更多'"></right>
              </div>
            </div>
            <div class="item mt12">
              <div class="item-head">
                <div class="item-head-title">
                  {{
                  judgelimitState.assessStateCityLeader &&
                  !judgelimitState.assessStateCityLeader
                  ? judgelimitState.cityName
                  : "全省"
                  }}考核{{
                  judgelimitState.assessStateCityLeader &&
                  !judgelimitState.assessStateCityLeader
                  ? "情况"
                  : "排名"
                  }}
                </div>
                <template v-if="globalApp.online">
                  <div class="item-head-full" @click="fullScreen(1, accessTitle)">
                    全屏
                    <img class="item-head-full-img" src="@/assets/index/ic_full screen.png" />
                  </div>
                </template>
              </div>
              <rline></rline>
              <!-- 省级 -->
              <div v-if="judgelimitState.assessProviLeader">
                <div class="ranking-wrap kaohe-ranking-wrap">
                  <tab
                    :tabList="rankingTab"
                    :name="'rankingTab'"
                    @onSwitch="rankingSwitch"
                    ref="provitabs"
                  ></tab>
                </div>
                <div style="padding-left: 12px; padding-right: 12px">
                  <rankCharts :rankList="rankList" @navToDetail="navToDetail" />
                </div>
              </div>
              <!-- 州市级 -->
              <div
                v-if="
                  !judgelimitState.assessProviLeader &&
                  judgelimitState.assessStateCityLeader
                "
              >
                <div class="item-cnt" style="position: relative">
                  <div class="item-cnt-score">
                    <scoreCard :type="1" :data="assessment"></scoreCard>
                  </div>
                  <div class="item-cnt-ranking">
                    <scoreCard :type="2" :data="ranking"></scoreCard>
                  </div>
                  <div class="vline">
                    <div class="borders-1px"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!--//////////////////////////////////////////////////////////////////-->
          <!--考核平台-->
          <!--//////////////////////////////////////////////////////////////////-->
          <!--招商引资-->
          <!--//////////////////////////////////////////////////////////////////-->
          <div class="data-card-cnt" v-if="attract">
            <div class="data-card-head">
              <div class="data-card-head-tit">招商引资</div>
              <div class="showmore-contain"  @click="openWindow('招商引资', '/investment/index')">
                <right :title="'查看更多'"></right>
              </div>
            </div>
            <div class="item mt12">
              <div class>
                <listItem
                  v-for="(item , index) in listItem"
                  :key="index"
                  :title="item.title"
                  :list="item.list"
                ></listItem>
              </div>
            </div>
          </div>
          <!--//////////////////////////////////////////////////////////////////-->
          <!--招商引资-->
          <!--//////////////////////////////////////////////////////////////////-->
          <div class="ht50"></div>
        </div>
      </div>
    </van-pull-refresh>
  </div>
</template>
<script>
// --------注： 这是一种解决方案，下面代码，没有考虑兼容，和最优实现，但是整体流程是一种还不错的方案------//

import { mapState, mapActions } from "vuex";
import api from "apis";
import apis from "../../service/modules/index";
import apig from "../../service/modules/guide";
import refundworkapi from "../../service/modules/refund";
import integrityapi from "../../service/modules/integrity";
import util from "@/utils/common";
import moment from "moment";
// start 导游use by huhui
import guideRankCharts from "../guideSystem/components/guideRankCharts";
import guideLineCharts from "../guideSystem/components/LineCharts";
// end 导游use by huhui
import pieChartsInfeed from "@/components/exponentPieChart";
import right from "../travelAgency/components/right";
import lineCharts from "comps/LineCharts";
import rline from "../travelAgency/components/line";
import rankCharts from "./components/indexRankCharts";

import scoreCard from "comps/score-card";
// import tab from 'comps/tab';
// import tab from '../../components/tab';
import tab from "../../components/custab";

import mapCharts from "comps/MapChartsCenterCircle";

import card from "../travelAgency/components/card";
import tabNav from "./components/tabNav";
import complaintApis from "../../service/modules/complaintApis";
import listItem from "../investment/components/listItem.vue";

import API from "../../service/index";
import commonAPI from "../../utils/common";
import apiRefund from '../../service/modules/refund'
import { openWindow, handleToComplainList, handleToDoList, handleToComplainDetail } from "../../utils/helper";
import IndexComplainToDo from "./components/IndexToDo/complain/IndexComplainToDo.vue";
import TouristPrivacyCard from "./components/TouristPrivacyCard.vue";

export default {
  components: {
    listItem,
    lineCharts,
    scoreCard,
    tab,
    // custab,
    rline,
    mapCharts,
    rankCharts,
    card,
    // infeed,
    pieChartsInfeed,
    guideLineCharts,
    guideRankCharts,
    right,
    tabNav,
    IndexComplainToDo,
    TouristPrivacyCard
},
  filters: {
    filt(value) {
      if (parseInt(value) < 10000) {
        return value;
      } else if (parseInt(value) >= 10000 && parseInt(value) < 100000000) {
        return parseFloat(value / 10000).toFixed(2);
      } else if (parseInt(value) >= 100000000) {
        return parseFloat(value / 100000000).toFixed(2);
      }
    },
    filtTime(value) {
      return moment(value).format("YYYY-MM-DD HH:mm:ss");
    },
    filtTime1(value) {
      return moment(value).format("YYYY-MM-DD");
    },
    filt1(str) {
      if (str > 0) {
        let duration = str;
        let day = parseInt(parseInt(parseInt(duration / 60) / 60) / 24);
        let hour = parseInt(parseInt(duration / 60) / 60) % 24;
        let minutes = parseInt(duration / 60) % 60;
        let second = parseInt(duration) % 60;
        if (day !== 0) {
          day = day + "天";
        } else {
          day = "";
        }
        if (hour !== 0) {
          hour = hour + "时";
        } else {
          hour = "";
        }
        if (minutes !== 0) {
          minutes = minutes + "分";
        } else {
          minutes = "";
        }
        if (second !== 0) {
          second = second + "秒";
        } else {
          second = "";
        }
        if (day == 0) {
          return "剩余" + day + hour + minutes + second;
        } else {
          return "剩余" + day + hour + minutes + second;
        }
      } else {
        let duration = -str;
        let day = parseInt(parseInt(parseInt(duration / 60) / 60) / 24);
        let hour = parseInt(parseInt(duration / 60) / 60) % 24;
        let minutes = parseInt(duration / 60) % 60;
        let second = parseInt(duration) % 60;
        let times = "";
        if (day == 0) {
          times += " ";
        } else {
          times += day + "天";
        }

        if (hour < 10) {
          times += "0" + hour + ":";
        } else {
          times += hour + ":";
        }
        if (minutes < 10) {
          times += "0" + minutes + ":";
        } else {
          times += minutes + ":";
        }
        if (second < 10) {
          times += "0" + second;
        } else {
          times += second;
        }
        return "超时" + times;
      }
    },
    filt2(str) {
      if (str > 0) {
        let duration = str;
        let day = parseInt(parseInt(parseInt(duration / 60) / 60) / 24);
        let hour = parseInt(parseInt(duration / 60) / 60) % 24;
        let minutes = parseInt(duration / 60) % 60;
        let second = parseInt(duration) % 60;
        if (day !== 0) {
          day = day + "天";
        } else {
          day = "";
        }
        if (hour !== 0) {
          hour = hour + "时";
        } else {
          hour = "";
        }
        if (minutes !== 0) {
          minutes = minutes + "分";
        } else {
          minutes = "";
        }
        if (second !== 0) {
          second = second + "秒";
        } else {
          second = "";
        }
        if (day == 0) {
          return "待完善" + day + hour + minutes + second;
        } else {
          return "待完善" + day + hour + minutes + second;
        }
      } else {
        let duration = -str;
        let day = parseInt(parseInt(parseInt(duration / 60) / 60) / 24);
        let hour = parseInt(parseInt(duration / 60) / 60) % 24;
        let minutes = parseInt(duration / 60) % 60;
        let second = parseInt(duration) % 60;
        let times = "";
        if (day == 0) {
          times += " ";
        } else {
          times += day + "天";
        }

        if (hour < 10) {
          times += "0" + hour + ":";
        } else {
          times += hour + ":";
        }
        if (minutes < 10) {
          times += "0" + minutes + ":";
        } else {
          times += minutes + ":";
        }
        if (second < 10) {
          times += "0" + second;
        } else {
          times += second;
        }
        return "超时" + times;
      }
    },
    filtGuideTime(value) {
      return moment(value).format("YYYY-MM-DD");
    }
  },
  data() {
    return {
      listItem: [
        {
          title: "今日待处理事项",
          list: [
            {
              name: "留言待处理",
              amount: 0
            },
            {
              name: "信息发布待审核",
              amount: 0
            },
            {
              name: "项目待审核",
              amount: 0
            }
          ]
        }
      ],
      guide_trave_Role: "",
      showShadow: false,
      isTask: false,
      ishowTab: false,
      currentListState: "complaint",
      waitList: [],
      currentRoleList: [],
      dataTab: [],
      isLoading: false,
      getAuth1: false,
      getAuth2: false,
      getAuth3: false,
      getAuth4: false,
      getAuth5: false,
      getAuth6: false,
      getAuth7: false,
      touristPrivacyList: [],
      // 导旅
      limitState: {
        guideHandler: false,
        guideLeader: false,
        travelAgencyLeader: false,
        travelAgencyHandler: false
      },
      guideType: "all",
      travelType: "all",
      // 投诉  投诉所属
      complainlimitState: {
        complaintLeader: false,
        complaintHandlder: false
      },
      // 退货
      refundlimitState: {
        refundHandler: false, // 处理
        refundLeader: false // 领导
      },

      // 诚信
      integritylimitState: {
        integrityCityGeneral: false, // 市普通用户
        integrityCityLeader: false, // 市管理
        integrityCountyGeneral: false, // 州普通用户
        integrityCountyLeader: false, // 州管理
        integrityProviLeader: false // 省领导
      },
      // 考核
      judgelimitState: {
        assessProviLeader: false, // 省级
        assessStateCityLeader: false, // 市级
        cityID: "385",
        area: "385",
        isProvPriv: "0"
      },
      guideLimitState: "", // 导游权限用户
      headHeight: "",
      travelLineChartsIndex: 0,
      compickFlag2: false,
      compickFlag: false,
      // 首页全屏饼图
      pieInfeedList: [],
      // 折线图
      lineList: [],
      lineUnit: "起",
      color: "green",
      aboutTime: "today",
      dataList: [
        {
          key: "今日",
          select: true,
          value: "today"
        },
        {
          key: "本周",
          select: false,
          value: "week"
        },
        {
          key: "本月",
          select: false,
          value: "mouth"
        },
        {
          key: "全部",
          select: false,
          value: "all"
        }
      ],
      showInfeed: false,
      assessment: {},
      ranking: {},
      supervise: {},
      black: {},
      myTab: ["全部 12", "投诉 2", "退货 12"],
      rankingTab: ["一类地区", "二类地区"],
      mapTab: ["州市数量分布", "数量变化趋势"],
      guideTravelMapTab: ["数量变化趋势", "州市排名"],
      travellevel: [
        { min: 100, color: "rgba(54,179,116,1)" },
        { min: 20, max: 99, color: "rgba(54,179,116,0.7)" },
        { min: 10, max: 19, color: "rgba(54,179,116,0.4)" },
        { min: 0, max: 9, color: "rgba(54,179,116,0.1)" }
      ],
      guidelevel: [
        { min: 1000, color: "rgba(54,179,116,1)" },
        { min: 100, max: 999, color: "rgba(54,179,116,0.7)" },
        { min: 10, max: 99, color: "rgba(54,179,116,0.4)" },
        { min: 0, max: 9, color: "rgba(54,179,116,0.1)" }
      ],
      rankList: [],
      rankClone: [],
      // ///////////////////// start 导游 by huhui
      travelGuideIndicator: true,
      showCircle: false,
      guideTabList: ["州市数量分布", "历史数量变化", "州市排名"],
      guideAllTabIndex: 4,
      guideSuperviseTabIndex: 4,
      guideBlackTabIndex: 4,
      guideData: {
        all: {
          name: "",
          data: {
            dashboard: {
              numbers: "",
              compare: "",
              price: ""
            },
            rank: {
              numbers: "",
              compare: "",
              price: ""
            },
            trendList: [],
            rankList: [],
            mapList: []
          }
        }
      },
      // //////////////////// end 导游 by huhui
      /// /////////////////////投诉
      dropDistribution: { province: "", city: "", county: "", enterprise: "" },
      //
      handling: [
        { name: "待响应", value: "0" },
        { name: "处理中", value: "0" },
        { name: "即将超时", value: "0" },
        { name: "超时未办结", value: "0" }
      ], // 投诉预警
      syntheticalWarning: [],
      emergency: [],
      handleWorkbench: [],
      areaOne: "",
      fullAdress: "",
      IfComplaintHandling: false,
      unitType: "",
      /// /////////////////////投诉

      /// /////////////////////退货
      homeWorkInfo: "",
      checked: true,
      startTime: moment(new Date().getTime()).format("YYYY-MM-DD"),
      endTime: moment(new Date().getTime()).format("YYYY-MM-DD"),
      homeInfo: "",
      citycode: "530100",
      travelCityId: "",

      /// /////////////////////退货

      /// /////////////////////旅行社
      travelTabIndex: 0,
      travelTabList: [],
      travelData: {
        all: {
          name: "",
          data: {
            dashboard: {
              numbers: "",
              compare: "",
              price: ""
            },
            rank: {
              numbers: "",
              compare: "",
              price: ""
            },
            trendList: [],
            rankList: [],
            mapList: []
          }
        }
      },
      travelAllTabIndex: 0,
      travelBlackTrend: 0,
      travelSuperviseTabIndex: 0,
      travelBlackTabIndex: 0,
      travelMap: false,
      /// /////////////////////旅行社

      /// /////////////////////诚信
      formData: {},
      curCity: "",
      /// /////////////////////诚信
      // 头部信息
      headName: "",
      headTime: "",
      organize: "",
      authList: [],
      // 待办数量
      noticeNumAppraise: 0,
      // 待办轮询
      travelCircle: null,
      complaintCircle: null,
      integrityCircle: null,
      refundCircle: null,
      guideCircle: null,
      attractCircle: null,
      scarnFlag: "",
      enterpriseId: "",
      clickIndex: 1,
      areaFlag: false, // 区县权限
      proFlag: false, // 省级权限
      cityFlag: false, // 州市权限
      appointment: false, // 分时预约
      appointmentItem: "",
      resourcesManage: false, // 旅游资源管理
      resourcesManageCode: "",
      resourcesManageAreaLevel: "",
      area: "", // 州市权限的时候的州市code码
      areaLevel: "",
      isShowNotify: true, //是否有公告权限，用来传递到考核详情页面

      attract: false, // 招商引资
      teamSupervision: false,  //团队监管


      cityName: '',// 2021年10月17日20:36:31

      isCompanyHandler: false,

      orgCode: '',

      investmentUserType: 0, //用户类型 0 ：无，1:超管，2:省文旅厅

    };
  },

  computed: {
    userInfo () {
        return this.$store.state.integrity.userInfo;
    },
    ...mapState("user", ["info"]),
    ...mapState("menu", ["menu"]),
    ...mapState("notice", ["userAreaCode"]),

    indexMenu() {
      return this.$store.getters["menu/indexMenu"];
    },
    getAuth() {
      if (
        this.getAuth1 &&
        this.getAuth2 &&
        this.getAuth3 &&
        this.getAuth4 &&
        this.getAuth5 &&
        this.getAuth6 &&
        this.getAuth7
      ) {
        return true;
      } else {
        return false;
      }
    },
    noticeNumTravel() {
      return this.$store.state.notice.noticeNumTravel;
    },
    noticeNumComplain() {
      return this.$store.state.notice.noticeNumComplain;
    },
    noticeNumIntegrity() {
      return this.$store.state.notice.noticeNumIntegrity;
    },
    noticeNumRefund() {
      return this.$store.state.notice.noticeNumRefund;
    },
    noticeNumGuide1() {
      return this.$store.state.notice.noticeNumGuide;
    },
    noticeNumAttract() {
      return this.$store.state.notice.noticeNumAttract;
    },
    noticeNumTouristPrivacy() {
      return this.$store.state.notice.noticeNumTouristPrivacy;
    }
  },

  watch: {
    userInfo (val) {
        this.cityName = val.regionName;
    }
  },

  methods: {
    /** 系统权限接口 */
    getUnionAuth() {
      api.getUnionAuth({}).then(res => {
        console.log(res, "res555555");
        if (res.ret === 0) {
          const data = res.data
          const systemPermissionList = Object.keys(data) || []
          localStorage.setItem('systemPermissionList', JSON.stringify(systemPermissionList))
          if(data.hasOwnProperty('TRAVEL_AGENCY') || data.hasOwnProperty('GUIDE')) {
            data.hasOwnProperty('TRAVEL_AGENCY') ? this.getGuideContent({type: 'TRAVEL_AGENCY'}) : this.getGuideContent({type: 'GUIDE'})
          }
          // 分时预约权限
          if (
            res.data &&
            res.data.SCENIC_MANAGE_PLATFORM &&
            res.data["SCENIC_MANAGE_PLATFORM"].length > 0
          ) {
            this.appointment = res.data.SCENIC_MANAGE_PLATFORM[0].roleCodes;
            this.appointmentItem = res.data.SCENIC_MANAGE_PLATFORM[0].areaCode;
          }
          // this.appointment = (res.data && res.data.SCENIC_MANAGE_PLATFORM && res.data.SCENIC_MANAGE_PLATFORM[0].roleCodes) || '';
          // this.appointmentItem = (res.data && res.data.SCENIC_MANAGE_PLATFORM && res.data.SCENIC_MANAGE_PLATFORM[0].areaCode) || '';
          this.resourcesManage =
            (res.data &&
              res.data.TOURI_INDUSTRY_MANAGE &&
              res.data.TOURI_INDUSTRY_MANAGE[0].roleCodes &&
              res.data.TOURI_INDUSTRY_MANAGE[0].roleCodes[0] == "wlbmgly") ||
            "";
          this.resourcesManageCode =
            (res.data &&
              res.data.TOURI_INDUSTRY_MANAGE &&
              res.data.TOURI_INDUSTRY_MANAGE[0].roleCodes &&
              res.data.TOURI_INDUSTRY_MANAGE[0].areaCode) ||
            "";
          this.resourcesManageAreaLevel =
            (res.data &&
              res.data.TOURI_INDUSTRY_MANAGE &&
              res.data.TOURI_INDUSTRY_MANAGE[0].roleCodes &&
              res.data.TOURI_INDUSTRY_MANAGE[0].areaLevel) ||
            "";
          localStorage.setItem(
            "auth",
            JSON.stringify((res.data.SCENIC_MANAGE_PLATFORM || [])[0] || "")
          );
          localStorage.setItem(
            "level",
            res.data &&
              res.data.TOURI_INDUSTRY_MANAGE &&
              res.data.TOURI_INDUSTRY_MANAGE[0].areaLevel
          ) || "";
          this.getAuth6 = true;
          // 有考核权限
          if (res.data.ASSESS && res.data.ASSESS.length > 0) {
            // this.rankingTab = []
            if (res.data.ASSESS[0].areaLevel == "1") {
              this.$set(this.judgelimitState, "assessProviLeader", true);
              this.$set(this.judgelimitState, "assessStateCityLeader", false);
              this.getuserinfo();
            } else if (res.data.ASSESS[0].areaLevel == "2") {
              this.area = res.data.ASSESS[0].areaCode;
              this.$set(this.judgelimitState, "assessStateCityLeader", true);
              this.$set(this.judgelimitState, "assessProviLeader", false);
              this.getuserinfo();
            }
            if (this.$refs.provitabs) {
              this.$refs.provitabs.switchTab(0);
            }
            this.getAssessScoreByDefault();
          }
          //投诉权限
          if (res.data.COMPLAIN && res.data.COMPLAIN.length > 0) {
            this.getAuth3 = true;
            let auth = [];
            if (res.data.COMPLAIN[0].roleCodes[0] == "leader") {
              // 领导组
              this.complainlimitState.complaintLeader = true;
              this.complainlimitState.complaintHandlder = false;
              this.getComplainUserInfo(); // 投诉模块获取用户数据
              this.getbench(); // 领导组
            }
            if (res.data.COMPLAIN[0].roleCodes[0] == "staff") {
              //处置角色
              this.complainlimitState.complaintLeader = false;
              this.complainlimitState.complaintHandlder = true;
              auth.push("complaintHandlder");
              const list = {
                value: "complaint",
                name: "投诉",
                number: 1
              };
              this.resetNav(list);
              this.getNoticeNumComplain();
              if (this.dataTab.length > 0) {
                this.getComplainUserInfo(); // 投诉模块获取用户数据
                this.getWork(); // 处置组
                if (this.currentListState === "complaint") {
                  this.getComplaint(); // 待办先不管接口没做 ----- 202/07/08 15:14
                }
              }
            }
            if (this.complainlimitState.detail) {
              auth.push(this.complainlimitState.detail);
            }
            this.authList.push({ name: "投诉", content: [], auth: auth });
            localStorage.setItem("authList", JSON.stringify(this.authList));
          }

          //招商引资权限
          if (
            res.data.ATTRACT_INVESTMENT &&
            res.data.ATTRACT_INVESTMENT.length > 0 &&
            ['governmentStacff', 'superUser', 'supervision'].includes(res.data.ATTRACT_INVESTMENT[0].roleCodes[0])
            ){
            if (res.data.ATTRACT_INVESTMENT[0].areaCode && res.data.ATTRACT_INVESTMENT[0].areaCode == "530000") {
              this.investmentUserType = 2;
            }
            if (res.data.ATTRACT_INVESTMENT[0].roleCodes && res.data.ATTRACT_INVESTMENT[0].roleCodes.includes('superUser')) {
              this.investmentUserType = 1;
            }
            this.getUserAreaCodeNum(
              res.data.ATTRACT_INVESTMENT[0].areaCode
                ? res.data.ATTRACT_INVESTMENT[0].areaCode
                : 0
            );
            const list = {
              value: "attract",
              name: "招商引资",
              number: 7
            };
            localStorage.setItem('attractRole', res.data.ATTRACT_INVESTMENT[0].roleCodes[0])
            this.$store.commit('investment/setGovernmentStacff', res.data.ATTRACT_INVESTMENT[0].roleCodes[0] === 'governmentStacff')
            this.resetNav(list);
            this.getNoticeNumAttract();
            this.attract = true;
            // if (this.dataTab.length > 0 && this.currentListState == "attract") {
            this.areaLevel = res.data.ATTRACT_INVESTMENT[0].areaLevel;
            if (this.dataTab.length > 0) {
              this.getAttract();
              console.log(1)
            }

            console.log('招商角色', localStorage.getItem('attractRole'))
          }

          // 退货权限
          if (res.data.REFUND && res.data.REFUND.length > 0) {
            const handlerReg = /[hH]andler$/;
            const leaderReg = /[lL]eader$/;
            const role = res.data.REFUND[0].roleCodes[0];
            this.refundlimitState = {
              refundHandler: handlerReg.test(role),
              refundLeader: leaderReg.test(role)
            };
            console.log('refundlimitState', this.refundlimitState)
            let auth = [];
            if (this.refundlimitState.refundHandler) {
              const list = {
                value: "refund",
                name: "退货",
                number: 2
              };

              this.resetNav(list);
              auth.push("refundHandler");
              if (!util.getJsonLocal("configList")) {
                this.getType();
              }
            }
            if (this.refundlimitState.refundLeader) {
              auth.push("refundLeader");
              if (!util.getJsonLocal("configList")) {
                this.getType();
              }
            }
            if (this.refundlimitState.refundHandler) {
              this.getNoticeNumRefund();
              auth.push("refundHandler");
              // 退货
              if (this.dataTab.length > 0) {
                refundworkapi.currentUser().then(res => {
                  if (res.ret === 0) {
                    this.$store.commit("refund/getUserInfo", res.data);
                    this.isCompanyHandler = (res.data && res.data.roleList[0] == 'CompanyHandler')

                    this.city = res.data.regionName;
                    this.citycode = res.data.regionCode;
                    this.selectCode = res.data.regionCode;
                    this.cityName = res.data.regionName;
                    if (
                      this.dataTab.length == 1 &&
                      this.currentListState == "refund"
                    ) {
                      this.getRefund();
                    } else {
                      if (
                        this.dataTab.length > 1 &&
                        this.currentListState == "refund"
                      ) {
                        this.getRefund();
                      }
                    }
                  }
                });
              }
            }
            if (this.refundlimitState.refundLeader) {
              auth.push("refundLeader");
              refundworkapi.currentUser().then(res => {
                if (res.ret === 0) {
                  this.$store.commit("refund/getUserInfo", res.data);
                  this.isCompanyHandler = (res.data && res.data.roleList[0] == 'CompanyHandler')
                  console.log(this.isCompanyHandler, '6666')
                  this.city = res.data.regionName;
                  this.citycode = res.data.regionCode;
                  this.selectCode = res.data.regionCode;
                  this.cityName = res.data.regionName;
                  this.getType();
                  // 退货
                  this.getInitTime(this.startTime, this.endTime);
                  this.getTrend(1);

                  // 退货
                }
              });
            }
            if (this.refundlimitState.detail) {
              auth.push(this.refundlimitState.detail);
            }

            this.authList.push({ name: "退货", content: [], auth: auth });
            localStorage.setItem("authList", JSON.stringify(this.authList));
          }
          // 团队监管
          if (res.data && res.data.TEAM_SUPERVISION && res.data.TEAM_SUPERVISION.length > 0) {
            const resTeamSpv = res.data.TEAM_SUPERVISION;
            this.teamSupervision = resTeamSpv[0].roleCodes[0] === 'teamSupervisionLeader'
          }

        }
      });
    },
    toTime() {
      window.yyn.invokeJSB(
        "openWindow",
        {
          openUrl: `${
            this.globalApp.getSystemInfo().host
          }web/#/appointment/home?areaCode=${this.appointmentItem}`,
          isFullScreen: 0,
          setTitle: "景区预约",
          needLoading: 1,
        },
        cb => {
          console.log(cb, "callback");
        }
      );
    },
    toResourcesManage() {
      // this.$router.push({
      //   path: `/resourcesManage/home?resourcesManageCode=${this.resourcesManageCode}&resourcesManageAreaLevel=${this.resourcesManageAreaLevel}`
      // })
      window.yyn.invokeJSB(
        "openWindow",
        {
          openUrl: `${
            this.globalApp.getSystemInfo().host
          }web/#/resourcesManage/home?resourcesManageCode=${
            this.resourcesManageCode
          }&resourcesManageAreaLevel=${this.resourcesManageAreaLevel}`,
          isFullScreen: 0,
          setTitle: "旅游资源管理",
          needLoading: 1
        },
        cb => {
          console.log(cb, "callback");
        }
      );
    },
    getuserinfo() {
      API.getUserInfo({}).then(res => {
        if (res.ret == 0) {
          const hostoryAuth = commonAPI.getJsonLocal(
            "appraiseNewLocalauthority"
          );
          if (hostoryAuth) {
            commonAPI.removeJsonLocal("appraiseNewLocalauthority");
          }
          commonAPI.setJsonLocal("appraiseNewLocalauthority", res.data);
          if (res.data) {
            this.areaLevel = res.data.areaLevel;
            console.log("权限值:", res.data);
            if (
              res.data.userRole === "audit" ||
              res.data.userRole === "manager" ||
              res.data.userRole === "complaint" ||
              res.data.userRole === "experSatisf" ||
              res.data.userRole === "touristCounter"
            ) {
              this.isShowNotify = false;
            } else {
              this.isShowNotify = true;
            }
          }
        }
      });
    },
    checkAppraise() {
      // 在这之前 需要 判断 有没有点亮图标
      // !(judgelimitState.assessProviLeader || judgelimitState.assessStateCityLeader)?showTip():openWindow('考核平台','/appraise/provincial')
      const params = commonAPI.getJsonLocal("onlyonlyreadone");
      if (params) {
        commonAPI.removeJsonLocal("onlyonlyreadone");
      }
      // if (this.areaLevel === "1") {
      //   this.openWindow("考核平台", "/appraise/index");
      // } else if (this.areaLevel === "2") {
      //   this.openWindow("考核平台", "/appraise/detail");
      // }
      this.openWindow("考核平台", '/appraise/index');
    },
    ...mapActions("account", ["authCheckTioPermission"]),
    ...mapActions("notice", ["getUserAreaCodeNum"]),
    ...mapActions("investment", [
      "getTotalUndone",
      "getPublicUnDone",
      "getVerifying",
      "setInvestmentMessageList",
      "getAttractList",
      "getBusinessList",
      "getContactUsList",
      "getCompanyPartnerList",
      "getFindOperatingConfigList",
      "getProjectList",
      "getTotalUndone",
      "getPublicUnDone",
      "getVerifying"
    ]),
    // 提示
    getTask(index) {
      this.ishowTab = !this.ishowTab;
      setTimeout(() => {
        this.showShadow = !this.showShadow;
      }, 600);
      if (index == "1") {
        setTimeout(() => {
          window.yyn.invokeJSB(
            "openWindow",
            {
              openUrl: "yyngov://scan",
              isFullScreen: 0,
              setTitle: "",
              needLoading: 1
            },
            cb => {
              // console.log(cb, "callback");
            }
          );
        }, 700);
      } else if (index == "2") {
        setTimeout(() => {
          window.yyn.invokeJSB(
            "openWindow",
            {
              openUrl: `${
                this.globalApp.getSystemInfo().host
              }web/#/integrity/businessList?name=${encodeURIComponent(
                "总数"
              )}&code=all&ind=0&cityName=${encodeURIComponent(
                this.integritylimitState.regionName
              )}`,
              isFullScreen: 0,
              setTitle: "",
              needLoading: 1
            },
            cb => {
              // console.log(cb, "callback");
            }
          );
        }, 700);
      } else if (index == "3") {
        setTimeout(() => {
          window.yyn.invokeJSB(
            "openWindow",
            {
              openUrl: `${
                this.globalApp.getSystemInfo().host
              }web/#/guide/guideList?tabIndex=0&cityId=${
                this.guideLimitState.city
              }&cityName=${encodeURIComponent(
                this.guideLimitState.project
              )}&cityIndex=1&selfCityId=${this.guideLimitState.city}`,
              isFullScreen: 0,
              setTitle: "",
              needLoading: 1
            },
            cb => {
              // console.log(cb, "callback");
            }
          );
        }, 700);
      }else if (index == "4") {
        setTimeout(() => {
          window.yyn.invokeJSB(
              "openWindow",
              {
                openUrl: `${
                    this.globalApp.getSystemInfo().host
                }h5/team-supervision.module/#/`,
                isFullScreen: 0,
                setTitle: "",
                needLoading: 1
              },
              cb => {
                // console.log(cb, "callback");
              }
          );
        }, 700);
      }
    },
    myPending(item) {
      console.log(item);
      this.currentListState = item.value;
      this.waitList = [];
      if (item.value == "complaint") {
        // 投诉的接口拉取
        this.getComplaint();
      } else if (item.value == "refund") {
        // 退货的接口拉取
        this.getRefund();
      } else if (item.value == "guide") {
        // 导游接口拉取
        this.getGuide();
      } else if (item.value == "trave") {
        // 旅行社接口拉取
        this.getTrava();
      } else if (item.value == "inner") {
        // 旅行社接口拉取
        this.getInner();
      } else if (item.value == "attract") {
        //招商引资接口拉取
        this.getAttract();
      }  else if (item.value == "touristPrivacy") {
        //团队监管
        this.getTouristPrivacyLimits();
      }
    },
    // 投诉待办
    getComplaint() {
      if (this.complainlimitState.complaintHandlder) {
        // 有用户权限
        complaintApis.common.getNewWaitHandleList({
          pageIndex: 1,
          pageSize: 5,
        }).then(res => {
          if (res.ret == 0) {
            if (res.data && res.data.datas.length > 0) {
              this.waitList = res.data.datas;
              if (this.currentListState == "complaint") {
                this.isTask = false;
              }
            } else {
              if (this.currentListState == "complaint") {
                this.isTask = true;
              }
            }
          } else {
            if (this.currentListState == "complaint") {
              this.isTask = true;
            }
          }
        });
      } else {
      }
    },
    // 退货待办
    getRefund() {
      if (this.refundlimitState.refundHandler) {
        // 退货处理组
        const data = {
          pageIndex: 1,
          status: -17,
          pageSize: 80,
          orderBy: 'UTD'
        };
        // apis.todoList(data).then(res => {
        apiRefund.returnList(data).then(res => {
          if (res.ret == 0) {
            if (res.data && res.data.list.length > 0) {
              this.waitList = res.data.list;
              if (this.currentListState == "refund") {
                this.isTask = false;
              }
            } else {
              if (this.currentListState == "refund") {
                this.isTask = true;
              }
            }
          } else {
            if (this.currentListState == "refund") {
              this.isTask = true;
            }
          }
        });
      } else {
      }
    },
    // 导游待办
    getGuide() {
      apis.todoGuideList({ p: 1, pageSize: 80, status: 0 }).then(res => {
        if (res.ret == 0) {
          if (res.data && res.data.list.length > 0) {
            this.waitList = res.data.list;
            if (this.currentListState == "guide") {
              this.isTask = false;
            }
          } else {
            if (this.currentListState == "guide") {
              this.isTask = true;
            }
          }
        } else {
          if (this.currentListState == "guide") {
            this.isTask = true;
          }
        }
      });
    },
    // 旅行社待办
    getTrava() {
      apis
        .todoTravelList({ p: 1, pageSize: 80, status: 0, type: 1 })
        .then(res => {
          if (res.ret == 0) {
            if (res.data && res.data.list.length > 0) {
              this.waitList = res.data.list;
              console.log("---------------------------------------");
              console.log(res.data.list);
              if (this.currentListState == "trave") {
                this.isTask = false;
              }
            } else {
              if (this.currentListState == "trave") {
                this.isTask = true;
              }
            }
          } else {
            if (this.currentListState == "trave") {
              this.isTask = true;
            }
          }
        });
    },
    // 诚信待办
    getInner() {
      // this.waitList=[];
      let parm = {
        pageIndex: 1,
        pageSize: 200
      };
      apis.todoInnerList(parm).then(res => {
        console.log(res, "诚信");
        if (res.ret == 0) {
          if (res.data && res.data.list.length > 0) {
            this.waitList = res.data.list;
            if (this.currentListState == "inner") {
              this.isTask = false;
            }
          } else {
            if (this.currentListState == "inner") {
              this.isTask = true;
            }
          }
        } else {
          if (this.currentListState == "inner") {
            this.isTask = true;
          }
        }
      });
    },
    getAttract() {
      console.log("招商引资拉取列表");

      // 列表页和统计页，除了超级管理员外传advisoryObjectCode
      let messageListParams = {
        statue: 1,
        size: 50,
        current: 1
      }
      if (this.investmentUserType != 1) {
        messageListParams.advisoryObjectCode = this.orgCode;
      }
      this.waitList = [];
      // 如果是州市不展示待审核项目及待发布信息
      // 如果不是监管角色才获取列表
       if (localStorage.getItem('attractRole') !== 'supervision') {
         console.log('不是监管！！！--获取待办列表')
         if (this.areaLevel && this.areaLevel == 2) {
            Promise.all([
             this.setInvestmentMessageList(messageListParams),
           ]).then(res => {
             res.forEach((item, index) => {
               item.records.forEach(element => {
                 element.attractType = index;
               });
               this.waitList = this.waitList.concat(item.records);
             });
             this.$store.commit("notice/setNoticeNumAttract", this.waitList.length);
             if (this.waitList.length > 0) {
               if (this.currentListState == "attract") {
                 this.isTask = false;
               }
             } else {
               if (this.currentListState == "attract") {
                 this.isTask = true;
               }
             }
           })
         } else {
           Promise.all([
             this.setInvestmentMessageList(messageListParams),
             this.getAttractList({
               statue: 10,
               size: 50,
               current: 1
             }),
             this.getBusinessList({
               statue: 10,
               size: 50,
               current: 1
             }),
             this.getContactUsList({
               size: 50,
               current: 1,
               statue: 10
             }),
             this.getCompanyPartnerList({
               size: 50,
               current: 1,
               statue: 10
             }),
             this.getFindOperatingConfigList({
               size: 50,
               current: 1,
               status: 0
             }),
             this.getProjectList({
               status: 1,
               size: 50,
               current: 1
             })
           ]).then(res => {
             let total = 0
             res.forEach((item, index) => {
               item.records.forEach(element => {
                 element.attractType = index;
               });
               total += item.records.length
               if (this.currentListState == "attract") {
                 this.waitList = this.waitList.concat(item.records);
               }
             });

             this.$store.commit("notice/setNoticeNumAttract", total);
             if (this.waitList.length > 0) {
               if (this.currentListState == "attract") {
                 this.isTask = false;
               }
             } else {
               if (this.currentListState == "attract") {
                 this.isTask = true;
               }
             }
           })

         }
       }
      // this.$store.dispatch("notice/getAttractNum", this.waitList.length);

      let params = {};

      if (this.investmentUserType != 1) {
        params.advisoryObjectCode = this.orgCode;
      }
      Promise.all([
        this.getTotalUndone(params),
        this.getPublicUnDone(),
        this.getVerifying()
      ]).then(res => {
        if (localStorage.getItem('attractRole') !== 'supervision') {
          if (this.areaLevel && this.areaLevel == 2) {
            this.listItem = [
              {
                title: "今日待处理事项",
                list: [
                  {
                    name: "留言待处理",
                    amount: 0
                  }
                ]
              }
            ]
            this.listItem[0].list[0].amount = res[0] ? res[0] : 0;
          } else {
            this.listItem[0].list[0].amount = res[0] ? res[0] : 0;
            this.listItem[0].list[1].amount = res[1] ? res[1] : 0;
            this.listItem[0].list[2].amount = res[2] ? res[2] : 0;
          }
        }
      });
      // if (this.currentListState == "attract") {
      //   this.isTask = true;
      // }
    },

    goRefundDetail(item) {
      util.setJsonLocal("flowId", item.flowId);
      window.yyn.invokeJSB(
        "openWindow",
        {
          openUrl: `${
            this.globalApp.getSystemInfo().host
          }web/#/refund/refundDetail?flowId=${item.flowId}`,
          isFullScreen: 0,
          setTitle: "退货详情",
          needLoading: 1
        },
        cb => {
          console.log(cb, "callback");
        }
      );
    },
    goComplaintDetail(item) {
      util.setJsonLocal("item", item);
      console.log('-----goComplaintDetail-------')
      console.log(item)
      switch (item.waitHandleType) {
        case "depCompanyHandle": // 待处理（部门/企业）
          util.setJsonLocal("buttonType", "depCompanyHandle");
          util.setJsonLocal("waitResponse", "depCompanyHandle");
          break;
        case "centerAccepted": // 待响应
          util.setJsonLocal("buttonType", "centerAccepted");
          util.setJsonLocal("waitResponse", "centerAccepted");
          break;
        case "centerHandle": // 待处理，指挥中心
          util.setJsonLocal("buttonType", "centerHandle");
          util.setJsonLocal("waitResponse", "centerHandle");
          break;
        case "splitOrderReportIng": // 拆弹待审核
          util.setJsonLocal("buttonType", "splitOrderReportIng");
          util.setJsonLocal("waitResponse", "splitOrderReportIng");
          break;
        case "reportIng": // 上报待审核
          util.setJsonLocal("buttonType", "reportIng");
          util.setJsonLocal("waitResponse", "reportIng");
          localStorage.setItem("fromPath", "home");
          break;
        case "appealReportIng": // 申诉待审核
          util.setJsonLocal("buttonType", "appealReportIng");
          util.setJsonLocal("waitResponse", "appealReportIng");
          break;
        case "supplementInformation": // 结果待完善
          util.setJsonLocal("buttonType", "supplementInformation");
          util.setJsonLocal("waitResponse", "supplementInformation");
          break;
      }
      handleToComplainDetail({
        isSupervise: !!item.superviseNumber,
        title: '',
        ...item,
      })
      // if (item.waitHandleType == "supplementInformation") {
      //   window.yyn.invokeJSB(
      //     "openWindow",
      //     {
      //       openUrl: `${
      //         this.globalApp.getSystemInfo().host
      //       }web/#/complaint/resultDetail?subId=${item.subId}&id=${item.id}`,
      //       isFullScreen: 0,
      //       setTitle: "结果完善",
      //       needLoading: 1
      //     },
      //     cb => {
      //       console.log(cb, "callback");
      //     }
      //   );
      // } else if (item.waitHandleType != "superviseHandle") {
      //   this.$store.commit("complaint/setCheckList", false);
      //   window.yyn.invokeJSB(
      //     "openWindow",
      //     {
      //       openUrl: `${
      //         this.globalApp.getSystemInfo().host
      //       }web/#/complaint/detailList`,
      //       isFullScreen: 0,
      //       setTitle: "投诉详情",
      //       needLoading: 1
      //     },
      //     cb => {
      //       console.log(cb, "callback");
      //     }
      //   );
      // } else {
      //   // 督办待回复
      //   util.setJsonLocal("waitResponse", "superviseHandle");
      //   window.yyn.invokeJSB(
      //     "openWindow",
      //     {
      //       openUrl: `${this.globalApp.getSystemInfo().host}web/#/todoDetails`,
      //       isFullScreen: 0,
      //       setTitle: "督办件待回复",
      //       needLoading: 1
      //     },
      //     cb => {
      //       console.log(cb, "callback");
      //     }
      //   );
      // }
    },
    goInnerDetail(item) {
      // <!-- taskType: 1 - 评分待审核， 2 - 评分任务待编辑， 3 - 待线下整改通知， 4 - 待重新评分， 30 - 退出重点关注待审核， 32 - 退出重点关注审核不通过， 33 - 重点关注企业待评分， 34 - 黑名单预警企业待评分 -->
      if (item.taskType == 1) {
        // 待审核
        // this.$router.push({
        //     path: '/integrity/toAudited',
        //     query: {
        //         id: item.id,
        //         taskId: item.taskId
        //     }
        // });
        window.yyn.invokeJSB(
          "openWindow",
          {
            openUrl: `${
              this.globalApp.getSystemInfo().host
            }web/#/integrity/toAudited?id=${item.id}&taskId=${item.taskId}`,
            isFullScreen: 0,
            setTitle: "任务详情",
            needLoading: 1
          },
          cb => {
            console.log(cb, "callback");
          }
        );
      } else if (item.taskType == 2) {
        // 评分任务待编辑
        // this.$router.push({
        //     path: '/integrity/toBeEdited',
        //     query: {
        //         id: item.id,
        //         taskId: item.taskId
        //     }
        // });
        window.yyn.invokeJSB(
          "openWindow",
          {
            openUrl: `${
              this.globalApp.getSystemInfo().host
            }web/#/integrity/toBeEdited?id=${item.id}&taskId=${item.taskId}`,
            isFullScreen: 0,
            setTitle: "待办详情",
            needLoading: 1
          },
          cb => {
            console.log(cb, "callback");
          }
        );
      } else if (item.taskType == 3) {
        // 待办详情待线下整改
        // this.$router.push({
        //     path: '/integrity/toBeRectified',
        //     query: {
        //         id: item.id,
        //         taskId: item.taskId
        //     }
        // });
        window.yyn.invokeJSB(
          "openWindow",
          {
            openUrl: `${
              this.globalApp.getSystemInfo().host
            }web/#/integrity/toBeRectified?id=${item.id}&taskId=${item.taskId}`,
            isFullScreen: 0,
            setTitle: "待办详情",
            needLoading: 1
          },
          cb => {
            console.log(cb, "callback");
          }
        );
      } else if (item.taskType == 4) {
        // 待办详情待重新评分
        // this.$router.push({
        //     path: '/integrity/toBeRegraded',
        //     query: {
        //         id: item.id,
        //         taskId: item.taskId
        //     }
        // });
        window.yyn.invokeJSB(
          "openWindow",
          {
            openUrl: `${
              this.globalApp.getSystemInfo().host
            }web/#/integrity/toBeRegraded?id=${item.id}&taskId=${item.taskId}`,
            isFullScreen: 0,
            setTitle: "待办详情",
            needLoading: 1
          },
          cb => {
            console.log(cb, "callback");
          }
        );
      } else if (item.taskType == 30) {
        // V1.4 首页-退出重点关注待审核
        // this.$router.push({
        //     path: 'integrity/exitSupervision',
        //     query: {
        //         id: item.id,
        //         taskId: item.taskId
        //     }
        // });
        window.yyn.invokeJSB(
          "openWindow",
          {
            openUrl: `${
              this.globalApp.getSystemInfo().host
            }web/#/integrity/exitSupervision?id=${item.id}&taskId=${
              item.taskId
            }`,
            isFullScreen: 0,
            setTitle: "任务详情",
            needLoading: 1
          },
          cb => {
            console.log(cb, "callback");
          }
        );
      } else if (item.taskType == 31) {
        // 退出重点关注审核不通过
        // this.$router.push({
        //     path: 'integrity/examine',
        //     query: {
        //         id: item.id,
        //         taskId: item.taskId
        //     }
        // });
        window.yyn.invokeJSB(
          "openWindow",
          {
            openUrl: `${
              this.globalApp.getSystemInfo().host
            }web/#/integrity/examine?id=${item.id}&taskId=${item.taskId}`,
            isFullScreen: 0,
            setTitle: "任务详情",
            needLoading: 1
          },
          cb => {
            console.log(cb, "callback");
          }
        );
      } else if (item.taskType == 32) {
        // 重点关注企业待评分
        // this.$router.push({
        //     path: 'integrity/earlyWarning',
        //     query: {
        //         id: item.id,
        //         taskId: item.taskId,
        //         type: 'toScore'
        //     }
        // })
        window.yyn.invokeJSB(
          "openWindow",
          {
            openUrl: `${
              this.globalApp.getSystemInfo().host
            }web/#/integrity/earlyWarning?id=${item.id}&taskId=${
              item.taskId
            }&type=toScore`,
            isFullScreen: 0,
            setTitle: "任务详情",
            needLoading: 1
          },
          cb => {
            console.log(cb, "callback");
          }
        );
      } else if (item.taskType == 33) {
        // 黑名单预警企业待评分
        // this.$router.push({
        //     path: 'integrity/earlyWarning',
        //     query: {
        //         id: item.id,
        //         taskId: item.taskId,
        //         type: 'warning'
        //     }
        // })
        window.yyn.invokeJSB(
          "openWindow",
          {
            openUrl: `${
              this.globalApp.getSystemInfo().host
            }web/#/integrity/earlyWarning?id=${item.id}&taskId=${
              item.taskId
            }&type=warning`,
            isFullScreen: 0,
            setTitle: "任务详情",
            needLoading: 1
          },
          cb => {
            console.log(cb, "callback");
          }
        );


      } else if (item.taskType == 21 || item.taskType == 22) {
        window.yyn.invokeJSB(
          "openWindow",
          {
            openUrl: `${
              this.globalApp.getSystemInfo().host
            }web/#/agentDetails?id=${item.id}&taskId=${
              item.taskId
            }`,
            isFullScreen: 0,
            setTitle: "待办详情",
            needLoading: 1
          },
          cb => {
            console.log(cb, "callback");
          }
        );
      }
    },
    goAttractDetail(item) {

      if (item.attractType == 0) {
        // this.$router.push({
        //   path: "/investment/messageDetails",
        //   query: { id: item.id }
        // });
        window.yyn.invokeJSB(
          "openWindow",
          {
            openUrl: `${
              this.globalApp.getSystemInfo().host
            }web/#/investment/messageDetails?id=${item.id}`,
            isFullScreen: 0,
            setTitle: "留言详情",
            needLoading: 1
          },
          cb => {
            console.log(cb, "callback");
          }
        );
      } else if (item.attractType == 1) {
        // this.$router.push({
        //   path: "/investment/inforDetails",
        //   query: {
        //     id: item.id,
        //     category: item.attractType,
        //     infoId: item.infoId
        //   }
        // });
        window.yyn.invokeJSB(
          "openWindow",
          {
            openUrl: `${
              this.globalApp.getSystemInfo().host
            }web/#/investment/inforDetails?id=${item.id}&category=${
              item.attractType
            }&infoId=${item.infoId}`,
            isFullScreen: 0,
            setTitle: "信息详情",
            needLoading: 1
          },
          cb => {
            console.log(cb, "callback");
          }
        );
      } else if (item.attractType == 2 || item.attractType == 3 || item.attractType == 4 || item.attractType == 5) {
        // this.$router.push({
        //   path: "/investment/inforDetails",
        //   query: { id: item.id, category: item.attractType }
        // });
        window.yyn.invokeJSB(
          "openWindow",
          {
            openUrl: `${
              this.globalApp.getSystemInfo().host
            }web/#/investment/inforDetails?id=${item.id}&category=${
              item.attractType
            }`,
            isFullScreen: 0,
            setTitle: "信息详情",
            needLoading: 1
          },
          cb => {
            console.log(cb, "callback");
          }
        );
      } else if (item.attractType == 6) {
        // this.$router.push({
        //   path: "/investment/projectDetails",
        //   query: { id: item.id }
        // });
        window.yyn.invokeJSB(
          "openWindow",
          {
            openUrl: `${
              this.globalApp.getSystemInfo().host
            }web/#/investment/projectDetails?id=${item.id}`,
            isFullScreen: 0,
            setTitle: "项目详情",
            needLoading: 1
          },
          cb => {
            console.log(cb, "callback");
          }
        );
      }
    },
     goAttractDetail(item) {

      if (item.attractType == 0) {
        // this.$router.push({
        //   path: "/investment/messageDetails",
        //   query: { id: item.id }
        // });
        window.yyn.invokeJSB(
          "openWindow",
          {
            openUrl: `${
              this.globalApp.getSystemInfo().host
            }web/#/investment/messageDetails?id=${item.id}`,
            isFullScreen: 0,
            setTitle: "留言详情",
            needLoading: 1
          },
          cb => {
            console.log(cb, "callback");
          }
        );
      } else if (item.attractType == 1) {
        // this.$router.push({
        //   path: "/investment/inforDetails",
        //   query: {
        //     id: item.id,
        //     category: item.attractType,
        //     infoId: item.infoId
        //   }
        // });
        window.yyn.invokeJSB(
          "openWindow",
          {
            openUrl: `${
              this.globalApp.getSystemInfo().host
            }web/#/investment/inforDetails?id=${item.id}&category=${
              item.attractType
            }&infoId=${item.infoId}`,
            isFullScreen: 0,
            setTitle: "信息详情",
            needLoading: 1
          },
          cb => {
            console.log(cb, "callback");
          }
        );
      } else if (item.attractType == 2 || item.attractType == 3 || item.attractType == 4 || item.attractType == 5) {
        // this.$router.push({
        //   path: "/investment/inforDetails",
        //   query: { id: item.id, category: item.attractType }
        // });
        window.yyn.invokeJSB(
          "openWindow",
          {
            openUrl: `${
              this.globalApp.getSystemInfo().host
            }web/#/investment/inforDetails?id=${item.id}&category=${
              item.attractType
            }`,
            isFullScreen: 0,
            setTitle: "信息详情",
            needLoading: 1
          },
          cb => {
            console.log(cb, "callback");
          }
        );
      } else if (item.attractType == 6) {
        // this.$router.push({
        //   path: "/investment/projectDetails",
        //   query: { id: item.id }
        // });
        window.yyn.invokeJSB(
          "openWindow",
          {
            openUrl: `${
              this.globalApp.getSystemInfo().host
            }web/#/investment/projectDetails?id=${item.id}`,
            isFullScreen: 0,
            setTitle: "项目详情",
            needLoading: 1
          },
          cb => {
            console.log(cb, "callback");
          }
        );
      }
    },
    // 导游跳详情
    getJumpTo(val) {
      if (val.type === 6) {
        // this.$router.push(`/guide/info?guideId=${val.correlation_id}&isBlacklist=${val.black}&isSupervise=${val.emphasis}&disciplineType=${val.discipline}&back=noback`)
        window.yyn.invokeJSB(
          "openWindow",
          {
            openUrl: `${
              this.globalApp.getSystemInfo().host
            }web/#/guide/info?guideId=${val.correlation_id}&isBlacklist=${
              val.black
            }&isSupervise=${val.emphasis}&disciplineType=${
              val.discipline
            }&back=noback`,
            isFullScreen: 0,
            setTitle: "导游详情",
            needLoading: 1
          },
          cb => {
            console.log(cb, "callback");
          }
        );
      } else if (val.type === 4) {
        // 全国惩戒
        window.yyn.invokeJSB(
          "openWindow",
          {
            openUrl: `${
              this.globalApp.getSystemInfo().host
            }web/#/guide/exitBlacklist?type=quiteAllBlacklist&guideBlackId=${
              val.related_id
            }&guideId=${val.correlation_id}&back=noback`,
            isFullScreen: 0,
            setTitle: "",
            needLoading: 1
          },
          cb => {
            console.log(cb, "callback");
          }
        );
      } else if (val.type === 2) {
        // 黑名单
        window.yyn.invokeJSB(
          "openWindow",
          {
            openUrl: `${
              this.globalApp.getSystemInfo().host
            }web/#/guide/exitBlacklist?type=quiteBlacklist&guideId=${
              val.correlation_id
            }&guideBlackId=${val.related_id}&back=noback`,
            isFullScreen: 0,
            setTitle: "",
            needLoading: 1
          },
          cb => {
            console.log(cb, "callback");
          }
        );
      }
    },
    // 旅行社跳详情
    jumpTravle(val) {
      if (val.type === 1) {
        util.setJsonLocal("travelHistoryList", val);
        this.$router.push(
          `/travelAgency/info?id=${val.related_id}&back=noback`
        );
        // window.yyn.invokeJSB(
        //     'openWindow', {
        //         openUrl: `${this.globalApp.getSystemInfo().host}web/#/travelAgency/info?id=${val.correlation_id}&back=noback`,
        //         isFullScreen: 0,
        //         setTitle: '旅行社详情',
        //         needLoading: 1
        //     },
        //     cb => {
        //         console.log(cb, 'callback');
        //     }
        // );
      }
    },
    onLoad() {},
    checkList() {
      // 待办
      this.clickIndex = 1;
    },
    watchList() {
      // 统计数据
      this.clickIndex = 2;
      this.resetWatchBoad();
    },
    resetNav(obj) {
      let status = this.dataTab.reduce((cur, ele) => {
        if (ele.value == obj.value) {
          cur += 1;
        }
        return cur;
      }, 0);
      if (this.dataTab.length > 0 && status == 0) {
        this.dataTab.push(obj);
        this.currentListState = obj.value;
        if (this.dataTab.length > 0) {
          this.dataTab.sort((a, b) => {
            return a.number - b.number;
          });
        }
        if (this.dataTab.length > 1) {
          this.currentListState = this.dataTab[0].value;
        }
      } else if (status > 0) {
        return false;
      } else {
        this.dataTab.push(obj);
        this.currentListState = obj.value;
        if (this.dataTab.length > 0) {
          this.dataTab.sort((a, b) => {
            return a.number - b.number;
          });
        }

        if (this.dataTab.length > 1) {
          this.currentListState = this.dataTab[0].value;
        }
      }
    },
    onRefresh() {
      // 刷新用户权限信息
      this.travelMap = false;
      this.authList = [];
      // this.dataTab=[];
      let ts = this;

      setTimeout(() => {
        ts.isLoading = false;

        if (this.clickIndex == 2) {
          // 看板数据刷新
          ts.resetWatchBoad();
        } else {
          // 待办刷新
          ts.reset();
        }
      }, 500);
    },
    travelVantChange() {
      this.showCircle = false;
    },
    guideVantChange() {
      this.showCircle = false;
    },

    /** 首页权限下的字段 */
    getIndexInfo() {
      document.title = "工作台";
      apis.getIndexUserInfo().then(res => {
        if (res.ret === 0) {
          this.$store.dispatch("guide/setUser", res.data); // 设置搜索记录
          if (res.data.name.length > 7) {
            this.headName = res.data.name.slice(0, 7) + "...";
          } else {
            this.headName = res.data.name + "，";
          }
          this.headTime = "";
          let hour = new Date().getHours();
          if (hour < 6) {
            this.headTime = "凌晨好";
          } else if (hour < 9) {
            this.headTime = "早上好";
          } else if (hour < 12) {
            this.headTime = "上午好";
          } else if (hour < 14) {
            this.headTime = "中午好";
          } else if (hour < 17) {
            this.headTime = "下午好";
          } else if (hour < 19) {
            this.headTime = "傍晚好";
          } else if (hour < 22) {
            this.headTime = "晚上好";
          } else {
            this.headTime = "夜里好";
          }
          if (res.data) {
            this.organize = res.data.orgName;
            this.orgCode = res.data.orgCode;
          }
        }
      });
    },
    getGuideContent(type = 'GUIDE') {
      // 获取导率用户权限
      apig.getUser(type).then(res => {
        if (res.ret === 0) {
          let guideInfo = res.data;
          if (res.data) {
            this.guide_trave_Role = res.data;
          }
          localStorage.setItem("guideInfoObj", JSON.stringify(guideInfo));
        }
        this.getGuideLimit();
      });
    },
    // 拉取导游权限
    getGuideLimit() {
      api
        .Jurisdiction()
        .then(res => {
          this.getAuth1 = true;
          this.getAuth2 = true;
          let auth = [];
          if (res.data.guideHandler) {
            const list = {
              value: "guide",
              name: "导游",
              number: 4
            };
            this.resetNav(list);
            auth.push("guideHandler");
            this.getNoticeNumGuide();
          }
          //团队监管
          // if (res.data.teamSupervisionLeader){
          //   this.teamSupervision = true
          // }
          if (res.data.guideLeader) {
            const list = {
              value: "guide",
              name: "导游",
              number: 4
            };
            this.resetNav(list);
            auth.push("guideLeader");
            this.getNoticeNumGuide();

            if (this.dataTab.length > 0 && this.currentListState == "guide") {
              this.getGuide();
            }
          }
          this.authList.push({ name: "导游", content: [], auth: auth });
          localStorage.setItem("authList", JSON.stringify(this.authList));
          this.limitState.guideHandler = res.data.guideHandler || false;
          this.limitState.guideLeader = res.data.guideLeader || false;
          this.limitState.city = res.data.city || "";
          this.guideLimitState = res.data;
          // 旅行社权限
          this.getTravelLimit(res.data);
        })
        .catch(res => {
          this.getAuth1 = true;
          this.getAuth2 = true;
        });
    },
    // 获取旅行社权限
    getTravelLimit(data) {
      this.limitState.city = this.limitState.city || "";
      this.limitState.travelAgencyHandler = data.travelAgencyHandler;
      this.limitState.travelAgencyLeader = data.travelAgencyLeader;

      let auth = [];
      if (data.travelAgencyHandler) {
        auth.push("travelAgencyHandler");
      }
      if (data.travelAgencyLeader) {
        auth.push("travelAgencyLeader");
      }
      this.authList.push({ name: "旅行社", content: [], auth: auth });
      localStorage.setItem("authList", JSON.stringify(this.authList));
      if (this.limitState.travelAgencyLeader) {
        this.travelCityId = "";
        this.travelCityRegionCode = "530000";
      } else if (this.limitState.travelAgencyHandler) {
        this.travelCityId = this.limitState.city;
        this.travelCityRegionCode = this.limitState.regionCode;
      }
      // dev1.2.0
      if (
        this.limitState.travelAgencyHandler ||
        this.limitState.travelAgencyLeader
      ) {
        // 查询待办得数量
        const list = {
          value: "trave",
          name: "旅行社",
          number: 5
        };
        this.resetNav(list);
        this.getNoticeNumTravel();
        if (this.dataTab.length > 0 && this.currentListState == "trave") {
          this.getTrava();
        }
      }
    },
    // 获取投诉权限  投诉数据流向入口在这  投诉所属
    getComplainLimit() {
      apis
        .getComplainLimits()
        .then(res => {
          this.getAuth3 = true;
          if (res.ret === 0) {
            this.complainlimitState = res.data;
            let auth = [];
            if (this.complainlimitState.complaintLeader) {
              // 领导组
              // this.getNoticeNumComplain() // 待办先不管接口没做 ----- 202/07/08 15:14
              this.getComplainUserInfo(); // 投诉模块获取用户数据
              this.getbench(); // 领导组
            }
            if (this.complainlimitState.complaintHandlder) {
              auth.push("complaintHandlder");
              const list = {
                value: "complaint",
                name: "投诉",
                number: 1
              };
              this.resetNav(list);
              this.getNoticeNumComplain();
              if (this.dataTab.length > 0) {
                this.getComplainUserInfo(); // 投诉模块获取用户数据
                this.getWork(); // 处置组
                if (this.currentListState === "complaint") {
                  this.getComplaint(); // 待办先不管接口没做 ----- 202/07/08 15:14
                }
              }
            }
            if (this.complainlimitState.detail) {
              auth.push(this.complainlimitState.detail);
            }
            this.authList.push({ name: "投诉", content: [], auth: auth });
            localStorage.setItem("authList", JSON.stringify(this.authList));
          }
        })
        .catch(res => {
          this.getAuth3 = true;
        });
    },
    // 获取退货权限
    getRefundLimit() {
      api.getUnionAuth({}).then(res => {
        console.log(res)
        this.getAuth4 = true;
        if (res.ret === 0) {
          if (res.data.REFUND && res.data.REFUND.length > 0) {
            const handlerReg = /[hH]andler$/;
            const leaderReg = /[lL]eader$/;
            const role = res.data.REFUND[0].roleCodes[0];
            this.refundlimitState = {
              refundHandler: handlerReg.test(role),
              refundLeader: leaderReg.test(role)
            };
            console.log('refundlimitState', this.refundlimitState)
            let auth = [];
            if (this.refundlimitState.refundHandler) {
              const list = {
                value: "refund",
                name: "退货",
                number: 2
              };

              this.resetNav(list);
              auth.push("refundHandler");
              if (!util.getJsonLocal("configList")) {
                this.getType();
              }
            }
            if (this.refundlimitState.refundLeader) {
              auth.push("refundLeader");
              if (!util.getJsonLocal("configList")) {
                this.getType();
              }
            }
            if (this.refundlimitState.refundHandler) {
              this.getNoticeNumRefund();
              auth.push("refundHandler");
              // 退货
              if (this.dataTab.length > 0) {
                refundworkapi.currentUser().then(res => {
                  if (res.ret === 0) {
                    this.$store.commit("refund/getUserInfo", res.data);

                    this.city = res.data.regionName;
                    this.citycode = res.data.regionCode;
                    this.selectCode = res.data.regionCode;
                    this.cityName = res.data.regionName;
                    if (
                      this.dataTab.length == 1 &&
                      this.currentListState == "refund"
                    ) {
                      this.getRefund();
                    } else {
                      if (
                        this.dataTab.length > 1 &&
                        this.currentListState == "refund"
                      ) {
                        this.getRefund();
                      }
                    }
                  }
                });
              }
            }
            if (this.refundlimitState.refundLeader) {
              auth.push("refundLeader");
              refundworkapi.currentUser().then(res => {
                if (res.ret === 0) {
                  this.$store.commit("refund/getUserInfo", res.data);
                  this.city = res.data.regionName;
                  this.citycode = res.data.regionCode;
                  this.selectCode = res.data.regionCode;
                  this.cityName = res.data.regionName;
                  this.getType();
                  // 退货
                  this.getInitTime(this.startTime, this.endTime);
                  this.getTrend(1);

                  // 退货
                }
              });
            }
            if (this.refundlimitState.detail) {
              auth.push(this.refundlimitState.detail);
            }

            this.authList.push({ name: "退货", content: [], auth: auth });
            localStorage.setItem("authList", JSON.stringify(this.authList));
          }
        }
      }).catch(res => {
        this.getAuth4 = true;
      })
      // apis
      //   .getRefundLimits()
      //   .then(res => {
      //     this.getAuth4 = true;
      //     if (res.ret === 0) {
      //       console.log(res.data, "退货");
      //       this.refundlimitState = res.data;
      //       let auth = [];

      //       if (this.refundlimitState.refundHandler) {
      //         const list = {
      //           value: "refund",
      //           name: "退货",
      //           number: 2
      //         };

      //         this.resetNav(list);
      //         auth.push("refundHandler");
      //         if (!util.getJsonLocal("configList")) {
      //           this.getType();
      //         }
      //       }
      //       if (this.refundlimitState.refundLeader) {
      //         auth.push("refundLeader");
      //         if (!util.getJsonLocal("configList")) {
      //           this.getType();
      //         }
      //       }
      //       if (this.refundlimitState.refundHandler) {
      //         this.getNoticeNumRefund();
      //         auth.push("refundHandler");
      //         // 退货
      //         if (this.dataTab.length > 0) {
      //           refundworkapi.currentUser().then(res => {
      //             if (res.ret === 0) {
      //               this.$store.commit("refund/getUserInfo", res.data);
      //               this.city = res.data.regionName;
      //               this.citycode = res.data.regionCode;
      //               this.selectCode = res.data.regionCode;
      //               this.cityName = res.data.regionName;
      //               if (
      //                 this.dataTab.length == 1 &&
      //                 this.currentListState == "refund"
      //               ) {
      //                 this.getRefund();
      //               } else {
      //                 if (
      //                   this.dataTab.length > 1 &&
      //                   this.currentListState == "refund"
      //                 ) {
      //                   this.getRefund();
      //                 }
      //               }
      //             }
      //           });
      //         }
      //       }
      //       if (this.refundlimitState.refundLeader) {
      //         auth.push("refundLeader");
      //         refundworkapi.currentUser().then(res => {
      //           if (res.ret === 0) {
      //             this.$store.commit("refund/getUserInfo", res.data);
      //             this.city = res.data.regionName;
      //             this.citycode = res.data.regionCode;
      //             this.selectCode = res.data.regionCode;
      //             this.cityName = res.data.regionName;
      //             this.getType();
      //             // 退货
      //             this.getInitTime(this.startTime, this.endTime);
      //             this.getTrend(1);

      //             // 退货
      //           }
      //         });
      //       }
      //       if (this.refundlimitState.detail) {
      //         auth.push(this.refundlimitState.detail);
      //       }

      //       this.authList.push({ name: "退货", content: [], auth: auth });
      //       localStorage.setItem("authList", JSON.stringify(this.authList));
      //     }
      //   })
      //   .catch(res => {
      //     this.getAuth4 = true;
      //   });
    },
    // 获取诚信权限
    getIntegrityLimit() {
      apis
        .getIntegrityLimits()
        .then(res => {
          this.getAuth5 = true;
          if (res.ret === 0) {
            console.log(res.data);
            let auth = [];
            localStorage.setItem("integrityInfo", JSON.stringify(res.data));
            this.integritylimitState = res.data;
            let code = this.integritylimitState.regionCode;
            if (code.slice(2) === "0000") {
              this.proFlag = 1;
              this.cityFlag = 0;
              this.areaFlag = 0;
            } else if (code.slice(4) === "00") {
              this.proFlag = 0;
              this.cityFlag = 1;
              this.areaFlag = 0;
            } else {
              this.proFlag = 0;
              this.cityFlag = 0;
              this.areaFlag = 1;
            }
            localStorage.setItem("cityFlag", this.cityFlag);
            localStorage.setItem("areaFlag", this.areaFlag);
            localStorage.setItem("proFlag", this.proFlag);
            this.getCity(code);
            if (
              this.integritylimitState.integrityProviLeader ||
              this.integritylimitState.integrityCityLeader ||
              this.integritylimitState.integrityCountyLeader ||
              this.integritylimitState.integrityCityGeneral ||
              this.integritylimitState.integrityCountyGeneral
            ) {
              this.scarnFlag = true;
            } else {
              this.scarnFlag = false;
            }
            // dev1.2.0
            if (
              this.integritylimitState.integrityCityGeneral ||
              this.integritylimitState.integrityCityLeader ||
              this.integritylimitState.integrityCountyGeneral ||
              this.integritylimitState.integrityCountyLeader ||
              this.integritylimitState.integrityProviLeader
            ) {
              const list = {
                value: "inner",
                name: "诚信",
                number: 3
              };
              this.resetNav(list);
              this.getNoticeNumIntegrity();
              if (this.dataTab.length > 0 && this.currentListState == "inner") {
                this.getInner();
              }
              //     // 诚信
            }
            let proFlag;
            let cityFlag;
            let areaFlag;
            if (this.integritylimitState.integrityCityGeneral) {
              proFlag = 0;
              cityFlag = 1;
              areaFlag = 0;
              auth.push("integrityCityGeneral");
            }
            if (this.integritylimitState.integrityCityLeader) {
              proFlag = 0;
              cityFlag = 1;
              areaFlag = 0;
              auth.push("integrityCityLeader");
            }
            if (this.integritylimitState.integrityCountyGeneral) {
              proFlag = 0;
              cityFlag = 0;
              areaFlag = 1;
              auth.push("integrityCountyGeneral");
            }
            if (this.integritylimitState.integrityCountyLeader) {
              proFlag = 0;
              cityFlag = 0;
              areaFlag = 1;
              auth.push("integrityCountyLeader");
            }

            if (this.integritylimitState.integrityProviLeader) {
              proFlag = 1;
              cityFlag = 0;
              areaFlag = 0;
              auth.push("integrityProviLeader");
            }
            localStorage.setItem("cityFlag", cityFlag);
            localStorage.setItem("areaFlag", areaFlag);
            localStorage.setItem("proFlag", proFlag);

            this.authList.push({ name: "诚信", content: [], auth: auth });
            localStorage.setItem("authList", JSON.stringify(this.authList));
          }
        })
        .catch(res => {
          this.getAuth5 = true;
        });
    },
    // 获取团队监管权限
    getTouristPrivacyLimits() {
        apis.getTouristPrivacyLimit()
        .then(res => {
          this.getAuth7 = true;
          if (res.ret === 0) {
            const list = {
              value: "touristPrivacy",
              name: "团队监管",
              number: 7
            };
            this.touristPrivacyList = res.data.records || []
            this.$store.commit("notice/setTouristPrivacyNum", this.touristPrivacyList.length);
            this.resetNav(list);
            this.isTask = this.touristPrivacyList.length === 0
          }
        }).catch(res => {
          this.getAuth7 = true;
          // 模拟数据
          this.touristPrivacyList = []
          this.$store.commit("notice/setTouristPrivacyNum", 0);
          this.isTask = this.touristPrivacyList.length === 0
        });
    },
    // 获取城市
    getCity(val) {
      let typeList = [];
      integrityapi.region({ regionCode: val }).then(res => {
        let data = res.data;
        if (res.ret === 0) {
          if (this.proFlag) {
            let dataList = data[0].children;
            let arr = dataList.map(({ name, code, regionType, children }) => {
              return {
                text: name,
                value: code,
                regionType,
                children: children
                  ? children.map(({ name, code, regionType }) => {
                      return {
                        text: name,
                        value1: code,
                        regionType
                      };
                    })
                  : []
              };
            });
            let city = data.map(({ name, code, regionType }) => {
              return {
                text: name,
                value: code,
                regionType,
                children: []
              };
            });
            arr = city.concat(arr);
            for (var i = 0; i < arr.length; i++) {
              if (arr[i].children) {
                let cityChild = [{ text: "--", value1: "--", regionType: "" }];
                let newArr = arr[i].children.concat([]);
                arr[i].children = cityChild.concat(newArr);
              }
            }
            typeList.push(arr);
            localStorage.citylList = JSON.stringify(typeList);
          } else if (this.cityFlag) {
            if (data && data.length) {
              let brr = data.map(({ name, code, regionType, children }) => {
                return {
                  text: name,
                  value: code,
                  regionType,
                  children: children
                    ? children.map(({ name, code, regionType }) => {
                        return {
                          text: name,
                          value1: code,
                          regionType
                        };
                      })
                    : []
                };
              });
              for (var i = 0; i < brr.length; i++) {
                if (brr[i].children) {
                  let cityChild = [
                    { text: "--", value1: "--", regionType: "" }
                  ];
                  let newArr = brr[i].children.concat([]);
                  brr[i].children = cityChild.concat(newArr);
                }
              }
              typeList = [];
              typeList.push(brr);
              localStorage.citylList = JSON.stringify(typeList);
            }
          }
        } else if (this.areaFlag) {
          let crr = res.data.map(({ name, code, regionType }) => {
            return {
              text: name,
              value: code,
              regionType
            };
          });
          typeList.push(crr);
          localStorage.citylList = JSON.stringify(typeList);
        }
      });
    },

    getRegionIntegrity() {
      integrityapi.region().then(res => {
        this.getDistribution();
        var fn = data => {
          for (var i = 0; i < data.length; i++) {
            if (data[i].code === this.integritylimitState.regionCode) {
              this.curCity = data[i].name;
              localStorage.setItem("cityName", this.curCity);
              localStorage.setItem(
                "cityCode",
                this.integritylimitState.regionCode
              );
              break;
            }
            if (data[i].children && data[i].children.length > 0) {
              fn(data[i].children);
            }
          }
        };
        fn(res.data);
      });
    },
    // 获取考核权限
    getJudgeLimit() {
      apis
        .getJudgeLimits()
        .then(res => {
          this.getAuth6 = true;
          if (res.ret === 0) {
            let auth = [];
            this.judgelimitState = res.data;
            if (res.data.assessStateCityLeader) {
              auth.push("assessStateCityLeader");
            }
            if (res.data.assessProviLeader) {
              auth.push("assessProviLeader");
              this.accessTitle = "全省考核排名";
            } else {
              this.accessTitle = this.judgelimitState.cityName + "考核情况";
            }
            if (res.data.assessStateCityLeader || res.data.assessProviLeader) {
              this.getAssessScoreByDefault();
              // this.getuserinfo();
            }
            this.authList.push({ name: "考核", content: [], auth: auth });
            localStorage.setItem("authList", JSON.stringify(this.authList));
          }
        })
        .catch(res => {
          this.getAuth6 = true;
        });
    },
    resetWatchBoad() {
      this.watchComplaint();
      this.watchRefund();
      this.watchInterityLimt();
      this.watchJudgeLimit();
      this.watchGuide();
      this.watchTranval();
    },
    // 投诉看板
    watchComplaint() {
      if (this.complainlimitState.complaintLeader) {
        this.getComplainUserInfo();
        this.getbench(); // 领导组
      }
      if (this.complainlimitState.complaintHandlder) {
        this.getComplainUserInfo();
        this.getWork(); // 处置组
      }
    },
    // 退货看板
    watchRefund() {
      if (this.refundlimitState.refundHandler) {
        // 退货
        refundworkapi.currentUser().then(res => {
          if (res.ret === 0) {
            this.$store.commit("refund/getUserInfo", res.data);

            this.city = res.data.regionName;
            this.citycode = res.data.regionCode;
            this.selectCode = res.data.regionCode;
            this.cityName = res.data.regionName;
            this.getType();
            // 退货
            this.getInitTime(this.startTime, this.endTime);
            this.getTrend(1);

            // 退货
          }
        });
      }
      if (this.refundlimitState.refundLeader) {
        refundworkapi.currentUser().then(res => {
          if (res.ret === 0) {
            this.$store.commit("refund/getUserInfo", res.data);
            this.city = res.data.regionName;
            this.citycode = res.data.regionCode;
            this.selectCode = res.data.regionCode;
            this.cityName = res.data.regionName;
            this.getType();
            // 退货
            this.getInitTime(this.startTime, this.endTime);
            this.getTrend(1);

            // 退货
          }
        });
      }
    },
    // 诚信看板
    watchInterityLimt() {
      if (
        this.integritylimitState.integrityCityGeneral ||
        this.integritylimitState.integrityCityLeader ||
        this.integritylimitState.integrityCountyGeneral ||
        this.integritylimitState.integrityCountyLeader ||
        this.integritylimitState.integrityProviLeader
      ) {
        this.getRegionIntegrity();
        // 诚信
      }
    },
    // 考核看板
    watchJudgeLimit() {
      if (
        this.judgelimitState.assessStateCityLeader ||
        this.judgelimitState.assessProviLeader
      ) {
        this.getAssessScoreByDefault();
      }
    },
    // 导游看板
    watchGuide() {
      if (this.limitState.guideHandler || this.limitState.guideLeader) {
        this.getGuideDashboard(this.guideLimitState);
      }
    },
    // 旅行社看板
    watchTranval() {
      if (
        this.limitState.travelAgencyHandler ||
        this.limitState.travelAgencyLeader
      ) {
        this.getTravelDashboard();
      }
    },
    // 判断是否是iphonex系列
    getIphoneX() {
      var u = navigator.userAgent;
      if (
        /iphone/gi.test(u) &&
        ((screen.height === 896 && screen.width === 414) ||
          (screen.height === 812 && screen.width === 375))
      ) {
        this.headHeight = "180px";
      } else {
        this.headHeight = "150px";
      }
    },

    // 处理导旅切换swiper
    guideSwiperChange(index) {
      if (index === 0) {
        this.guideType = "all";
      } else if (index === 1) {
        this.guideType = "supervise";
      } else {
        this.guideType = "black";
      }
    },

    travelSwiperChange(index) {
      if (index === 0) {
        this.travelType = "all";
      } else if (index === 1) {
        this.travelType = "supervise";
      } else {
        this.travelType = "black";
      }
    },

    fullScreen(val, title, type = "") {
      localStorage.removeItem("auth");
      localStorage.removeItem("getComplaintData");
      localStorage.removeItem("getRefundData");
      localStorage.removeItem("getIntegrityData");
      localStorage.removeItem("loadGuideDataInfeed");
      localStorage.removeItem("loadTravelData");
      localStorage.removeItem("getAssessData");
      localStorage.removeItem("swipeTo");
      localStorage.removeItem("swipeTitle");
      localStorage.removeItem("level");

      localStorage.setItem(
        "auth",
        JSON.stringify({
          limitState: this.limitState, // 导旅
          complainlimitState: this.complainlimitState, // 投诉
          refundlimitState: this.refundlimitState, // 退货
          integritylimitState: this.integritylimitState // 诚信
        })
      );

      let arr = [];
      if (this.complainlimitState.complaintLeader) {
        localStorage.setItem(
          "getComplaintData",
          JSON.stringify({
            handling: this.handling,
            syntheticalWarning: this.syntheticalWarning,
            emergency: this.emergency,
            dropDistribution: this.dropDistribution,
            handleWorkbench: this.handleWorkbench,
            areaOne: this.areaOne,
            fullAdress: this.fullAdress,
            IfComplaintHandling: this.IfComplaintHandling
          })
        );
        arr.push({
          name: "今日投诉数量统计",
          index: 0,
          path: this.complainlimitState.complaintLeader
            ? "/complaint/leader"
            : "/complaint/worker"
        });
      }
      if (this.refundlimitState.refundLeader) {
        localStorage.setItem("getRefundData", true);
        arr.push({
          name: "今日退货数量统计",
          index: 2,
          path: this.refundlimitState.refundLeader
            ? "/refund/leader"
            : "/refund/worker"
        });
      }

      if (
        this.integritylimitState.integrityCityLeader ||
        this.integritylimitState.integrityCountyLeader ||
        this.integritylimitState.integrityProviLeader
      ) {
        localStorage.setItem("getIntegrityData", true);
        arr.push({
          name: this.curCity + "诚信",
          index: 3,
          path: "/integrity/index"
        });
      }

      if (this.limitState.guideHandler || this.limitState.guideLeader) {
        console.log("this.guideData:", this.guideData);
        console.log("this.guideData:", this.guideData[this.guideType].data);
        localStorage.setItem(
          "loadGuideDataInfeed",
          JSON.stringify({
            guideDataInfeed: this.guideData[this.guideType].data,
            limitState: this.limitState
          })
        );
        arr.push({ name: "全省导游数量", index: 4, path: "/guide/index" });
      }

      if (
        this.limitState.travelAgencyLeader ||
        this.limitState.travelAgencyHandler
      ) {
        console.log("this.travelData:", this.travelData);
        console.log("this.travelData:", this.travelData[this.travelType].data);
        localStorage.setItem(
          "loadTravelData",
          JSON.stringify({
            datatravel: this.travelData[this.travelType].data,
            limitStatetravel: this.limitState
          })
        );
        arr.push({ name: "旅行社", index: 5, path: "/travelAgency/home" });
      }
      if (
        this.judgelimitState.assessProviLeader ||
        this.judgelimitState.assessStateCityLeader
      ) {
        localStorage.setItem(
          "getAssessData",
          JSON.stringify({
            rankClone: this.rankClone,
            assessment: this.assessment,
            ranking: this.ranking,
            judgelimitState: this.judgelimitState
          })
        );
        arr.push({ name: "考核", index: 1, path: "/appraise/provincial" });
      }

      for (var i = 0; i < arr.length; i++) {
        if (arr[i].index === Number(val)) {
          localStorage.setItem("swipeTo", i);
          localStorage.setItem("swipeTitle", JSON.stringify(arr));
        }
      }

      window.yyn.invokeJSB(
        "transformScreen",
        {
          landscape: 1, // 是否横屏 1 横屏  0 竖屏
          url: `${this.globalApp.getSystemInfo().host}web/#/infeedPage` // 页面请求H5地址
        },
        () => {}
      );
      // })
    },

    /// //////////////////////////////////待办数量统一拉取  lbw  0224///////////////////////////////////////////////
    // 旅行社
    getNoticeNumTravel() {
      clearInterval(this.travelCircle);
      this.travelCircle = null;
      this.$store.dispatch("notice/getTravelNum");
      this.travelCircle = setInterval(() => {
        console.log("旅行社轮询中");
        if (this.currentListState == "trave") {
          this.getTrava();
        }
      }, 30000);
    },
    // 投诉
    getNoticeNumComplain() {
      clearInterval(this.complaintCircle);
      this.complaintCircle = null;
      this.$store.dispatch("notice/getComplainNum");
      this.complaintCircle = setInterval(() => {
        console.log("待办轮询中");
        if (this.currentListState == "complaint") {
          this.getComplaint();
        }
      }, 30000);
    },
    // 诚信
    getNoticeNumIntegrity() {
      clearInterval(this.integrityCircle);
      this.integrityCircle = null;
      this.$store.dispatch("notice/getIntegrityNum");
      this.integrityCircle = setInterval(() => {
        console.log("诚信轮询中");
        if (this.currentListState == "inner") {
          this.getInner();
        }
      }, 30000);
    },
    // 退货
    getNoticeNumRefund() {
      clearInterval(this.refundCircle);
      this.refundCircle = null;
      this.$store.dispatch("notice/getRefundNum");
      this.refundCircle = setInterval(() => {
        console.log("退货轮询中");
        if (this.currentListState == "refund") {
          this.getRefund();
        }
      }, 30000);
    },
    // 导游
    getNoticeNumGuide() {
      clearInterval(this.guideCircle);
      this.guideCircle = null;
      this.$store.dispatch("notice/getGuideNum");
      this.guideCircle = setInterval(() => {
        console.log("导游轮询中");
        if (this.currentListState == "guide") {
          this.getGuide();
        }
      }, 30000);
    },

     //招商引资
    getNoticeNumAttract() {
      clearInterval(this.attractCircle);
      this.attractCircle = null;
      this.attractCircle = setInterval(() => {
        console.log("招商轮询中");
        this.getAttract()
      }, 30000)
    },
    /// ///////////////////////////////////////////////////////////////////////////////////////////////////////////

    /// ////////////////////////////////////////////
    /// ////////////////////////////////////////////
    // 投诉↓↓↓
    /// ////////////////////////////////////////////
    /// ////////////////////////////////////////////
    // 获取投诉模块用户信息   投诉所属
    getComplainUserInfo() {
      complaintApis.common.user({}).then(res => {
        if (res.ret === 0) {
          const userInfo = res.data.userInfo;
          const deptInfo = (res.data.depts || [])[0] || {}; // 部门信息
          this.areaOne = deptInfo.txId;
          this.fullAdress = deptInfo.areaName;
          console.log("fullAdress" + this.fullAdress);
          this.unitType = userInfo.orgType;
          util.setJsonLocal("userInfoComplaint", res.data);
        }
      });
    },
    WorkbenchItemClick(item, area) {
      // 处理工作台
      const userInfo = util.getJsonLocal("userInfoComplaint") || {};
      util.setJsonLocal("buttonType", "");
      switch (item.value) {
        case "notAcceptComplainList": // 待响应，指挥中心
          util.setJsonLocal("buttonType", "centerAccepted");
          util.setJsonLocal("waitResponse", "centerAccepted");
          break;
        case "notHandleComplainList": // 待处理，指挥中心
          if (userInfo.userInfo.orgType.indexOf("tszhzx") > -1) {
            // 指挥中心
            util.setJsonLocal("buttonType", "centerHandle");
            util.setJsonLocal("waitResponse", "centerHandle");
          } else if (
            userInfo.userInfo.orgType.indexOf("wbtj") > -1 ||
            userInfo.userInfo.orgType.indexOf("company") > -1
          ) {
            // 部门
            util.setJsonLocal("buttonType", "depCompanyHandle");
            util.setJsonLocal("waitResponse", "depCompanyHandle");
          }
          break;
        case "awaitReportlist": // 上报待审核，指挥中心
          util.setJsonLocal("buttonType", "reportIng");
          util.setJsonLocal("waitResponse", "reportIng");
          break;
        case "superviseToAcceptList": // 督办待受理，指挥中心
          util.setJsonLocal("buttonType", "superviseHandle");
          util.setJsonLocal("waitResponse", "superviseHandle");

          break;
        case "applySplitOrderList": // 拆单待审核，指挥中心
          util.setJsonLocal("buttonType", "splitOrderReportIng");
          util.setJsonLocal("waitResponse", "depCompanyHandle");
          break;
        case "feedBackList": // 部门申诉待审核
          util.setJsonLocal("buttonType", "appealReportIng");
          util.setJsonLocal("waitResponse", "appealReportIng");
          break;
        // case 'supplementInformation':// 结果待完善
        //     util.setJsonLocal('buttonType', 'supplementInformation');
        //     util.setJsonLocal('waitResponse','supplementInformation');
        //     break;
        case "waitAcceptCase": // 诉转案，待立案
          util.setJsonLocal("buttonType", "caseHandle");
          break;
        case "awaitPendingList": // 部门待处理
          util.setJsonLocal("buttonType", "depCompanyHandle");
          util.setJsonLocal("waitResponse", "depCompanyHandle");
          break;
        case "waitDealCase": // 诉转案，待处理
          util.setJsonLocal("buttonType", "complainToCase");
          break;
      }
      let params = {
        place: area,
        placeName: this.fullAdress,
        type: item.value
      };
      // this.$router.push({
      //   path: `/complaint/workerListForth?type=${item.value}&place=${area}&placeName=${encodeURI(this.fullAdress)}`,
      //   query: params
      // })
      // return;
      // 业务人员跳转 投诉待办列表
      handleToDoList({
        type : item.listType, 
        // cityId: this.areaOne,
        title: item.name,
      })
      // window.yyn.invokeJSB(
      //   "openWindow",
      //   {
      //     openUrl: `${
      //       this.globalApp.getSystemInfo().host
      //     }web/#/complaint/workerListForth?type=${
      //       item.value
      //     }&place=${area}&placeName=${encodeURI(this.fullAdress)}`,
      //     isFullScreen: 0,
      //     setTitle: item.name,
      //     needLoading: 1
      //   },
      //   cb => {
      //     console.log(cb, "callback");
      //   }
      // );
    },
    // 领导组 获取状态统计数据  投诉所属
    getSatusData(type = 'leader') {
      complaintApis.leader.getAppMetricsCount({}).then(res => {
        if (res.ret) return false;
        const list = res.data || [];
        if (type === 'leader') {
          // 领导组
          this.handling.splice(0, this.handling.length);
          this.handling.push(...list);
        } else if (type === 'worker') {
          // 处置组
          this.IfComplaintHandling = true;
          this.handleWorkbench.splice(0, this.handleWorkbench.length);
          this.handleWorkbench.push(...list);
        }
      });
    },
    // 获取落点分布数据 投诉所属
    getDropDistribution() {
      complaintApis.leader.getCountByPlace({}).then(res => {
        if (res.ret) return false;
        Object.keys(this.dropDistribution).forEach(prop => {
          this.dropDistribution[prop] = 0;
        });
        this.dropDistribution = Object.assign(
          {},
          this.dropDistribution,
          res.data.dropDistribution
        );
      });
    },
    // 获取综合预警投诉统计数据 投诉所属
    getWarninngData() {
      complaintApis.common.queryAllsyntheticalWarning({}).then(res => {
        if (res.ret === 0) {
          const list = (res.data.syntheticalWarning || {}).list || [];
          this.syntheticalWarning.splice(0, this.syntheticalWarning.length);
          this.syntheticalWarning.push(...list);
        }
      });
    },
    // 获取紧急程度投诉统计数据 投诉所属
    getEmergencyData() {
      complaintApis.common.queryAllemergency({}).then(res => {
        if (res.ret === 0) {
          const list = res.data.emergency || [];
          this.emergency.splice(0, this.emergency.length);
          this.emergency.push(...list);
          console.log(this.emergency);
        }
      });
    },
    // 领导组数据看板
    getbench() {
      this.getSatusData('leader');
      // 落点分布【废弃】
      // this.getDropDistribution();
      // 综合预警【废弃】
      // this.getWarninngData();
      // 紧急程度分度【废弃】
      // this.getEmergencyData();
    },
    // 处置组数据看板
    getWork() {
      // 获取待办统计不区分角色
      this.getSatusData('worker'); 
      // complaintApis.worker
      //   .menuList({ isFromObject: 1, isFromTIO: 1 })
      //   .then(res => {
      //     if (res.ret === 0) {
      //       this.IfComplaintHandling = true;
      //       const list = (res.data || {}).complainDealCount || [];
      //       this.handleWorkbench.splice(0, this.handleWorkbench.length);
      //       this.handleWorkbench.push(...list);
      //     }
      //   });
    },

    goList(type, value, area) {
      // 轮播图跳转的页面
      // console.log(type, value);
      // 还需要传当前区域id
      this.$store.commit("complaint/setBackDetail", "");
      util.setJsonLocal("buttonType", "queryList");
      window.yyn.invokeJSB(
        "openWindow",
        {
          openUrl: `${
            this.globalApp.getSystemInfo().host
          }web/#/complaint/comprehensiveWarningList?type=${type}&warningType=${value}&place=${area}`,
          isFullScreen: 0,
          setTitle: "综合预警",
          needLoading: 1
        },
        cb => {
          console.log(cb, "callback");
        }
      );
    },
    goRoute(value) {
      this.$store.commit("complaint/setBackDetail", "");
      util.setJsonLocal("buttonType", "queryList");
      // value 是旧版用于高亮省级、州市、区县、企业
      handleToComplainList('type', {
        itemType: '',
        cityId: this.areaOne,
        title: '落点分布',
      })
      // window.yyn.invokeJSB(
      //   "openWindow",
      //   {
      //     openUrl: `${
      //       this.globalApp.getSystemInfo().host
      //     }web/#/complaint/leaderListSec?typeSign=dropDistribution&dafaultType=${value}&areaOne=${
      //       this.areaOne
      //     }&fullAdress=${encodeURI(this.fullAdress)}`,
      //     isFullScreen: 0,
      //     setTitle: "落点分布",
      //     needLoading: 1
      //   },
      //   cb => {
      //     console.log(cb, "callback");
      //   }
      // );
    },
    leaderListItemClick(item, title) {
      util.setJsonLocal("buttonType", "queryList");
      this.$store.commit("complaint/setBackDetail", "");
      
      handleToComplainList('type', {
        itemType : item.listType, 
        // cityId: this.areaOne,
        title: title,
        // 加入今日参数
        isToday : true,
      })
    },
    toLeaderWarningList(type, value, areaOne, item) {
      // 底部紧急程度模块
      util.setJsonLocal("buttonType", "queryList");
      handleToComplainList('type', {
        itemType: type,
        cityId: areaOne,
        title: '',
        // 紧急程度
        code: item.value,
      })
      // window.yyn.invokeJSB(
      //   "openWindow",
      //   {
      //     openUrl: `${
      //       this.globalApp.getSystemInfo().host
      //     }web/#/complaint/warningList?type=${type}&emergencyType=${value}&place=${
      //       this.areaOne
      //     }&placeName=${encodeURI(this.fullAdress)}`,
      //     isFullScreen: 0,
      //     setTitle: "",
      //     needLoading: 1
      //   },
      //   cb => {
      //     console.log(cb, "callback");
      //   }
      // );
    },
    /// ////////////////////////////////////////////
    /// ////////////////////////////////////////////
    // 投诉↑↑↑
    /// ////////////////////////////////////////////
    /// ////////////////////////////////////////////

    /// ////////////////////////////////////////////
    /// ////////////////////////////////////////////
    // 退货↓↓↓
    /// ////////////////////////////////////////////
    /// ////////////////////////////////////////////
    getType() {
      // 获取配置中心数据
      refundworkapi.typePicker({}).then(res => {
        if (res.ret === 0) {
          // this.$store.state.configlist = res.data;
          util.setJsonLocal("configList", res.data);
        }
      });
    },
    goLeader(value, path) {
      if (this.refundlimitState.refundLeader) {
        window.yyn.invokeJSB(
          "openWindow",
          {
            openUrl: `${
              this.globalApp.getSystemInfo().host
            }web/#/refund/leaderList?citycode=${this.citycode}&aboutTime=${
              this.aboutTime
            }&refundType=${value}&cityName=${encodeURI(this.cityName)}`,
            isFullScreen: 0,
            setTitle: "",
            needLoading: 1
          },
          cb => {
            console.log(cb, "callback");
          }
        );
      } else if (this.refundlimitState.refundHandler) {
        window.yyn.invokeJSB(
          "openWindow",
          {
            openUrl: `${this.globalApp.getSystemInfo().host}web/#${path}&day=${
              this.startTime
            }`,
            isFullScreen: 0,
            setTitle: "",
            needLoading: 1
          },
          cb => {
            console.log(cb, "callback");
          }
        );
      }
    },
    goWork(path) {
      window.yyn.invokeJSB(
        "openWindow",
        {
          openUrl: `${this.globalApp.getSystemInfo().host}web/#` + path,
          isFullScreen: 0,
          setTitle: "",
          needLoading: 1
        },
        cb => {
          console.log(cb, "callback");
        }
      );
    },
    getWorkInfoList() {
      this.startTime = moment(new Date().getTime()).format("YYYY-MM-DD");
      this.endTime = moment(new Date().getTime()).format("YYYY-MM-DD");
      let data = {
        // areaId: this.citycode,
        startDate: this.startTime,
        endDate: this.endTime
      };
      refundworkapi.workbench(data).then(res => {
        if (res.ret === 0) {
          this.homeWorkInfo = res.data;
        }
      });
    },
    selectAll(index, item) {
      this.dataList.map((item, index1) => {
        this.$set(this.dataList[index1], "select", false);
      });
      this.$set(this.dataList[index], "select", true);
      this.aboutTime = item.value;
      if (item.value === "today") {
        this.startTime = moment(new Date().getTime()).format("YYYY-MM-DD");
        this.endTime = moment(new Date().getTime()).format("YYYY-MM-DD");
      } else if (item.value === "week") {
        let nowTime = moment(new Date().getTime()).format("YYYY-MM-DD");
        var data = util.getWeekStartEnd(moment, nowTime);
        this.startTime = data.start;
        this.endTime = data.end;
      } else if (item.value === "mouth") {
        var currentDateMon = new Date();
        // 获取当前月的第一天
        this.startTime = this.getCurrentMonthFirst(currentDateMon);
        // 获取当前月的最后一天
        this.endTime = this.getCurrentMonthLast(currentDateMon);
      } else if (item.value === "all") {
        this.startTime = "2019-05-01";
        this.endTime = moment(new Date().getTime()).format("YYYY-MM-DD");
      }
      if (this.refundlimitState.refundLeader) {
        this.getInfoList();
      }
      if (this.refundlimitState.refundHandler) {
        this.getInfoList();
      }

      this.getInitTime(this.startTime, this.endTime);
    },
    getInitTime(startTime, endTime) {
      // 获取初始化时间
      this.$store.commit("refund/getStartTime", startTime);
      this.$store.commit("refund/getEndTime", endTime);
    },
    getCurrentMonthFirst(d) {
      var date = new Date(d);
      date.setDate(1);
      var month = parseInt(date.getMonth() + 1);
      var day = date.getDate();
      if (month < 10) {
        month = "0" + month;
      }
      if (day < 10) {
        day = "0" + day;
      }
      return date.getFullYear() + "-" + month + "-" + day;
    },
    getCurrentMonthLast(d) {
      var date = new Date(d);
      var currentMonth = date.getMonth();
      var nextMonth = ++currentMonth;
      var nextMonthFirstDay = new Date(date.getFullYear(), nextMonth, 1);
      var oneDay = 1000 * 60 * 60 * 24;
      var lastTime = new Date(nextMonthFirstDay - oneDay);
      var month = parseInt(lastTime.getMonth() + 1);
      var day = lastTime.getDate();
      if (month < 10) {
        month = "0" + month;
      }
      if (day < 10) {
        day = "0" + day;
      }
      return date.getFullYear() + "-" + month + "-" + day;
    },
    getInfoList() {
      apis
        .workbenchLeader({
          areaId: this.citycode,
          startDate: this.startTime,
          endDate: this.endTime
        })
        .then(res => {
          if (res.ret === 0) {
            this.homeInfo = res.data;
            console.log(
              "this.homeInfo!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!",
              this.homeInfo
            );
          }
        });
    },

    getTrend(type) {
      api
        .lately30Trendhome({ now: new Date().getTime(), days: "-30" })
        .then(res => {
          if (res.ret === 0) {
            this.lineList = [];
            const arr = [];
            res.data.map((item, index) => {
              var obj = { xAxis: item.date.substring(5, 10), num: item.count };
              arr.push(obj);
            });
            this.lineList = arr;
            console.log(
              "this.lineListthis.lineListthis.lineListthis.lineListthis.lineList:",
              this.lineList
            );
          }
          if (type === 0) {
            this.getInfoList();
          } else if (type === 1) {
            this.getInfoList();
          }
        });
    },

    /// ////////////////////////////////////////////
    /// ////////////////////////////////////////////
    // 退货↑↑↑
    /// ////////////////////////////////////////////
    /// ////////////////////////////////////////////

    /// ////////////////////////////////////////////
    /// ////////////////////////////////////////////
    // 诚信↓↓↓
    /// ////////////////////////////////////////////
    /// ////////////////////////////////////////////

    // 获取基础数据
    getstatisticsTotal() {
      let parm = {
        regionCode: this.integritylimitState.regionCode || "530000" // 区域code
      };

      integrityapi.statisticsTotal(parm).then(res => {
        if (res.ret === 0) {
          let data = res.data;
          // this.total = 1 * data.unGraded + 1 * data.stop + 1 * data.graded;
          this.total = 1 * data.graded;
          data.total = this.total;
          data.pExponent = data.online - data.lastOnline;
          data.zExponent = data.supervision - data.lastSupervision;
          data.hExponent = data.blacklist - data.lastBlack;
          console.log(data.pExponent);
          this.formData = data;
        }
      });
    },
    goBusinessList(dataList) {
      console.log('统计台');
      console.log(this.cityName);
      window.yyn.invokeJSB(
        "openWindow",
        {
          openUrl: `${
            this.globalApp.getSystemInfo().host
          }web/#/integrity/businessList?name=${encodeURIComponent(
            dataList.name
          )}&code=${dataList.code}&ind=${
            dataList.ind
          }&cityName=${encodeURIComponent(this.curCity)}&cityCode=${
            this.integritylimitState.regionCode
          }`,
          isFullScreen: 0,
          setTitle: "",
          needLoading: 1
        },
        cb => {
          console.log(cb, "callback");
        }
      );
    },
    // 诚信指数
    getDistribution() {
      let parm = {
        regionCode: this.integritylimitState.regionCode || "530000" // 地区
      };

      integrityapi.distribution(parm).then(res => {
        this.getstatisticsTotal();
        if (res.ret === 0) {
          let data = res.data;
          this.pieInfeedList = [
            {
              ratio: (
                (Number(data.moreNine) /
                  (Number(data.moreNine) +
                    Number(data.sevenToNine) +
                    Number(data.sixToSeven))) *
                100
              ).toFixed(2),
              value: Number(data.moreNine),
              name: "9.5分以上"
            },
            {
              ratio: (
                (Number(data.sevenToNine) /
                  (Number(data.moreNine) +
                    Number(data.sevenToNine) +
                    Number(data.sixToSeven))) *
                100
              ).toFixed(2),
              value: Number(data.sevenToNine),
              name: "≥7分且<9.5分"
            },
            {
              ratio: (
                (Number(data.sixToSeven) /
                  (Number(data.moreNine) +
                    Number(data.sevenToNine) +
                    Number(data.sixToSeven))) *
                100
              ).toFixed(2),
              value: Number(data.sixToSeven),
              name: "≥6分且<7分"
            }
          ];
        }
      });
    },
    /// ////////////////////////////////////////////
    /// ////////////////////////////////////////////
    // 诚信↑↑↑
    /// ////////////////////////////////////////////
    /// ////////////////////////////////////////////

    /// ////////////////////////////////////////////
    /// ////////////////////////////////////////////
    // 旅行社
    /// ////////////////////////////////////////////
    /// ////////////////////////////////////////////

    // 得到旅行社面板数据
    getTravelDashboard() {
      if (this.limitState.travelAgencyLeader) {
        this.travelTabList = ["州市数量分布", "历史数量变化"];
      }
      if (this.limitState.travelAgencyHandler) {
        this.travelTabList = ["历史数量变化", "州市排名"];
      }
      api.getHomeTravelNumber({ city: this.travelCityId }).then(res => {
        this.getTravelTrend();
        if (res.ret === 0) {
          let data = res.data;
          // 所有导游 面板数据
          this.travelData.all.data.dashboard.numbers = data.allCount;
          this.travelData.all.data.dashboard.compare =
            data.allCount === data.previousMonthCount
              ? "equal"
              : data.allCount > data.previousMonthCount
              ? "add"
              : "decrease";
          this.travelData.all.data.dashboard.price =
            data.allCount - data.previousMonthCount;
        }
      });
    },
    // 得到趋势数据
    getTravelTrend() {
      let params = { city: this.travelCityId };
      // 得到所有数据趋势
      api.getAllMonthNumber(params).then(res => {
        this.getTravelMapList();
        if (res.ret === 0) {
          this.travelData.all.data.trendList = this.formatTrendList(res.data);
        }
      });
    },
    // 得到排名及地图数据
    getTravelMapList() {
      // 得到所有数据排名
      api.getCityAllNumber({ city: "" }).then(res => {
        if (res.ret === 0) {
          this.travelData.all.data.rankList = res.data;
          this.travelData.all.data.mapList = [];
          res.data.forEach(item => {
            this.travelData.all.data.mapList.push({
              name: item.cityName,
              value: item.count,
              cityShortName: item.cityShortName
            });
            this.travelMap = true;
          });
          this.travelAllTabIndex = 0;
        }
      });
    },
    //
    travelTabSwitch(index, key) {
      switch (key) {
        case "all":
          this.travelAllTabIndex = index;
          break;
        case "supervise":
          this.travelSuperviseTabIndex = index;
          break;
        case "black":
          this.travelBlackTabIndex = index;
          break;
      }
    },
    setTravelSelfItem(index, item) {
      let surplus = 0;
      this.limitState.cityName = item.cityShortName;
      this.travelData[index].data.rank.numbers = item.index;
      surplus = item.index - item.lastIndex;
      this.travelData[index].data.rank.compare =
        surplus === 0 ? "equal" : surplus < 0 ? "decrease" : "add";
      this.travelData[index].data.rank.price = surplus;
    },
    /// ////////////////////////////////////////////
    /// ////////////////////////////////////////////
    // 旅行社
    /// ////////////////////////////////////////////
    /// ////////////////////////////////////////////

    /// ////////////////////////////////////////////
    /// ////////////////////////////////////////////
    // start 导游 by huhui
    /// ////////////////////////////////////////////
    /// ////////////////////////////////////////////

    // 得到导游面板数据
    getGuideDashboard(postData) {
      if (this.limitState.guideLeader) {
        this.guideTabList = ["州市数量分布", "历史数量变化"];
      }
      if (this.limitState.guideHandler) {
        this.guideTabList = ["历史数量变化", "州市排名"];
      }
      let params = {};
      if (this.limitState.city === "34") {
        params = { city: "" };
      } else {
        params = { city: this.limitState.city };
      }
      api.guideHomeDashboard(params).then(res => {
        this.getGuideMapList(postData);
        if (res.ret === 0) {
          let data = res.data;
          let surplus = 0;
          // 所有导游 面板数据
          this.guideData.all.data.dashboard.numbers = data.allCount;
          surplus = data.allCount - data.previousMonthCount;
          this.guideData.all.data.dashboard.compare =
            surplus === 0 ? "equal" : surplus < 0 ? "decrease" : "add";
          this.guideData.all.data.dashboard.price = surplus;
        }
      });
    },
    // 得到趋势数据
    getGuideTrend(postData) {
      let params = {};
      if (Number(this.limitState.city) === 34) {
        params = { city: "" };
      } else {
        params = { city: this.limitState.city };
      }
      // 得到所有数据趋势
      api.guideAllTrend(params).then(res => {
        if (res.ret === 0) {
          this.guideData.all.data.trendList = this.formatTrendList(res.data);
        }
      });
    },
    // 得到排名及地图数据
    getGuideMapList(postData) {
      let params = { city: "" };
      // 得到所有数据排名
      api.guideHomeAllList(params).then(res => {
        this.getGuideTrend(postData);
        if (res.ret === 0) {
          this.guideData.all.data.rankList = res.data;
          this.guideData.all.data.mapList = [];
          res.data.forEach(item => {
            this.guideData.all.data.mapList.push({
              name: item.cityName,
              value: item.count,
              cityShortName: item.cityShortName
            });
            this.travelMap = true;
          });
          this.guideAllTabIndex = 0;
        }
      });
    },
    // 格式化线图数据
    formatTrendList(data) {
      data.reverse();
      let arr = [];
      data.forEach(item => {
        arr.push({
          xAxis: item.date,
          num: item.count
        });
      });
      return arr;
    },
    //
    guideTabSwitch(index, key) {
      switch (key) {
        case "all":
          this.guideAllTabIndex = index;
          break;
        case "supervise":
          this.guideSuperviseTabIndex = index;
          break;
        case "black":
          this.guideBlackTabIndex = index;
          break;
      }
    },
    // 导游swiper切换
    onChangeGuideSwipe(index) {
      console.log(2222);
      this.guideTabIndex = 0;
    },
    //
    setGuideSelfItem(index, item) {
      let surplus = 0;
      this.limitState.cityName = item.cityShortName;
      this.guideData[index].data.rank.numbers = item.index;
      surplus = item.index - item.lastIndex;
      this.guideData[index].data.rank.compare =
        surplus === 0 ? "equal" : surplus < 0 ? "decrease" : "add";
      this.guideData[index].data.rank.price = surplus;
    },
    /// ////////////////////////////////////////////
    /// ////////////////////////////////////////////
    // end 导游 by huhui
    /// ////////////////////////////////////////////
    /// ////////////////////////////////////////////

    sortList(list) {
      // 排序
      list.sort((x, y) => {
        return x.ranking - y.ranking;
      });
    },
    rankingSwitch(index) {
      this.getAssessScoreByDefault(index + 1);
    },
    openWindow,
    showTeamSupervision() {
      window.yyn.invokeJSB(
          "openWindow",
          {
            openUrl: `${this.globalApp.getSystemInfo().host}team-supervision/supervision-app/index.html`,
            needLoading: 1,
            isFullScreen: 1,
          },
          cb => {
            console.log(cb, "callback");
          }
      );
    },

    // 旅行社
    travelMapSwitch(index) {
      this.travelLineChartsIndex = index;
      switch (index) {
        case 0:
          break;
        case 1:
          break;
        default:
          break;
      }
    },
    getAssessScoreByDefault(type) {
      console.log("走这里没?", this.judgelimitState.assessProviLeader);
      let today = new Date();
      let year = today.getFullYear();
      let month = today.getMonth() + 1;
      let quarter = 1;
      if (month < 4) {
        quarter = 1;
      } else if (month < 7) {
        quarter = 2;
      } else if (month < 10) {
        quarter = 3;
      } else if (month < 13) {
        quarter = 4;
      }
      // 考核省级卡片数据
      // if (this.judgelimitState.isProvPriv === '1') {
      if (this.judgelimitState.assessProviLeader) {
        api
          .getAssessScoreList({
            year: year,
            quarter: quarter,
            areaType: type ? type : "1"
          })
          .then(res => {
            this.rankClone = res.data.scoreVOList;
            this.rankList = this.rankClone;
            this.rankList = res.data.scoreVOList.map(e => ({
              area: e.area,
              areaName: e.areaName,
              rankingChange: e.diffRanking,
              diffRanking: e.diffRanking,
              oldRanking: e.oldRanking,
              lastRanking: e.oldRanking,
              quarter: e.quarter,
              ranking: e.ranking,
              score: e.score / 100,
              year: e.year
            }));
            console.log("省级数据:", this.rankList);
            this.sortList(this.rankList);
          });
        // api.getAssessScoreByDefault({
        //     isProvPriv: this.judgelimitState.isProvPriv,
        //     area: this.judgelimitState.area
        // })
        //     .then(res => {
        //         console.log('考核结果')
        //         console.log(res)
        //         this.rankClone = res.data.list;
        //         this.rankList = this.rankClone.filter(item => {
        //             return item.areaType === 1;
        //         });
        //         this.sortList(this.rankList)
        //         console.log('this.rankList考核考核考核考核考核考核:', this.rankList)
        //     });
      } else {
        // 考核州市卡片
        api
          .getAssessScoreDay({
            year: year,
            quarter: quarter,
            area: this.area,
            contrast: "0",
            type: "A"
          })
          .then(res => {
            console.log("考核结果");
            console.log(res);
            this.assessment = {
              title: "考核分",
              num:
                res && res.data && res.data.scoreAndRankingVO
                  ? res.data.scoreAndRankingVO.score
                  : 0,
              type: 0,
              desc: "比上季",
              diff:
                res && res.data && res.data.scoreAndRankingVO
                  ? res.data.scoreAndRankingVO.scoreChange
                  : ""
            };
            this.ranking = {
              title: "当前排名",
              num: res.data.scoreAndRankingVO.ranking,
              desc: "比上季",
              diff: res.data.scoreAndRankingVO.rankingChange
            };
          });
      }
    },
    fixQuater(index) {
      if (index == 1) {
        return "第一季度";
      } else if (index == 2) {
        return "第二季度";
      } else if (index == 3) {
        return "第三季度";
      } else if (index == 4) {
        return "第四季度";
      }
    },
    navToDetail(val) {
      // this.judgelimitState.isProvPriv
      // let data = {
      //     year: this.judgelimitState.year,
      //     quarter: this.judgelimitState.quarter,
      //     isProvPriv: this.judgelimitState.isProvPriv,
      //     area: val.area,
      //     areaName: val.areaName,
      //     quarterName: this.judgelimitState.quarterName,
      //     complainQuarter: this.judgelimitState.complainQuarter,
      //     compickFlag2: this.compickFlag2,
      //     compickFlag: this.compickFlag
      // }
      // console.log('data:::', data)
      console.log("----val:", val);
      // this.$router.push({ path: '', query:{
      //   year: val.year,
      //   quarter: val.quarter,
      //   area: val.area,
      //   areaName: val.areaName,
      //   quarterName: val.year+'年'+ this.fixQuater(val.quarter),
      //   complainQuarter: '',
      //   compickFlag: false,
      //   compickFlag2: false,
      //   isProvPriv: 1,
      //   uuuuxd: 0
      // }})
      const params = commonAPI.getJsonLocal("onlyonlyreadone");
      if (params) {
        commonAPI.removeJsonLocal("onlyonlyreadone");
      }
      commonAPI.setJsonLocal("onlyonlyreadone", {
        year: val.year,
        quarter: val.quarter,
        area: val.area,
        areaName: val.areaName,
        quarterName: "",
        complainQuarter: "",
        compickFlag: false,
        compickFlag2: false,
        isProvPriv: 1,
        uuuuxd: 1
      });
      window.yyn.invokeJSB(
        "openWindow",
        {
          openUrl: `${
            this.globalApp.getSystemInfo().host
          }web/#/appraise/detail`,
          // openUrl: `${this.globalApp.getSystemInfo().host}web/#/appraise/provincialDetail?year=${this.judgelimitState.year}&
          //quarter=${this.judgelimitState.quarter}&isProvPriv=${this.judgelimitState.isProvPriv}&area=${val.area}&
          //areaName=${encodeURIComponent(val.areaName)}&quarterName=${encodeURIComponent(this.judgelimitState.quarterName)}&
          //complainQuarter=${this.judgelimitState.complainQuarter}&compickFlag2=${this.compickFlag2}&compickFlag=${this.compickFlag}`,
          isFullScreen: 0,
          setTitle: "",
          needLoading: 1
        },
        cb => {
          console.log(cb, "callback");
        }
      );
      //   window.yyn.invokeJSB(
      //     'openWindow', {
      //         openUrl: `${this.globalApp.getSystemInfo().host}web/#/appraise/detail?year=${val.year}&quarter=${val.quarter}&area=${val.area}
      //                              &areaName=${encodeURIComponent(val.areaName)}&quarterName=''&complainQuarter=''
      //                              &compickFlag=false&compickFlag2=false&isProvPriv=1&isShowTopnofify=true&uuuuxd=1`,
      //         isFullScreen: 0,
      //         setTitle: '',
      //         needLoading: 1
      //     },
      //     cb => {
      //         console.log(cb, 'callback');
      //     }
      // );

      // window.yyn.invokeJSB(
      //     'openWindow', {
      //         openUrl: `${this.globalApp.getSystemInfo().host}web/#/appraise/index`,
      //         // openUrl: `${this.globalApp.getSystemInfo().host}web/#/appraise/provincialDetail?year=${this.judgelimitState.year}&
      //            //quarter=${this.judgelimitState.quarter}&isProvPriv=${this.judgelimitState.isProvPriv}&area=${val.area}&
      //            //areaName=${encodeURIComponent(val.areaName)}&quarterName=${encodeURIComponent(this.judgelimitState.quarterName)}&
      //            //complainQuarter=${this.judgelimitState.complainQuarter}&compickFlag2=${this.compickFlag2}&compickFlag=${this.compickFlag}`,
      //         isFullScreen: 0,
      //         setTitle: '',
      //         needLoading: 1
      //     },
      //     cb => {
      //         console.log(cb, 'callback');
      //     }
      // );
    },
    // 无权限提示信息
    showTip() {
      this.$Toast("暂无权限");
    },
    reset() {
      this.authList = [];
      // 清空notice 的 storage
      localStorage.removeItem("getTravelNotice");
      localStorage.removeItem("noticeNumTravel");
      localStorage.removeItem("getComplainNotice");
      localStorage.removeItem("noticeNumComplain");
      localStorage.removeItem("getIntegrityNotice");
      localStorage.removeItem("noticeNumIntegrity");
      localStorage.removeItem("getRefundNotice");
      localStorage.removeItem("noticeNumRefund");
      localStorage.removeItem("noticeNumGuide");
      localStorage.removeItem("noticeNumAttract");
      localStorage.removeItem("authList");

      this.$store.commit("notice/setTravelNum", 0);
      this.$store.commit("notice/setComplainNum", 0);
      this.$store.commit("notice/setIntegrityNum", 0);
      this.$store.commit("notice/setRefundNum", 0);
      this.$store.commit("notice/setGuideNum", 0);
      this.$store.commit("notice/setNoticeNumAttract", 0);
      this.$store.commit("notice/setTouristPrivacyNum", 0);

      this.getIphoneX();
      // this.getHeadInfo()
      this.getIndexInfo(); /** 更换首页权限字段 */
      // 菜单权限
      // this.getComplainLimit();// 投诉权限
      this.getRefundLimit(); // 退货权限
      this.getIntegrityLimit(); // 诚信权限
      // this.getGuideLimit();// 导游权限
      // this.getGuideContent();
      // this.getJudgeLimit();// 考核权限
      this.getUnionAuth(); // 分时预约
      this.getTouristPrivacyLimits() // 团队监管
    },
    scanBtn() {
      this.showShadow = !this.showShadow;
      setTimeout(() => {
        this.ishowTab = !this.ishowTab;
      }, 100);
    },
    hideMenu() {
      this.ishowTab = false;
      setTimeout(() => {
        this.showShadow = !this.showShadow;
      }, 100);
    },
    scanBtn1() {
      this.$router.push(
        `/integrity/businessList?name=${"总数"}&code=${"all"}&ind=${"0"}`
      );
      window.yyn.invokeJSB(
        "openWindow",
        {
          openUrl: `${
            this.globalApp.getSystemInfo().host
          }web/#/integrity/businessList?name=${"总数"}&code=${"all"}&ind=${"0"}`,
          isFullScreen: 0,
          setTitle: "",
          needLoading: 1
        },
        cb => {
          console.log(cb, "callback");
        }
      );
    },
    scanBtn2() {
      this.$router.push(
        `/guide/guideList?tabIndex=${"0"}&cityId=${"385"}&cityName=${"昆明"}&cityIndex=${"0"}&selfCityId=${"385"}`
      );
      window.yyn.invokeJSB(
        "openWindow",
        {
          openUrl: `${
            this.globalApp.getSystemInfo().host
          }web/#/guide/guideList?tabIndex=${"0"}&cityId=${"385"}&cityName=${"昆明"}&cityIndex=${"0"}&selfCityId=${"385"}`,
          isFullScreen: 0,
          setTitle: "",
          needLoading: 1
        },
        cb => {
          // console.log(cb, "callback");
          // alert(cb);
        }
      );
    },
    regestChangeDate() {
      // 每次进页面刷新待办数
      let ts = this;
      window.yyn.registerAsyn("onShow", function() {
        console.log("registerAsyn:onshow");
        ts.reset();
        ts.waitList = [];
        ts.showShadow = false;
        ts.ishowTab = false;
      });
    }
  },

  mounted() {
    // if(this.$refs.tabs){
    //   this.$refs.tabs.switchTab(0);
    // }

    this.reset();
    this.regestChangeDate();
  },

  created() {
    console.log("process.env:", process.env);
    localStorage.setItem("guideNotice", "");
    localStorage.setItem("travelNotice", "");
    util.setJsonLocal("waitResponse", "");
    this.$store.commit("complaint/setBackDetail", "");

    //  this.getuserinfo();
    clearInterval(this.travelCircle);
    clearInterval(this.complaintCircle);
    clearInterval(this.integrityCircle);
    clearInterval(this.refundCircle);
    clearInterval(this.guideCircle);
    clearInterval(this.attractCircle);
  },


  beforeDestroy() {
    clearInterval(this.travelCircle);
    clearInterval(this.complaintCircle);
    clearInterval(this.integrityCircle);
    clearInterval(this.refundCircle);
    clearInterval(this.guideCircle);
    clearInterval(this.attractCircle);

  },

  destroyed() {
    clearInterval(this.travelCircle);
    clearInterval(this.complaintCircle);
    clearInterval(this.integrityCircle);
    clearInterval(this.refundCircle);
    clearInterval(this.guideCircle);
    clearInterval(this.attractCircle);

  }
};
</script>
<style scoped lang="less">
.home_container {
  .box_shadow {
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 100vh;
    background: rgba(0, 0, 0, 0);
    z-index: 9999;
    .kongBtn {
      width: 40px;
      height: 40px;
      border-radius: 50%;
      position: absolute;
      right: 24px;
      top: 44px;
    }
    .toolTips {
      padding: 16px;
      background-color: #424242;
      position: absolute;
      right: 12px;
      top: 94px;
      z-index: 99999;
      z-index: 9999;
      transition: all 0.2s ease-in-out;
      transform: scale(0);
      transform-origin: 75% -4%; /* 变换原点 */
      border-radius: 3px;
      opacity: 0;
      .triangle {
        display: block;
        height: 0px;
        width: 0px;
        border: 8px solid transparent;
        border-bottom-color: #424242;
        position: absolute;
        top: -15px;
        left: 72px;
      }
      .tool_info {
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        .item {
          width: 100%;
          display: flex;
          flex-direction: row;
          align-items: center;
          font-size: 12px;
          text-align: center;
          margin-top: 24px;
          p {
            font-size: 14px;
            width: 56px;
            color: #fff;
            display: inline-block;
            margin-left: 8px;
            text-align: left;
          }
          img {
            width: 16px;
            height: 16px;
            display: inline-block;
          }
        }
        .item:nth-child(1) {
          margin-top: 0;
        }
      }
    }
    .activeTool {
      transform: scale(1);
      opacity: 1;
    }
  }
  .container {
    background: rgba(251, 251, 251, 1);
    min-height: 100vh;

    .scan {
      width: 41px;
      height: 41px;
      position: absolute;
      z-index: 99;
      right: 24px;
      top: 44px;
      background: rgba(16, 132, 74, 0.3);
      border-radius: 21px;
      display: flex;
      justify-content: center;
      align-items: center;
      .scan_img {
        width: 19px;
        height: 19px;
      }
    }
    .toolTips {
      padding: 16px;
      background-color: #424242;
      position: absolute;
      right: 12px;
      top: 94px;
      z-index: 9999;
      transition: all 0.2s ease-in-out;
      transform: scale(0);
      transform-origin: 75% -4%; /* 变换原点 */
      border-radius: 3px;
      opacity: 0;
      .triangle {
        display: block;
        height: 0px;
        width: 0px;
        border: 8px solid transparent;
        border-bottom-color: #424242;
        position: absolute;
        top: -15px;
        left: 72px;
      }
      .tool_info {
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        .item {
          width: 100%;
          display: flex;
          flex-direction: row;
          align-items: center;
          font-size: 12px;
          text-align: center;
          margin-top: 24px;
          p {
            font-size: 14px;
            width: 56px;
            color: #fff;
            display: inline-block;
            margin-left: 8px;
            text-align: left;
          }
          img {
            width: 16px;
            height: 16px;
            display: inline-block;
          }
        }
        .item:nth-child(1) {
          margin-top: 0;
        }
      }
    }
    .activeTool {
      transform: scale(1);
      opacity: 1;
    }
    .fallPointDistribution {
      width: 100%;
      overflow: hidden;
      box-sizing: border-box;

      .status {
        font-family: PingFang SC, Arial, sans-serif !important;
        -webkit-font-smoothing: antialiased !important;
        margin-left: 23px;
        font-size: 14px;
        font-weight: 700;
        color: rgba(51, 51, 51, 1);
        margin-top: 16px;
      }

      .levelDistribution {
        width: 100%;
        height: 66px;
        display: flex;
        box-sizing: border-box;
        padding-top: 16px;
        padding-bottom: 16px;
        justify-content: center;

        .districtLevel {
          flex: 1;

          height: 34px;

          .leaveName {
            font-size: 14px;
            font-weight: 400;
            color: rgba(51, 51, 51, 1);
            text-align: center;
          }

          .levelOp1 {
            color: rgba(54, 179, 116, 1);
          }

          .levelOp2 {
            color: rgba(54, 179, 116, 0.8);
          }

          .levelOp3 {
            color: rgba(54, 179, 116, 0.6);
          }

          .levelOp4 {
            color: rgba(54, 179, 116, 0.4);
          }

          .pointsNum {
            font-weight: Regular;
            font-size: 12px;
            font-weight: 600;
            color: #333333;
            text-align: center;
            margin-top: 10px;
          }
        }

        .levelPointing {
          width: 7px;
          height: 34px;
        }
      }
    }

    .select_type {
      margin-top: 16px;
      box-sizing: border-box;
      background: #ffffff;
      text-align: center;
      @vv: 3.75vw;
      .t_txt {
        width: 78 / @vv;
        height: 30 / @vv;
        display: inline-block;
        line-height: 30 / @vv;
        text-align: center;
        border: 1px solid #36b374;
        border-right: none;
        font-size: 14 / @vv;
        color: #36b374;
      }

      .t_txt:last-child {
        border: 1px solid #36b374;
        border-radius: 0px 2px 2px 0px !important;
      }
      .t_txt:first-child {
        border-radius: 2px 0px 0px 2px !important;
      }

      .t_active {
        background-color: #36b374;
        color: #fff;
        font-weight: 700;
      }
    }

    .refund-cnt {
      padding-left: 16px;
      padding-right: 16px;

      .title-wrap {
        display: flex;
        margin-top: 34px;
        margin-bottom: 14px;

        .title {
          margin-right: 8px;
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: rgba(51, 51, 51, 1);
        }

        .tit {
          font-size: 14px;
          font-family: PingFang-SC-Bold, PingFang-SC;
          font-weight: bold;
          color: rgba(51, 51, 51, 1);
        }
      }

      .refund-apply {
        display: flex;
        justify-content: space-between;
        align-items: flex-end;
        margin-bottom: 12px;
      }

      .refund-suc {
        display: flex;
        justify-content: space-between;
        align-items: flex-end;
        margin-bottom: 12px;
      }

      .refund-title {
        font-size: 14px;
        font-family: PingFang-SC-Bold, PingFang-SC;
        font-weight: bold;
        color: rgba(51, 51, 51, 1);
      }

      .details {
        margin-bottom: 16px;
        background: rgba(248, 248, 248, 1);
        border-radius: 1px;
        padding: 12px;
        align-items: center;
        display: flex;
        justify-content: space-between;

        .txt {
          font-size: 11px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: rgba(102, 102, 102, 1);
        }
      }

      .num {
        font-size: 32px;
        font-family: DIN-Bold, DIN;
        font-weight: bold;
        color: rgba(54, 179, 116, 1);
      }

      .start {
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(51, 51, 51, 1);
      }

      .line-unit {
        font-size: 10px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(153, 153, 153, 1);
      }
    }
    .line-charts {
      padding-left: 16px;
      margin-top: 20px;
      margin-bottom: 5px;
      font-size: 14px;
      font-family: PingFang-SC-Bold, PingFang-SC;
      font-weight: bold;
      color: rgba(51, 51, 51, 1);
    }

    .card-wrap {
      display: flex;
      position: relative;

      .items {
        flex: 1;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        padding-top: 23px;
        padding-bottom: 23px;

        .tit {
          margin-bottom: 8px;
          font-size: 12px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: rgba(51, 51, 51, 1);
        }

        .num {
          font-size: 32px;
          font-family: DIN-Bold, DIN;
          font-weight: bold;
          color: rgba(54, 179, 116, 1);
        }

        .price {
          margin-top: 8px;
          font-size: 12px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: rgba(102, 102, 102, 1);
          background: rgba(248, 248, 248, 1);
          padding: 8px 12px;
        }
      }
    }

    .pg-pd12 {
      padding-left: 12px;
      padding-right: 12px;
    }

    .head {
      padding-left: 20px;
      // width: 375px;
      width: 100%;
      position: relative;
      display: flex;
      align-items: flex-end;
      background: url("../../assets/index/head_bg.png");
      box-sizing: border-box;

      .tower {
        width: 129px;
        height: 91px;
        position: absolute;
        bottom: 36px;
        right: 38px;
      }

      &-user {
        margin-bottom: 64px;
        z-index: 110;
        &-name {
          font-size: 20px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: rgba(255, 255, 255, 1);
          line-height: 20px;
        }

        &-desc {
          margin-top: 8px;
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: rgba(255, 255, 255, 1);
          line-height: 14px;
        }
      }
    }

    .con-box {
      display: flex;
      align-items: center;
      position: relative;
      flex-wrap: wrap;
      margin-left: 12px;
      margin-right: 12px;
      margin-top: -40px;
      z-index: 999;
      box-sizing: border-box;
      padding-bottom: 24px;

      .items-box {
        display: flex;
        flex-direction: column;
        align-items: center;
        width: 87px;
        height: 84px;
        box-sizing: border-box;
        padding-top: 24px;

        .notice-contain {
          position: relative;
          .items-img {
            width: 40px;
            height: 40px;
            margin-bottom: 8px;
          }

          .notice-num {
            background: #ff4d4d;
            display: flex;
            align-items: center;
            justify-content: center;
            padding: 1.5px 4px 0.5px;
            border-radius: 8px;
            font-size: 8px;
            line-height: 12px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: rgba(255, 255, 255, 1);
            position: absolute;
            top: -3px;
            left: 31px;
            z-index: 10;
            border: 1px solid #ffffff;
            min-width: 16px;
          }
        }

        .items-text {
          font-size: 12px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: rgba(51, 51, 51, 1);
          line-height: 12px;
        }

        .no-power {
          color: rgba(51, 51, 51, 0.3);
        }
      }
    }
    .tab_nav {
      display: flex;
      flex-direction: row;
      align-items: center;
      padding: 0 16px;
      box-sizing: border-box;
      margin-top: 32px;
      .check {
        color: #333333;
        text-align: center;
        font-size: 20px;
        font-weight: 700;
        position: relative;
        .i_circle {
          position: absolute;
          right: -18px;
          top: -7px;
          display: inline-block;
          background: #ff4d4d;
          color: #fff;
          font-size: 11px;
          padding: 3px 3px;
          border-radius: 9px;
          width: 12px;
        }
        .i_cril {
          position: absolute;
          right: -23px;
          top: -7px;
          display: inline-block;
          background: #ff4d4d;
          color: #fff;
          font-size: 11px;
          padding: 3px 3px;
          border-radius: 9px;
        }
      }
      .boad {
        margin-left: 31px;
      }
      .active {
        color: #36b374;
      }
    }
    .data-card {
      .more {
        margin-top: 12px;
        display: flex;
        align-items: center;

        &-tit {
          font-size: 14px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: rgba(54, 179, 116, 1);
        }

        &-img {
          width: 12px;
          height: 12px;
          margin-left: 4px;
        }
      }

      .pending-list {
        background: rgba(255, 255, 255, 1);
        box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.04);
        border-radius: 3px;
        margin-top: 22px;

        &-line {
          width: 100%;
          height: 1px;
          background: #eeeeee;
        }
      }

      &-head {
        margin-top: 24px;
        display: flex;
        justify-content: space-between;
        align-items: center;

        &-tit {
          font-size: 20px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: rgba(51, 51, 51, 1);
          line-height: 20px;
        }

        &-diy {
          display: flex;
          align-items: center;
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: rgba(51, 51, 51, 1);
          line-height: 14px;

          &-img {
            width: 12px;
            height: 12px;
            margin-left: 4px;
          }
        }
      }

      &-cnt {
        .guide-card-state {
          position: relative;
          display: flex;
        }

        .flex1 {
          flex: 1;
        }

        .guide-card {
          height: 99px;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;

          .ranking {
            .num {
              font-size: 32px;
              font-family: DIN-Bold, DIN;
              font-weight: bold;
              color: rgba(54, 179, 116, 1);
              margin-right: 4px;
            }

            .unit {
              font-size: 10px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: rgba(54, 179, 116, 1);
              &.gray {
                color: #999999;
                margin-right: 8px;
              }
            }
          }

          .desc {
            margin-top: 8px;

            .diff {
              font-size: 12px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: rgba(153, 153, 153, 1);
              margin-right: 4px;
            }

            .res {
              font-size: 12px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
            }
          }
        }

        margin-top: 22px;

        .indicators {
          display: flex;
          justify-content: center;
          align-items: center;
          height: 24px;

          .indicator {
            width: 6px;
            height: 6px;
            background: rgba(240, 240, 240, 1);
            border-radius: 100%;

            transition: opacity 0.2s;

            &-active {
              background-color: #36b374;
            }

            &:not(:last-child) {
              margin-right: 4px;
            }
          }
        }

        .swipt {
          width: 351px;
          height: 274px;
        }

        .item {
          background: rgba(255, 255, 255, 1);
          box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.04);
          border-radius: 3px;

          &-head {
            display: flex;
            justify-content: space-between;
            padding: 16px;
            box-sizing: border-box;

            &-title {
              font-size: 14px;
              font-family: PingFangSC-Medium, PingFang SC;
              font-weight: 500;
              color: rgba(51, 51, 51, 1);
              line-height: 14px;
            }

            &-full {
              display: flex;
              align-items: center;
              font-size: 12px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: rgba(51, 51, 51, 1);
              line-height: 12px;

              &-img {
                width: 12px;
                height: 12px;
                margin-left: 6px;
              }
            }
          }

          &-cnt {
            position: relative;
            display: flex;
            height: 117px;
            width: 100%;

            &-score {
              flex: 1;
            }

            &-ranking {
              flex: 1;
            }

            &-m-line {
              position: absolute;
              width: 1px;
              height: 100%;
              background: #eeeeee;
              left: 50%;
              transform: translateX(-50%);
            }

            &-t-line {
              position: absolute;
              width: 100%;
              height: 1px;
              background: #eeeeee;
              left: 0;
              top: 0;
            }

            &-b-line {
              position: absolute;
              width: 100%;
              height: 1px;
              background: #eeeeee;
              left: 0;
              bottom: 0;
            }
          }

          &-unresponsive {
            padding: 16px;
            box-sizing: border-box;
            height: 66px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            position: relative;

            &-b-line {
              position: absolute;
              width: 100%;
              height: 1px;
              background: #eeeeee;
              left: 0;
              bottom: 0;
            }

            &-desc {
              display: flex;
              flex-direction: column;
              justify-content: space-between;

              &-tit {
                font-size: 14px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: rgba(51, 51, 51, 1);
                line-height: 14px;
              }

              &-addr {
                margin-top: 8px;
                font-size: 12px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: rgba(153, 153, 153, 1);
                line-height: 12px;
              }
            }

            &-deduction {
              font-size: 12px;
              font-family: PingFang-SC-Bold, PingFang-SC;
              font-weight: bold;
              color: rgba(255, 77, 77, 1);
              line-height: 12px;
            }
          }

          .footer {
            height: 43px;
            display: flex;
            align-items: center;
            justify-content: center;

            &-tit {
              font-size: 12px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: rgba(102, 102, 102, 1);
              line-height: 12px;
            }

            &-img {
              width: 12px;
              height: 12px;
            }
          }

          // .content-box {
          //   background: rgba(255, 255, 255, 1);
          //   border-radius: 3px;
          //   display: flex;
          //   flex-wrap: wrap;

          //   .items-box {
          //     width: 33%;
          //     padding-top: 16px;
          //     display: flex;
          //     flex-direction: column;
          //     align-items: center;
          //     overflow: hidden;
          //     height: 68px;

          //     .name-box {
          //       display: flex;
          //       align-items: center;

          //       .names {
          //         font-size: 12px;
          //         font-weight: 400;
          //         color: rgba(51, 51, 51, 1);
          //         margin-right: 4px;
          //       }

          //       .right-icon {
          //         display: block;
          //         width: 12px;
          //         height: auto;
          //         margin-top: 1px;
          //       }
          //     }

          //     .numbers {
          //       font-size: 24px;
          //       font-family: DIN-Bold, DIN;
          //       font-weight: bold;
          //       color: rgba(54, 179, 116, 1);
          //       margin-top: 8px;
          //     }
          //   }

          //   .one-item {
          //     width: 100%;
          //     height: 95px;
          //     .numbers {
          //       font-size: 32px;
          //     }
          //   }
          // }

          // .qipao {
          //   width: 319px;
          //   height: 131px;
          //   position: relative;
          //   margin: 10px auto;
          //   background: #f7f7f7;

          //   &::before {
          //     content: "";
          //     width: 0;
          //     height: 0;
          //     border: 10px solid;
          //     position: absolute;
          //     top: -20px;
          //     right: 36px;
          //     border-color: transparent transparent #f7f7f7;
          //   }

          //   .score-box {
          //     padding: 21px 12px 25px;

          //     .s-item {
          //       display: flex;
          //       align-items: center;
          //       height: 18px;
          //       margin-bottom: 16px;

          //       .i-title {
          //         width: 26%;
          //         font-size: 12px;
          //         font-family: PingFangSC-Regular, PingFang SC;
          //         font-weight: 400;
          //         color: rgba(51, 51, 51, 1);
          //       }

          //       .i-num {
          //         width: 22%;
          //         font-size: 18px;
          //         font-family: DIN-Bold, DIN;
          //         font-weight: bold;
          //         color: rgba(51, 51, 51, 1);
          //         line-height: 18px;
          //         display: flex;
          //         justify-content: flex-end;
          //         align-items: flex-end;
          //         margin-right: 2px;
          //         .n-unit-num{
          //           padding-bottom:1px;
          //           margin-right: 2px;
          //         }
          //         .n-unit {
          //           font-family: PingFangSC-Regular, PingFang SC;
          //           font-size: 10px;
          //           font-weight: 400;
          //           color: rgba(153, 153, 153, 1);
          //         }
          //       }

          //       .i-text {
          //         width: 30%;
          //         height: 12px;
          //         font-size: 12px;
          //         font-family: PingFangSC-Regular, PingFang SC;
          //         font-weight: 400;
          //         color: #999999;
          //         line-height: 12px;
          //         text-align: right;
          //       }

          //       .rank-box {
          //         width: 22%;
          //         font-size: 12px;
          //         font-family: PingFangSC-Regular, PingFang SC;
          //         text-align: right;

          //         &.no-change {
          //           color: #2283e6;
          //         }

          //         &.up {
          //           color: #36b374;
          //         }

          //         &.down {
          //           color: #ff4d4d;
          //         }
          //       }
          //     }
          //   }
          // }
          .container_shop {
            width: 100%;
            padding-bottom: 10px;
            background-color: #fff;
            .shop_title {
              display: flex;
              flex-direction: column;
              align-items: center;
              padding: 24px 0;
              box-sizing: border-box;
              .title {
                display: flex;
                flex-direction: row;
                align-items: center;
                p {
                  font-size: 12px;
                  color: #333;
                }
                img {
                  width: 12px;
                  height: 12px;
                }
              }
              .shop_total {
                font-size: 32px;
                color: #36b374;
                font-weight: 700;
                margin-top: 8px;
              }
            }
            .shop_type {
              width: 100%;
              display: flex;
              flex-direction: row;
              padding: 15px 0;
              box-sizing: border-box;
              .shop_item {
                width: 50%;
                display: flex;
                flex-direction: column;
                align-items: center;
                .shop_left {
                  display: flex;
                  flex-direction: row;
                  align-items: center;
                  p {
                    font-size: 12px;
                    color: #333;
                  }
                  img {
                    width: 12px;
                    height: 12px;
                  }
                }
                .item_total {
                  font-size: 24px;
                  color: #36b374;
                  margin-top: 8px;
                  font-weight: 700;
                }
              }
            }
            .item_list {
              display: flex;
              flex-direction: row;
              align-items: center;
              justify-content: space-between;
              padding: 16px;
              box-sizing: border-box;
              .c_total {
                width: 150px;
                .tip3 {
                  font-size: 12px;
                  color: #333333;
                }
                .p_total {
                  margin-top: 8px;
                  font-size: 0;
                  span {
                    display: inline-block;
                  }
                  span:nth-child(1) {
                    font-size: 18px;
                    color: #333;
                    font-weight: 700;
                  }
                  span:nth-child(2) {
                    font-size: 12px;
                    color: #999;
                    margin-left: 2px;
                  }
                }
              }

              .tip1 {
                color: #999;
                font-size: 12px;
              }
              .complin {
                display: flex;
                flex-direction: row;
                align-items: center;
                justify-content: space-between;
                width: 50px;
                .tip2 {
                  color: #999;
                  font-size: 12px;
                }
                .iconSize {
                  width: 8px;
                  height: 12px;
                  margin-left: 9px;
                }
              }

              .arrow_right {
                width: 12px;
                height: 12px;
              }
            }
          }
          .container_shop {
            width: 100%;
            padding-bottom: 10px;
            background-color: #fff;
            .shop_title {
              display: flex;
              flex-direction: column;
              align-items: center;
              padding: 24px 0;
              box-sizing: border-box;
              .title {
                display: flex;
                flex-direction: row;
                align-items: center;
                p {
                  font-size: 12px;
                  color: #333;
                }
                img {
                  width: 12px;
                  height: 12px;
                }
              }
              .shop_total {
                font-size: 32px;
                color: #36b374;
                font-weight: 700;
                margin-top: 8px;
              }
            }
            .shop_type {
              width: 100%;
              display: flex;
              flex-direction: row;
              padding: 15px 0;
              box-sizing: border-box;
              .shop_item {
                width: 50%;
                display: flex;
                flex-direction: column;
                align-items: center;
                .shop_left {
                  display: flex;
                  flex-direction: row;
                  align-items: center;
                  p {
                    font-size: 12px;
                    color: #333;
                  }
                  img {
                    width: 12px;
                    height: 12px;
                  }
                }
                .item_total {
                  font-size: 24px;
                  color: #36b374;
                  margin-top: 8px;
                  font-weight: 700;
                }
              }
            }
            .item_list {
              display: flex;
              flex-direction: row;
              align-items: center;
              justify-content: space-between;
              padding: 16px;
              box-sizing: border-box;
              .c_total {
                width: 150px;
                .tip3 {
                  font-size: 12px;
                  color: #333333;
                }
                .p_total {
                  margin-top: 8px;
                  font-size: 0;
                  span {
                    display: inline-block;
                  }
                  span:nth-child(1) {
                    font-size: 18px;
                    color: #333;
                    font-weight: 700;
                  }
                  span:nth-child(2) {
                    font-size: 12px;
                    color: #999;
                    margin-left: 2px;
                  }
                }
              }

              .tip1 {
                color: #999;
                font-size: 12px;
              }
              .complin {
                display: flex;
                flex-direction: row;
                align-items: center;
                justify-content: space-between;
                width: 50px;
                .tip2 {
                  color: #999;
                  font-size: 12px;
                }
                .iconSize {
                  width: 8px;
                  height: 12px;
                  margin-left: 9px;
                }
              }

              .arrow_right {
                width: 12px;
                height: 12px;
              }
            }
          }
          .spread {
            margin-top: 16px;

            .s-title {
              font-size: 14px;
              font-family: PingFang SC, Arial, sans-serif;
              -webkit-font-smoothing: antialiased;
              font-weight: 700;
              color: rgba(51, 51, 51, 1);
              padding-left: 15px;
            }

            .s-cont {
              padding: 32px 16px;
            }
          }
        }

        .message {
          min-height: 33px;
          padding: 16px;
          display: flex;
          align-items: center;
          justify-content: space-between;

          .m-left {
            width: 290px;

            .l-title {
              font-size: 14px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: rgba(51, 51, 51, 1);
              line-height: 18px;
              margin-bottom: 8px;
            }

            .l-addr {
              font-size: 12px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: rgba(153, 153, 153, 1);
              line-height: 12px;
            }
          }

          .m-right {
            text-align: right;
            font-size: 12px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: rgba(255, 77, 77, 1);
          }
        }

        .power {
          width: 100%;

          .warning {
            .w-title {
              font-family: PingFang SC, Arial, sans-serif;
              -webkit-font-smoothing: antialiased;
              font-size: 14px;
              font-weight: 700;
              margin: 15px 0 0 16px;
            }

            .w-swiper {
              width: 351px;
              min-height: 120px;
              font-family: PingFangSC-Medium, PingFang SC;

              .item {
                min-height: 104px;
                padding: 16px 0 16px 0;
                flex: 1;
                display: flex;
                flex-direction: column;
                justify-content: space-between;
                align-items: center;
                box-shadow: none;

                .i-title {
                  font-size: 16px;
                  font-family: PingFang SC, Arial, sans-serif;
                  -webkit-font-smoothing: antialiased;
                  font-weight: 700;
                  color: rgba(54, 179, 116, 1);
                  line-height: 16px;
                }

                .i-cont {
                  font-size: 14px;
                  font-weight: 300;
                  color: rgba(51, 51, 51, 1);
                  line-height: 14px;
                  padding: 0 16px;
                  width: 100%;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  white-space: nowrap;
                  text-align: center;
                }

                .i-time {
                  font-size: 12px;
                  font-weight: 300;
                  color: rgba(153, 153, 153, 1);
                  line-height: 12px;
                }
              }
            }
            .complain-w-swiper {
              &::v-deep .item {
                justify-content: space-around;
              }

              &::v-deep .van-swipe__indicators {
                bottom: 16px;
              }
              &::v-deep .van-swipe__indicator {
                background-color: #e9e9e9 !important;
              }
              &::v-deep .van-swipe__indicator--active {
                background-color: #bbbbbb !important;
              }
            }

            .w-cont {
              padding: 20px 0 16px 0;
              display: flex;
              width: 100%;

              .c-item {
                flex: 1;
                width: 33%;
                display: flex;
                flex-direction: column;
                justify-content: space-between;
                align-items: center;

                .i-title {
                  font-family: PingFangSC-Regular, PingFang SC;
                  font-size: 12px;
                  color: rgba(51, 51, 51, 1);
                  margin-bottom: 8px;
                }

                .i-num {
                  font-size: 32px;
                  font-family: DIN-Bold, DIN;
                  font-weight: bold;

                  &.d-color {
                    color: rgba(17, 139, 245, 1);
                  }

                  &.w-color {
                    color: #f75c32;
                  }

                  &.t-color {
                    color: #ffa509;
                  }
                }
              }
            }
          }
        }
      }
    }
    .waitCheck {
      .state_nav {
        margin-top: 10px;
      }
      .content_list {
        width: 100%;
        .tab_item {
          width: 100%;
          background-color: #fff;
          margin-top: 12px;
          border-radius: 3px;
          .item_list {
            width: 100%;
            box-sizing: border-box;
            .item_title {
              display: flex;
              flex-direction: row;
              align-items: center;
              justify-content: space-between;
              padding: 15px 16px;
              .left_box {
              }
              .left {
                display: flex;
                flex-direction: row;
                align-items: center;
                .tip1 {
                  font-size: 14px;
                  line-height: 18px;
                  color: #333;
                  font-weight: 700;
                }
                .left_tip {
                  color: #fff;
                  font-size: 10px;
                  font-weight: 400;
                  width: 36px;
                  height: 18px;
                  line-height: 18px;
                  text-align: center;
                  margin-left: 8px;
                  border-radius: 13px;
                  span {
                    display: inline-block;
                    transform: scale(0.8);
                  }
                }

                .tip2 {
                  width: 36px;
                  height: 18px;
                  color: #fff;
                  background-color: #118bf5;
                  border-radius: 9px;
                  text-align: center;
                  line-height: 18px;
                  margin-left: 8px;
                  i {
                    font-size: 12px;
                    display: inline-block;
                    transform: scale(0.8);
                    color: #fff;
                  }
                }
                .series {
                  background-color: #ff4d17;
                }
                .bad {
                  background-color: #ffa509;
                }
              }
              .right_box {
                display: flex;
                justify-content: space-between;
                align-items: center;
                .left_time {
                  font-size: 12px;
                  font-weight: 400;
                  color: #ff8c19;
                  text-align: right;
                }
              }
              .right {
                display: flex;
                flex-direction: row;
                align-items: center;
                .tip3 {
                  font-size: 12px;
                  line-height: 18px;
                  color: #ff4d4d;
                }
                .tip4 {
                  font-size: 12px;
                  line-height: 18px;
                  color: #fff;
                  padding: 8px;
                  background-color: #36b374;
                  border-radius: 2px;
                  margin-left: 8px;
                }
              }
            }
            .item_bottom {
              width: 100%;
              padding: 15px 16px;
              box-sizing: border-box;
              .item_bottom_tag {
                display: flex;
                justify-content: left;
                margin-top: 8px;
                margin-left: -6px;
                .item_bottom_tag_city {
                  line-height: 18px;
                  font-size: 12px;
                  height: 18px;
                  // margin-left: 4px;
                  -webkit-transform: scale(0.84);
                  padding: 0 3px 2px 3px;
                  text-align: center;
                  color: #2283e6;
                  // margin-right: 8px;
                }
                .item_bottom_tag_guide {
                  line-height: 18px;
                  font-size: 12px;
                  height: 18px;
                  margin-left: 4px;
                  -webkit-transform: scale(0.84);
                  padding: 0 3px 2px 3px;
                  text-align: center;
                  color: #36b374;
                }
                // .item_bottom_tag_city{
                //   color: #2283E6;
                //   margin-right: 8px;
                //   .item_bottom_tag_city>div {
                //     max-width: 108px;
                //     overflow: hidden;
                //     text-overflow: ellipsis;
                //     white-space: nowrap;
                //     height: 14px;
                //     font-size: 10px;
                //     line-height: 14px;
                //     text-align: center;
                //     -webkit-transform: scale(0.84);
                //     padding: 0 4px 0 4px;
                //   }
                // }
                // .item_bottom_tag_guide{
                //   color: #36B374;
                //   .item_bottom_tag_guide>div{
                //     height: 14px;
                //     font-size: 10px;
                //     line-height: 14px;
                //     text-align: center;
                //     padding: 0 4px 0 4px;
                //     -webkit-transform: scale(0.84);
                //   }
                // }
              }
              .b_title {
                font-size: 12px;
                color: #333;
                font-weight: 700;
                padding-bottom: 12px;
              }
              .bottom_list {
                width: 100%;
                display: flex;
                flex-direction: row;
                align-items: center;
                .tip5 {
                  width: 60px;
                  font-size: 12px;
                  line-height: 18px;
                  color: #666;
                }
                .otherWidth {
                  width: 108px !important;
                }
                .otherWidth1 {
                  width: 128px !important;
                }
                .textWidth {
                  width: 70% !important;
                }
                .tip6 {
                  width: 76%;
                  overflow: hidden;
                  white-space: nowrap;
                  font-size: 12px;
                  line-height: 18px;
                  color: #666;
                  text-overflow: ellipsis;
                }
                .tip7 {
                  span {
                    padding: 2px 4px;
                    border: 1px solid #36b374;
                    color: #36b374;
                    font-size: 12px;
                    margin-left: 4px;
                    line-height: 18px;
                  }
                }
              }
              .other {
                margin-top: 8px;
              }
              .person_info {
                width: 100%;
                padding: 8px;
                box-sizing: border-box;
                background-color: #f9f9f9;
                display: flex;
                flex-direction: row;
                align-items: center;
                margin-top: 12px;
                p {
                  font-size: 12px;
                  line-height: 18px;
                  color: #999999;
                  white-space: nowrap;
                  overflow: hidden;
                  text-overflow: ellipsis;
                }
                p:nth-child(1) {
                  width: 176px;
                }
                p:nth-child(2) {
                  margin-left: 16px;
                }
              }
            }
          }
        }
        .no_task {
          width: 100%;
          padding: 32px 0;
          display: flex;
          flex-direction: column;
          align-items: center;
          background-color: #fff;
          justify-content: center;
          border-radius: 3px;
          img {
            width: 74px;
            height: 62px;
          }
          p {
            font-size: 14px;
            color: #999;
            margin-top: 24px;
          }
        }
      }
    }
    .box {
      width: 100%;
      border-radius: 4px;
      font-size: 0;
      background: #ffffff;

      .left {
        width: 50%;
        height: 100px;
        display: inline-block;
        text-align: center;
      }
    }
    .complain-example-box {
      position: relative;
      .score-card {
        height: 100px !important;
        &::v-deep .cnt {
          margin-bottom: 0 !important;
        }
      }
    }
  }

  .item-head-line {
    width: 100%;
    height: 1px;
    background: #eeeeee;
  }

  .ranking-wrap {
    padding-left: 16px;
    padding-bottom: 18px;
  }

  .map-contain {
    height: 250px;
    position: relative;
    .v-loading {
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
    }
  }

  .line-contain {
    height: 200px;
  }

  .addcolor {
    color: rgba(54, 179, 116, 1);
  }
  .descrecolor {
    color: rgba(255, 77, 77, 1);
  }
  .columnar-box {
    overflow: auto;
  }
  .leader-bg0 {
    background: #fff !important;
  }
  .leader-pd0 {
    padding-left: 0 !important;
    padding-right: 0 !important;
  }
  .none::before {
    display: none;
  }

  .data-card-head {
    .showmore-contain {
    }
  }

  .data-card-head-first {
    margin-top: 36px !important;
  }
  .data-card-head-tit {
    font-size: 16px !important;
    font-weight: 700 !important;
    font-family: PingFang SC, Arial, sans-serif !important;
    -webkit-font-smoothing: antialiased !important;
  }
  .data-card-head-tit-big {
    font-size: 20px !important;
    font-weight: 700 !important;
  }
  .item-head {
    padding: 0 16px !important;
    height: 45px;
  }
  .item-head-title {
    font-family: PingFang SC, Arial, sans-serif !important;
    -webkit-font-smoothing: antialiased !important;
    font-weight: 700 !important;
    line-height: 48px !important;
  }
  .vline {
    transform: none !important;
    background: none !important;
    top: 0 !important;
    bottom: 0 !important;
    .borders-1px:after {
      position: absolute;
      content: "";
      top: -50%;
      bottom: -50%;
      left: -50%;
      right: -50%;
      -webkit-transform: scale(0.5);
      transform: scale(0.5);
      border-right: 1px solid #eeeeee;
    }
  }
  .kaohe-ranking-wrap {
    .data-card-tab {
      margin-top: 16px !important;
    }
  }
}
</style>
